/*
        This is a generated type file made by our GraphQL code generator
        This file will change as you update your backend schema or any queries and mutations you have in your service

        Please commit and check in changes to these files

        If you have a merge conflicts:
        - Pull in the changes
        - Fix conflicts with the main codebase
        - Rerun the codegen
      */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  GeoJSONCoordinates: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export enum AddressPerformanceMode {
  FallbackToLandregAll = 'FALLBACK_TO_LANDREG_ALL',
  FallbackToLandregFreeholdOnly = 'FALLBACK_TO_LANDREG_FREEHOLD_ONLY',
  NoLandreg = 'NO_LANDREG'
}

export type Account = {
  __typename?: 'Account';
  _id?: Maybe<Scalars['String']['output']>;
  _organisation?: Maybe<Organisation>;
  _users?: Maybe<Array<Maybe<User>>>;
  billing_address?: Maybe<Array<Scalars['String']['output']>>;
  cancel_at_period_end?: Maybe<Scalars['Boolean']['output']>;
  current_period_end?: Maybe<Scalars['Date']['output']>;
  downgrade_plan_period_end?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Flags>;
  included_letter_send?: Maybe<IncludedLetterSendCredit>;
  land_reg_credit_pounds?: Maybe<Scalars['Float']['output']>;
  licences?: Maybe<Scalars['Int']['output']>;
  manual_billing?: Maybe<Scalars['Boolean']['output']>;
  mastermap_tiles?: Maybe<MastermapCredit>;
  monthly_billing_invite_code?: Maybe<Scalars['String']['output']>;
  monthly_billing_invite_date?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  name_team?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  ownership_views?: Maybe<OwnershipCredit>;
  planning_views: PlanningViewBalance;
  product?: Maybe<Scalars['String']['output']>;
  sales_rep?: Maybe<Scalars['String']['output']>;
  skip_traces?: Maybe<SkipTracesCredit>;
  stripe_customer_id?: Maybe<Scalars['String']['output']>;
  subscription_id?: Maybe<Scalars['String']['output']>;
  subscription_status?: Maybe<Scalars['String']['output']>;
  trial_expiration?: Maybe<Scalars['Date']['output']>;
};

export type AccountInput = {
  _id: Scalars['ID']['input'];
  merge_into_team?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  line3?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
};

export type AddressBaseRecord = {
  __typename?: 'AddressBaseRecord';
  address?: Maybe<Scalars['String']['output']>;
  administrative_area?: Maybe<Scalars['String']['output']>;
  building_name?: Maybe<Scalars['String']['output']>;
  building_number?: Maybe<Scalars['String']['output']>;
  company_name?: Maybe<Scalars['String']['output']>;
  full_address?: Maybe<Scalars['String']['output']>;
  la_organisation?: Maybe<Scalars['String']['output']>;
  location: GeoJsonGeometry;
  pao_end_number?: Maybe<Scalars['String']['output']>;
  pao_end_suffix?: Maybe<Scalars['String']['output']>;
  pao_start_number?: Maybe<Scalars['String']['output']>;
  pao_start_suffix?: Maybe<Scalars['String']['output']>;
  pao_text?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_class_code?: Maybe<Scalars['String']['output']>;
  property_class_description?: Maybe<Scalars['String']['output']>;
  property_class_primary_code?: Maybe<Scalars['String']['output']>;
  property_class_secondary_code?: Maybe<Scalars['String']['output']>;
  property_class_tertiary_code?: Maybe<Scalars['String']['output']>;
  rm_organisation_name?: Maybe<Scalars['String']['output']>;
  sao_end_number?: Maybe<Scalars['String']['output']>;
  sao_end_suffix?: Maybe<Scalars['String']['output']>;
  sao_start_number?: Maybe<Scalars['String']['output']>;
  sao_start_suffix?: Maybe<Scalars['String']['output']>;
  sao_text?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street_description?: Maybe<Scalars['String']['output']>;
  town_name?: Maybe<Scalars['String']['output']>;
  uprn: Scalars['ID']['output'];
  use_class?: Maybe<Scalars['String']['output']>;
  use_class_description?: Maybe<Scalars['String']['output']>;
  use_class_description_2020?: Maybe<Scalars['String']['output']>;
  use_class_sep_2020?: Maybe<Scalars['String']['output']>;
  voa_record?: Maybe<VoaRating>;
};


export type AddressBaseRecordAddressArgs = {
  line_split?: InputMaybe<Scalars['String']['input']>;
};

export type AllText = {
  __typename?: 'AllText';
  all_text?: Maybe<Scalars['String']['output']>;
};

export type AllTextInput = {
  all_text?: InputMaybe<Scalars['String']['input']>;
};

export type Annotation = {
  _id: Scalars['ID']['output'];
  geometry: GeoJsonGeometry;
  kind: AnnotationKind;
};

export enum AnnotationKind {
  Radius = 'RADIUS'
}

export type AnnotationRadius = Annotation & {
  __typename?: 'AnnotationRadius';
  _id: Scalars['ID']['output'];
  geometry: GeoJsonGeometry;
  kind: AnnotationKind;
  radius: Scalars['Float']['output'];
};

export type AnnotationRadiusInput = {
  geometry: GeoJsonGeometryInput;
  radius: Scalars['Float']['input'];
};

export type AnnotationRadiusUpdateInput = {
  _id: Scalars['ID']['input'];
  geometry?: InputMaybe<GeoJsonGeometryInput>;
  radius?: InputMaybe<Scalars['Float']['input']>;
};

export type ArchivedItem = {
  __typename?: 'ArchivedItem';
  _id: Scalars['ID']['output'];
  typename: Scalars['String']['output'];
};

export type ArchivedPlanningItem = {
  __typename?: 'ArchivedPlanningItem';
  _id: Scalars['ID']['output'];
  _site?: Maybe<Scalars['ID']['output']>;
  typename: Scalars['String']['output'];
};

export type BoundaryImage = {
  __typename?: 'BoundaryImage';
  id: Scalars['ID']['output'];
  uri: Scalars['String']['output'];
};

export type BoundingBoxGeoFilter = {
  __typename?: 'BoundingBoxGeoFilter';
  bottom_right: CoordinatePair;
  top_left: CoordinatePair;
};

export type BoundingBoxGeoFilterInput = {
  bottom_right: CoordinatePairInput;
  top_left: CoordinatePairInput;
};

export type BuildingHeight = {
  __typename?: 'BuildingHeight';
  abs_h_max?: Maybe<Scalars['Float']['output']>;
  abs_h_min?: Maybe<Scalars['Float']['output']>;
  abs_h_to_roof?: Maybe<Scalars['Float']['output']>;
  address?: Maybe<AddressBaseRecord>;
  no_floors_estimate?: Maybe<Scalars['Int']['output']>;
  rel_h_max?: Maybe<Scalars['Float']['output']>;
  rel_h_to_roof?: Maybe<Scalars['Float']['output']>;
  uprn?: Maybe<Scalars['ID']['output']>;
};

export enum CompanyTreeMode {
  ChainDownToCompanyNo = 'CHAIN_DOWN_TO_COMPANY_NO',
  ChainUpToCompanyNo = 'CHAIN_UP_TO_COMPANY_NO',
  DirectChildrenCompanies = 'DIRECT_CHILDREN_COMPANIES',
  DirectParentCompanies = 'DIRECT_PARENT_COMPANIES',
  DirectParentOthers = 'DIRECT_PARENT_OTHERS',
  RelevantOwner = 'RELEVANT_OWNER',
  UltimateOwnerCompany = 'ULTIMATE_OWNER_COMPANY'
}

export enum CreateSiteResponseStatus {
  Created = 'CREATED',
  Skipped = 'SKIPPED'
}

export type CachedSettingsSetting = {
  __typename?: 'CachedSettingsSetting';
  expirationTime?: Maybe<Scalars['Int']['output']>;
};

export type CachedSettingsSettingInput = {
  expirationTime?: InputMaybe<Scalars['Int']['input']>;
};

export type ChecklistItem = {
  __typename?: 'ChecklistItem';
  is_checked: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
};

export type Collaborator = {
  __typename?: 'Collaborator';
  _id?: Maybe<Scalars['ID']['output']>;
  email: Scalars['String']['output'];
  firstname?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type Company = {
  __typename?: 'Company';
  addresses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  appraiser_link?: Maybe<Scalars['String']['output']>;
  company_no?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  is_foreign?: Maybe<Scalars['Boolean']['output']>;
  land_holdings?: Maybe<CompanyLandHoldings>;
  name?: Maybe<Scalars['String']['output']>;
  proprietorship?: Maybe<Scalars['String']['output']>;
  tree?: Maybe<Array<CompanyOwnership>>;
};


export type CompanyTreeArgs = {
  mode?: InputMaybe<CompanyTreeMode>;
  to_company_no?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyLandHoldingStats = {
  __typename?: 'CompanyLandHoldingStats';
  area_owned: Scalars['Float']['output'];
  freehold_area_owned: Scalars['Float']['output'];
  freeholds_owned: Scalars['Int']['output'];
  leasehold_area_owned: Scalars['Float']['output'];
  leaseholds_owned: Scalars['Int']['output'];
  titles_owned: Scalars['Int']['output'];
};

export type CompanyLandHoldings = {
  __typename?: 'CompanyLandHoldings';
  direct: CompanyLandHoldingStats;
  tree: CompanyLandHoldingStats;
};

export type CompanyOwnership = {
  __typename?: 'CompanyOwnership';
  child_company: Company;
  holding_max?: Maybe<Scalars['Int']['output']>;
  parent_company?: Maybe<Company>;
  parent_person?: Maybe<Person>;
};

export type Comparable = {
  __typename?: 'Comparable';
  _id: Scalars['ID']['output'];
  address?: Maybe<Scalars['String']['output']>;
  appn_postcode?: Maybe<Scalars['String']['output']>;
  date_of_transfer?: Maybe<Scalars['Date']['output']>;
  deed_date?: Maybe<Scalars['Date']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  est_bedrooms?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  est_price?: Maybe<Scalars['Float']['output']>;
  estate_type?: Maybe<Scalars['String']['output']>;
  location?: Maybe<GeoJsonGeometry>;
  new_build?: Maybe<Scalars['String']['output']>;
  num_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_habitable_rooms?: Maybe<Scalars['Int']['output']>;
  old_new?: Maybe<Scalars['String']['output']>;
  paon?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  ppd_category?: Maybe<Scalars['String']['output']>;
  prev_transactions?: Maybe<Array<Maybe<Comparable>>>;
  price?: Maybe<Scalars['Int']['output']>;
  price_paid?: Maybe<Scalars['Float']['output']>;
  price_per_square_metre?: Maybe<Scalars['Float']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  saon?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  tenure?: Maybe<Scalars['String']['output']>;
  total_floor_area?: Maybe<Scalars['Float']['output']>;
  town?: Maybe<Scalars['String']['output']>;
  transaction_id: Scalars['ID']['output'];
  transaction_type?: Maybe<Scalars['String']['output']>;
  ukhpi_factor?: Maybe<Scalars['Float']['output']>;
  ukhpi_index_from?: Maybe<Scalars['Float']['output']>;
  ukhpi_index_to?: Maybe<Scalars['Float']['output']>;
};

export type ComparableTransactionIdentityInput = {
  transaction_id: Scalars['String']['input'];
};

export type ComparableV2 = {
  __typename?: 'ComparableV2';
  _id: Scalars['ID']['output'];
  address?: Maybe<Scalars['String']['output']>;
  category: PropertyCategoryEnum;
  country?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  date_of_transfer?: Maybe<Scalars['Date']['output']>;
  designation: PropertyDesignationEnum;
  distance_from_center?: Maybe<Scalars['Float']['output']>;
  est_bedrooms?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  est_price?: Maybe<Scalars['Float']['output']>;
  est_price_per_square_metre?: Maybe<Scalars['Float']['output']>;
  geometry?: Maybe<GeoJsonGeometry>;
  is_new_property?: Maybe<Scalars['Boolean']['output']>;
  num_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_habitable_rooms?: Maybe<Scalars['Int']['output']>;
  owner_type?: Maybe<PropertyOwnerTypeEnum>;
  post_code?: Maybe<Scalars['String']['output']>;
  prev_transactions?: Maybe<Array<Comparable>>;
  price?: Maybe<Scalars['Int']['output']>;
  price_paid?: Maybe<Scalars['Int']['output']>;
  price_per_square_metre?: Maybe<Scalars['Float']['output']>;
  property_id: Scalars['String']['output'];
  region?: Maybe<Scalars['String']['output']>;
  sub_category: PropertySubCategoryEnum;
  tenure?: Maybe<Tenure>;
  total_floor_area?: Maybe<Scalars['Float']['output']>;
  town?: Maybe<Scalars['String']['output']>;
  transaction_id: Scalars['ID']['output'];
  uprn?: Maybe<Scalars['String']['output']>;
};

export type CompositeTerms = {
  __typename?: 'CompositeTerms';
  and?: Maybe<Array<Maybe<CompositeTerms>>>;
  field?: Maybe<Scalars['String']['output']>;
  matchType?: Maybe<Scalars['String']['output']>;
  or?: Maybe<Array<Maybe<CompositeTerms>>>;
  search_group_details?: Maybe<SearchGroupDetails>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CompositeTermsInput = {
  and?: InputMaybe<Array<InputMaybe<CompositeTermsInput>>>;
  field?: InputMaybe<Scalars['String']['input']>;
  matchType?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<CompositeTermsInput>>>;
  search_group_details?: InputMaybe<SearchGroupDetailsInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CoordinatePair = {
  __typename?: 'CoordinatePair';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type CoordinatePairInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type CouncilConfigurationInput = {
  _scraper?: InputMaybe<Scalars['ID']['input']>;
  additional_parameters?: InputMaybe<Scalars['JSON']['input']>;
  auto_scrape?: InputMaybe<Scalars['Boolean']['input']>;
  count_scrape_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  crawlera_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  crawlera_session_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  daily_scraping_duration?: InputMaybe<Scalars['Int']['input']>;
  date_format?: InputMaybe<Scalars['String']['input']>;
  documents_crawlera_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  documents_crawlera_session_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  gss_code: Scalars['ID']['input'];
  live?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  poor_month_rescrape_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  scraping_priority?: InputMaybe<Scalars['Int']['input']>;
  search_url?: InputMaybe<Scalars['String']['input']>;
  site_ref?: InputMaybe<Scalars['String']['input']>;
  stats_date_field?: InputMaybe<Scalars['String']['input']>;
  test_job_type?: InputMaybe<Scalars['String']['input']>;
  use_daily_search_range?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CouncilInput = {
  gss_code: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CountResultsJobsInput = {
  date_from: Scalars['String']['input'];
  date_to: Scalars['String']['input'];
  gss_codes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CountResultsPerSearch = {
  __typename?: 'CountResultsPerSearch';
  result_count?: Maybe<Scalars['Int']['output']>;
  search_values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CountResultsScore = {
  __typename?: 'CountResultsScore';
  results_number?: Maybe<Scalars['Int']['output']>;
  results_per_search?: Maybe<Array<Maybe<CountResultsPerSearch>>>;
  results_refs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CreateSiteInput = {
  assignees?: InputMaybe<Array<Scalars['ID']['input']>>;
  geometry: GeoJsonGeometryInput;
  id?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<SiteCreationSource>;
  tidbit?: InputMaybe<SiteCreationTidbit>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_no?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSiteStageInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
};

export type DailyJobInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  gss_code: Scalars['String']['input'];
};

export type DailyJobsInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  gss_codes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DataQualitySetting = {
  __typename?: 'DataQualitySetting';
  expect_decision_after_days?: Maybe<Scalars['Int']['output']>;
};

export type DataQualitySettingInput = {
  expect_decision_after_days?: InputMaybe<Scalars['Int']['input']>;
};

export type DateRange = {
  __typename?: 'DateRange';
  from?: Maybe<Scalars['Date']['output']>;
  to?: Maybe<Scalars['Date']['output']>;
};

export type DateRangeInput = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export enum DevelopmentType {
  Commercial = 'COMMERCIAL',
  Industrial = 'INDUSTRIAL',
  MixedUse = 'MIXED_USE',
  Other = 'OTHER',
  Power = 'POWER',
  Residential = 'RESIDENTIAL',
  Retirement = 'RETIREMENT',
  StudentHousing = 'STUDENT_HOUSING'
}

export type Dimensions = {
  __typename?: 'Dimensions';
  /** @deprecated Returns area in ft² whereas other units are generally return in m² - use area_building_metric instead */
  area_building?: Maybe<Scalars['Float']['output']>;
  area_building_metric?: Maybe<Scalars['Float']['output']>;
  area_floor_total_metric?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Returns area in ft² whereas other units are generally return in m² - use area_gross_metric instead */
  area_gross?: Maybe<Scalars['Float']['output']>;
  area_gross_metric?: Maybe<Scalars['Float']['output']>;
  area_lot_metric?: Maybe<Scalars['Float']['output']>;
  coverage?: Maybe<Scalars['Float']['output']>;
  floor_area_ratio?: Maybe<Scalars['Float']['output']>;
};

export type DocumentStats = {
  __typename?: 'DocumentStats';
  document_scraping_attempts?: Maybe<Scalars['Int']['output']>;
  failed_documents_count?: Maybe<Scalars['Int']['output']>;
  has_document_stats?: Maybe<Scalars['Boolean']['output']>;
  succeeded_documents_count?: Maybe<Scalars['Int']['output']>;
  succeeded_documents_percent?: Maybe<Scalars['Int']['output']>;
};

export type EsResult = {
  __typename?: 'ESResult';
  _id: Scalars['ID']['output'];
  _index: Scalars['String']['output'];
  _score: Scalars['Float']['output'];
  _type: Scalars['String']['output'];
  highlight?: Maybe<Array<Maybe<HighlightedField>>>;
  raw_highlight?: Maybe<Array<Maybe<RawHighlightedField>>>;
};

export type EpcData = {
  __typename?: 'EpcData';
  appraisal_date?: Maybe<Scalars['Date']['output']>;
  built_form?: Maybe<Scalars['String']['output']>;
  construction_age_band?: Maybe<Scalars['String']['output']>;
  current_energy_efficiency?: Maybe<Scalars['Int']['output']>;
  current_energy_rating?: Maybe<Scalars['String']['output']>;
  number_habitable_rooms?: Maybe<Scalars['Int']['output']>;
  potential_energy_efficiency?: Maybe<Scalars['Int']['output']>;
  potential_energy_rating?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  roof_type?: Maybe<Scalars['String']['output']>;
  tenure?: Maybe<Scalars['String']['output']>;
  total_floor_area?: Maybe<Scalars['Float']['output']>;
};

export type EsGeoDistanceSort = {
  distance_type?: InputMaybe<Scalars['String']['input']>;
  location: Array<Scalars['Float']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  unit: Scalars['String']['input'];
};

export type EsSort = {
  fieldName: Scalars['String']['input'];
  sortType?: InputMaybe<EsSortType>;
};

export type EsSortType = {
  _geo_distance?: InputMaybe<EsGeoDistanceSort>;
  missing?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

export type Filters = {
  assignee?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  authority?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  site?: InputMaybe<Scalars['String']['input']>;
};

export type Flags = {
  __typename?: 'Flags';
  allow_ua_sharing?: Maybe<Scalars['Boolean']['output']>;
  annual?: Maybe<Scalars['Boolean']['output']>;
  auto_downgrade_after_trial?: Maybe<Scalars['Boolean']['output']>;
  external_api_access?: Maybe<Scalars['Boolean']['output']>;
  force_planning_alerts?: Maybe<Scalars['Boolean']['output']>;
  government_ownership?: Maybe<Scalars['Boolean']['output']>;
  housing_supply?: Maybe<Scalars['Boolean']['output']>;
  is_trialing?: Maybe<Scalars['Boolean']['output']>;
  land_enhance?: Maybe<Scalars['Boolean']['output']>;
  land_enhance_documents?: Maybe<Scalars['Boolean']['output']>;
  online_direct_sales?: Maybe<Scalars['Boolean']['output']>;
  os_maps_chargable_key?: Maybe<Scalars['Boolean']['output']>;
  ownership_csv_export?: Maybe<Scalars['Boolean']['output']>;
  ownership_unlimited?: Maybe<Scalars['Boolean']['output']>;
  planning_policy_layer?: Maybe<Scalars['Boolean']['output']>;
  property_search_access?: Maybe<Scalars['Boolean']['output']>;
};

export type FlagsInput = {
  allow_ua_sharing?: InputMaybe<Scalars['Boolean']['input']>;
  annual?: InputMaybe<Scalars['Boolean']['input']>;
  auto_downgrade_after_trial?: InputMaybe<Scalars['Boolean']['input']>;
  external_api_access?: InputMaybe<Scalars['Boolean']['input']>;
  force_planning_alerts?: InputMaybe<Scalars['Boolean']['input']>;
  government_ownership?: InputMaybe<Scalars['Boolean']['input']>;
  housing_supply?: InputMaybe<Scalars['Boolean']['input']>;
  is_trialing?: InputMaybe<Scalars['Boolean']['input']>;
  land_enhance?: InputMaybe<Scalars['Boolean']['input']>;
  land_enhance_documents?: InputMaybe<Scalars['Boolean']['input']>;
  online_direct_sales?: InputMaybe<Scalars['Boolean']['input']>;
  os_maps_chargable_key?: InputMaybe<Scalars['Boolean']['input']>;
  ownership_csv_export?: InputMaybe<Scalars['Boolean']['input']>;
  ownership_unlimited?: InputMaybe<Scalars['Boolean']['input']>;
  planning_policy_layer?: InputMaybe<Scalars['Boolean']['input']>;
  property_search_access?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FloatRange = {
  __typename?: 'FloatRange';
  from?: Maybe<Scalars['Float']['output']>;
  to?: Maybe<Scalars['Float']['output']>;
};

export type FloatRangeInput = {
  from?: InputMaybe<Scalars['Float']['input']>;
  to?: InputMaybe<Scalars['Float']['input']>;
};

export type GeoFilter = BoundingBoxGeoFilter | PolygonGeoFilter | RadiusGeoFilter;

export type GeoJsonGeometry = {
  __typename?: 'GeoJSONGeometry';
  coordinates: Scalars['GeoJSONCoordinates']['output'];
  type: Scalars['String']['output'];
};

export type GeoJsonGeometryInput = {
  coordinates: Scalars['GeoJSONCoordinates']['input'];
  type: Scalars['String']['input'];
};

export type Geocode = IGeocode & {
  __typename?: 'Geocode';
  geocode_accuracy?: Maybe<Scalars['String']['output']>;
  geocode_date?: Maybe<Scalars['Date']['output']>;
  geocode_method?: Maybe<Scalars['String']['output']>;
  location?: Maybe<GeoJsonGeometry>;
};

export type GeocodingSetting = {
  __typename?: 'GeocodingSetting';
  gss_codes_using_the_same_planning_portal?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  ignore_boundaries_stats_for_gss_codes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GeocodingSettingInput = {
  gss_codes_using_the_same_planning_portal?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  ignore_boundaries_stats_for_gss_codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type HighlightFragment = {
  __typename?: 'HighlightFragment';
  closingTag: Scalars['String']['output'];
  highlightedText: Scalars['String']['output'];
  length: Scalars['Int']['output'];
  openingTag: Scalars['String']['output'];
  postText: Scalars['String']['output'];
  preText: Scalars['String']['output'];
  startIndex: Scalars['Int']['output'];
};

export type HighlightInput = {
  post_tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pre_tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type HighlightedField = {
  __typename?: 'HighlightedField';
  fieldName: Scalars['String']['output'];
  values: Array<Maybe<HighlightedValues>>;
};

export type HighlightedValues = {
  __typename?: 'HighlightedValues';
  highlightFragments: Array<HighlightFragment>;
  highlightedValue: Scalars['String']['output'];
  unhighlightedValue: Scalars['String']['output'];
};

export type HistoricMothlyJobsInput = {
  gss_codes?: InputMaybe<Array<Scalars['String']['input']>>;
  persist_documents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IGeocode = {
  geocode_accuracy?: Maybe<Scalars['String']['output']>;
  geocode_date?: Maybe<Scalars['Date']['output']>;
  geocode_method?: Maybe<Scalars['String']['output']>;
  location?: Maybe<GeoJsonGeometry>;
};

export type IPlanningBase = {
  address?: Maybe<Scalars['String']['output']>;
  agent_address?: Maybe<Scalars['String']['output']>;
  agent_name?: Maybe<Scalars['String']['output']>;
  agent_tel?: Maybe<Scalars['String']['output']>;
  applicant_name?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Date']['output']>;
  date_received?: Maybe<Scalars['Date']['output']>;
  date_valid?: Maybe<Scalars['Date']['output']>;
  decision?: Maybe<Scalars['String']['output']>;
  decision_date?: Maybe<Scalars['Date']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  extract_date?: Maybe<Scalars['Date']['output']>;
  extract_url?: Maybe<Scalars['String']['output']>;
  gss_code: Scalars['String']['output'];
  house_name_no?: Maybe<Scalars['String']['output']>;
  import_job_id?: Maybe<Scalars['String']['output']>;
  local_id?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['Date']['output']>;
  other?: Maybe<Scalars['JSON']['output']>;
  parish?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  ref: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  target_date?: Maybe<Scalars['Date']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  town?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uprn?: Maybe<Scalars['String']['output']>;
  village?: Maybe<Scalars['String']['output']>;
  ward?: Maybe<Scalars['String']['output']>;
};

export type IncludedLetterSendCredit = {
  __typename?: 'IncludedLetterSendCredit';
  cap?: Maybe<Scalars['Int']['output']>;
  next_reset_date?: Maybe<Scalars['Date']['output']>;
  used?: Maybe<Scalars['Int']['output']>;
};

export type IntRange = {
  __typename?: 'IntRange';
  from?: Maybe<Scalars['Int']['output']>;
  to?: Maybe<Scalars['Int']['output']>;
};

export type IntRangeInput = {
  from?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Int']['input']>;
};

export type InvalidPlanning = IPlanningBase & {
  __typename?: 'InvalidPlanning';
  address?: Maybe<Scalars['String']['output']>;
  agent_address?: Maybe<Scalars['String']['output']>;
  agent_name?: Maybe<Scalars['String']['output']>;
  agent_tel?: Maybe<Scalars['String']['output']>;
  applicant_name?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Date']['output']>;
  date_received?: Maybe<Scalars['Date']['output']>;
  date_valid?: Maybe<Scalars['Date']['output']>;
  decision?: Maybe<Scalars['String']['output']>;
  decision_date?: Maybe<Scalars['Date']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  extract_date?: Maybe<Scalars['Date']['output']>;
  extract_url?: Maybe<Scalars['String']['output']>;
  gss_code: Scalars['String']['output'];
  house_name_no?: Maybe<Scalars['String']['output']>;
  import_job_id?: Maybe<Scalars['String']['output']>;
  local_id?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['Date']['output']>;
  other?: Maybe<Scalars['JSON']['output']>;
  parish?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  ref: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  target_date?: Maybe<Scalars['Date']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  town?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uprn?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  validationErrors?: Maybe<Array<Maybe<PlanningValidationError>>>;
  village?: Maybe<Scalars['String']['output']>;
  ward?: Maybe<Scalars['String']['output']>;
};

export enum JobType {
  CountResults = 'countResults',
  Daily = 'daily',
  Monthly = 'monthly',
  Update = 'update'
}

export type KeyPerson = {
  __typename?: 'KeyPerson';
  _id: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  person_name: Scalars['String']['output'];
  person_position?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type LandRegCredentialsInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type LastStateTime = {
  __typename?: 'LastStateTime';
  state_key?: Maybe<Scalars['String']['output']>;
  transition_time?: Maybe<Scalars['Date']['output']>;
};

export type Licence = {
  __typename?: 'Licence';
  feature_set: Scalars['String']['output'];
};

export type LicenceInput = {
  feature_set: Scalars['String']['input'];
  justificationId?: InputMaybe<Scalars['ID']['input']>;
};

export type LocalAuthority = {
  __typename?: 'LocalAuthority';
  gss_code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LogPlanningAppViewResponse = {
  __typename?: 'LogPlanningAppViewResponse';
  planningApp?: Maybe<Planning>;
  planning_views: PlanningViewBalance;
};

export type MastermapCredit = {
  __typename?: 'MastermapCredit';
  cap?: Maybe<Scalars['Int']['output']>;
  next_reset_date?: Maybe<Scalars['Date']['output']>;
  used?: Maybe<Scalars['Int']['output']>;
};

export type MatchPhraseAllText = {
  __typename?: 'MatchPhraseAllText';
  match_phrase?: Maybe<AllText>;
};

export type MatchPhraseInput = {
  match_phrase?: InputMaybe<AllTextInput>;
};

export type McSearchCreateSiteInput = {
  geometry_id: Scalars['ID']['input'];
};

export type MongoRecordWithIdIdentityInput = {
  _id: Scalars['ID']['input'];
};

export type MonthlyJobInput = {
  date: Scalars['String']['input'];
  gss_code: Scalars['String']['input'];
  persist_documents?: InputMaybe<Scalars['Boolean']['input']>;
  test_job?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MonthlyJobsInput = {
  date_from: Scalars['String']['input'];
  date_to: Scalars['String']['input'];
  gss_codes?: InputMaybe<Array<Scalars['String']['input']>>;
  persist_documents?: InputMaybe<Scalars['Boolean']['input']>;
  test_job?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MoveStageInput = {
  stageId: Scalars['ID']['input'];
  targetProjectId: Scalars['ID']['input'];
};

export type MustNotInput = {
  must_not?: InputMaybe<Array<InputMaybe<MatchPhraseInput>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addLabel?: Maybe<SiteUpdateResponse>;
  addSiteComment: UpdateSiteTidbitResponse;
  addVerification: PlanningAuthorityVerification;
  adminUpdateUser?: Maybe<UserResponse>;
  archiveLabel: SiteLabelArchiveResponse;
  archiveSite: SiteArchiveResponse;
  archiveSiteStage?: Maybe<Array<Maybe<ArchivedItem>>>;
  archiveSites: SiteArchiveResponse;
  createAnnotation?: Maybe<Annotation>;
  createLabel?: Maybe<SiteLabel>;
  createPlanningAlertSubscription: PlanningAlertSubscription;
  createSiteStage?: Maybe<SiteStage>;
  createSites?: Maybe<Array<Maybe<SiteSaving>>>;
  createSitesFromMcSearch?: Maybe<Array<Maybe<SiteSaving>>>;
  deleteAnnotation?: Maybe<Annotation>;
  deletePlanningAlertSubscription: ArchivedPlanningItem;
  deleteSiteAttachment?: Maybe<SiteTidbitArchiveResponse>;
  deleteSiteTidbit: SiteTidbitArchiveResponse;
  deleteUserAddress: Scalars['ID']['output'];
  insertUserAddress: UserAddress;
  logPlanningAppView: LogPlanningAppViewResponse;
  logPlanningRoyalties: Scalars['Boolean']['output'];
  markAsFixed?: Maybe<ScrapingIssue>;
  moveAllSitesToStage: Array<SiteUpdateResponse>;
  moveStage?: Maybe<SiteStage>;
  newScraper: Scraper;
  processFinishedJobs?: Maybe<Array<ShStat>>;
  purchaseTitleDocuments: Array<Maybe<Transaction>>;
  registerSiteAttachmentUpload: UpsertSiteTidbitResponse;
  removeLabel?: Maybe<SiteUpdateResponse>;
  rescrapeAffectedPlanningApps?: Maybe<Array<ShStat>>;
  rescrapePlanningRefSet?: Maybe<Array<ShStat>>;
  scheduleCountResultsJobs?: Maybe<Array<ShStat>>;
  scheduleDailyJob: ShStat;
  scheduleDailyJobs?: Maybe<Array<ShStat>>;
  scheduleHistoricMonthlyJobs?: Maybe<Array<ShStat>>;
  scheduleMonthlyJob: ShStat;
  scheduleMonthlyJobs?: Maybe<Array<ShStat>>;
  scheduleUpdateJobs?: Maybe<Array<ShStat>>;
  scheduleUpdateMissingRefsJobs?: Maybe<Array<ShStat>>;
  scheduleUpdateUndecidedRefsJobs?: Maybe<Array<ShStat>>;
  setBillingAddress?: Maybe<Account>;
  setSettings: Setting;
  topupBalance?: Maybe<StripePaymentIntent>;
  updateAllSitesInStage?: Maybe<Array<SiteUpdateResponse>>;
  updateAnnotation?: Maybe<Annotation>;
  updateCouncilConfiguration: PlanningAuthority;
  updateExtractUrlIssues?: Maybe<Array<Maybe<PlanningDataIssue>>>;
  updateLabel?: Maybe<SiteLabel>;
  updatePlanningAlertSubscription: PlanningAlertSubscription;
  updateScraper: Scraper;
  updateSelectedSites?: Maybe<Array<Maybe<SiteUpdateResponse>>>;
  updateSettings: Setting;
  updateSiteStage?: Maybe<SiteStage>;
  updateSiteStages?: Maybe<Array<Maybe<SiteStage>>>;
  updateSiteTidbit: UpdateSiteTidbitResponse;
  updateSiteTidbitComment: UpdateSiteTidbitResponse;
  updateSites: Array<SiteUpdateResponse>;
  updateTask?: Maybe<PlanningCron>;
  updateUserAddress: UserAddress;
  updateVerification: PlanningAuthority;
  upsertComparableTransactionSiteTidbit: UpsertSiteTidbitResponse;
  upsertOSMapPrintSiteTidbit: UpsertSiteTidbitResponse;
  upsertOwnershipSiteTidbit: UpsertSiteTidbitResponse;
  upsertPlanningSiteTidbit: UpsertSiteTidbitResponse;
  upsertPricepaidSiteTidbit: UpsertSiteTidbitResponse;
  upsertTitleDocumentSiteTidbit: UpsertSiteTidbitResponse;
};


export type MutationAddLabelArgs = {
  labelId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationAddSiteCommentArgs = {
  comment_body: Scalars['String']['input'];
  site: Scalars['ID']['input'];
};


export type MutationAddVerificationArgs = {
  input: PlanningAuthorityVerificationUserInput;
};


export type MutationAdminUpdateUserArgs = {
  _id: Scalars['ID']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};


export type MutationArchiveLabelArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationArchiveSiteArgs = {
  _id: Scalars['String']['input'];
};


export type MutationArchiveSiteStageArgs = {
  _id: Scalars['String']['input'];
  archiveSites?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationArchiveSitesArgs = {
  _stage?: InputMaybe<Scalars['String']['input']>;
  assignees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  filters?: InputMaybe<Filters>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<SiteSearchInput>;
  selection?: InputMaybe<SelectionInput>;
  siteLabels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  siteName?: InputMaybe<Scalars['String']['input']>;
  siteSort?: InputMaybe<SiteSorting>;
};


export type MutationCreateAnnotationArgs = {
  radius: AnnotationRadiusInput;
};


export type MutationCreateLabelArgs = {
  labelCreation: SiteLabelCreation;
  siteId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreatePlanningAlertSubscriptionArgs = {
  name: Scalars['String']['input'];
  search: PlanningSearchInput;
  site_id?: InputMaybe<Scalars['String']['input']>;
  subscribed: Scalars['Boolean']['input'];
};


export type MutationCreateSiteStageArgs = {
  stageCreation: SiteStageCreation;
  startPosition?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateSitesArgs = {
  sites?: InputMaybe<Array<CreateSiteInput>>;
  stage?: InputMaybe<CreateSiteStageInput>;
  stageId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateSitesFromMcSearchArgs = {
  sites?: InputMaybe<Array<McSearchCreateSiteInput>>;
  stageId: Scalars['ID']['input'];
};


export type MutationDeleteAnnotationArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeletePlanningAlertSubscriptionArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteSiteAttachmentArgs = {
  tidbit_id: Scalars['String']['input'];
};


export type MutationDeleteSiteTidbitArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDeleteUserAddressArgs = {
  address_id: Scalars['ID']['input'];
};


export type MutationInsertUserAddressArgs = {
  address: UserAddressInput;
  as_default?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationLogPlanningAppViewArgs = {
  planningAppView: PlanningInput;
};


export type MutationLogPlanningRoyaltiesArgs = {
  planningAppView: PlanningInput;
};


export type MutationMarkAsFixedArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMoveAllSitesToStageArgs = {
  _stageFrom: Scalars['String']['input'];
  _stageTo: Scalars['String']['input'];
  assignees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  filters?: InputMaybe<Filters>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  siteLabels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  siteName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMoveStageArgs = {
  input: MoveStageInput;
};


export type MutationNewScraperArgs = {
  input: ScraperInput;
};


export type MutationProcessFinishedJobsArgs = {
  input: ProcessFinishedJobsInput;
};


export type MutationPurchaseTitleDocumentsArgs = {
  address: UserAddressInput;
  doc_type: TransactionPurchaseType;
  landRegCredentials?: InputMaybe<LandRegCredentialsInput>;
  title_nos: Array<Scalars['String']['input']>;
};


export type MutationRegisterSiteAttachmentUploadArgs = {
  attachment_title?: InputMaybe<Scalars['String']['input']>;
  file_name: Scalars['String']['input'];
  site_id: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveLabelArgs = {
  labelId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationRescrapeAffectedPlanningAppsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRescrapePlanningRefSetArgs = {
  dataIssueId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationScheduleCountResultsJobsArgs = {
  input: CountResultsJobsInput;
};


export type MutationScheduleDailyJobArgs = {
  input: DailyJobInput;
};


export type MutationScheduleDailyJobsArgs = {
  input: DailyJobsInput;
};


export type MutationScheduleHistoricMonthlyJobsArgs = {
  input: HistoricMothlyJobsInput;
};


export type MutationScheduleMonthlyJobArgs = {
  input: MonthlyJobInput;
};


export type MutationScheduleMonthlyJobsArgs = {
  input: MonthlyJobsInput;
};


export type MutationScheduleUpdateJobsArgs = {
  input: UpdateJobsInput;
};


export type MutationScheduleUpdateMissingRefsJobsArgs = {
  input: UpdateJobsInput;
};


export type MutationScheduleUpdateUndecidedRefsJobsArgs = {
  input: UpdateJobsInput;
};


export type MutationSetBillingAddressArgs = {
  address?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationSetSettingsArgs = {
  input: SettingInput;
};


export type MutationTopupBalanceArgs = {
  pence?: InputMaybe<Scalars['Int']['input']>;
  stripeCharge: StripeCharge;
};


export type MutationUpdateAllSitesInStageArgs = {
  filters?: InputMaybe<Filters>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  stageId: Scalars['String']['input'];
  updateData: SiteUpdate;
};


export type MutationUpdateAnnotationArgs = {
  radius: AnnotationRadiusUpdateInput;
};


export type MutationUpdateCouncilConfigurationArgs = {
  input: CouncilConfigurationInput;
};


export type MutationUpdateExtractUrlIssuesArgs = {
  gss_codes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateLabelArgs = {
  _id: Scalars['ID']['input'];
  labelUpdate: SiteLabelUpdate;
};


export type MutationUpdatePlanningAlertSubscriptionArgs = {
  _id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<PlanningSearchInput>;
  subscribed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateScraperArgs = {
  input: ScraperInput;
};


export type MutationUpdateSelectedSitesArgs = {
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<SiteSearchInput>;
  selection?: InputMaybe<SelectionInput>;
  siteLabels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  siteSort?: InputMaybe<SiteSorting>;
  updateData?: InputMaybe<SiteUpdate>;
};


export type MutationUpdateSettingsArgs = {
  input: SettingInput;
};


export type MutationUpdateSiteStageArgs = {
  updateData: SiteStageUpdate;
};


export type MutationUpdateSiteStagesArgs = {
  updateData: Array<SiteStageUpdate>;
};


export type MutationUpdateSiteTidbitArgs = {
  updateData: SiteTidbitUpdate;
};


export type MutationUpdateSiteTidbitCommentArgs = {
  updateData: SiteTidbitCommentUpdate;
};


export type MutationUpdateSitesArgs = {
  updateData: Array<SiteUpdate>;
};


export type MutationUpdateTaskArgs = {
  input: PlanningCronInput;
};


export type MutationUpdateUserAddressArgs = {
  address?: InputMaybe<UserAddressInput>;
  address_id: Scalars['ID']['input'];
  as_default?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateVerificationArgs = {
  input: PlanningAuthorityVerificationInput;
};


export type MutationUpsertComparableTransactionSiteTidbitArgs = {
  upsertData: SiteTidbitComparableTransactionCreation;
};


export type MutationUpsertOsMapPrintSiteTidbitArgs = {
  upsertData: SiteTidbitOsMapPrintCreation;
};


export type MutationUpsertOwnershipSiteTidbitArgs = {
  upsertData: SiteTidbitOwnershipRecordCreation;
};


export type MutationUpsertPlanningSiteTidbitArgs = {
  upsertData: SiteTidbitPlanningRecordCreation;
};


export type MutationUpsertPricepaidSiteTidbitArgs = {
  upsertData: SiteTidbitPricepaidRecordCreation;
};


export type MutationUpsertTitleDocumentSiteTidbitArgs = {
  upsertData: SiteTidbitTitleDocumentCreation;
};

export type OsMapPrint = {
  __typename?: 'OSMapPrint';
  _id: Scalars['ID']['output'];
  center?: Maybe<GeoJsonGeometry>;
  created: Scalars['Date']['output'];
  orientation: Scalars['String']['output'];
  page_size: Scalars['String']['output'];
  scale: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Organisation = {
  __typename?: 'Organisation';
  _id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type OwnershipCredit = {
  __typename?: 'OwnershipCredit';
  cap?: Maybe<Scalars['Int']['output']>;
  next_reset_date?: Maybe<Scalars['Date']['output']>;
  used?: Maybe<Scalars['Int']['output']>;
};

export type OwnershipSearch = {
  __typename?: 'OwnershipSearch';
  _id?: Maybe<Scalars['ID']['output']>;
  composite_terms?: Maybe<CompositeTerms>;
  created?: Maybe<Scalars['Date']['output']>;
  geo_filter?: Maybe<GeoFilter>;
  lease_end_date_range?: Maybe<DateRange>;
  lease_start_date_range?: Maybe<DateRange>;
  modified?: Maybe<Scalars['Date']['output']>;
  parcel_size_range?: Maybe<IntRange>;
  proprietorship_added_date_range?: Maybe<DateRange>;
  search_in_subsidiaries?: Maybe<Scalars['Boolean']['output']>;
  search_name?: Maybe<Scalars['String']['output']>;
};

export type OwnershipSearchInput = {
  bounding_box_geo_filter?: InputMaybe<BoundingBoxGeoFilterInput>;
  composite_terms?: InputMaybe<CompositeTermsInput>;
  include_unknown_owners?: InputMaybe<Scalars['Boolean']['input']>;
  lease_end_date_range?: InputMaybe<DateRangeInput>;
  lease_start_date_range?: InputMaybe<DateRangeInput>;
  parcel_size_range?: InputMaybe<IntRangeInput>;
  poly_geo_filter?: InputMaybe<PolygonGeoFilterInput>;
  proprietorship_added_date_range?: InputMaybe<DateRangeInput>;
  radius_geo_filter?: InputMaybe<RadiusGeoFilterInput>;
  search_in_subsidiaries?: InputMaybe<Scalars['Boolean']['input']>;
  search_name?: InputMaybe<Scalars['String']['input']>;
};

export type OwnershipSearchResult = {
  __typename?: 'OwnershipSearchResult';
  es_result?: Maybe<EsResult>;
  result_id?: Maybe<Scalars['ID']['output']>;
  result_item?: Maybe<TitleOwnership>;
};

export type OwnershipSearchResultConnection = {
  __typename?: 'OwnershipSearchResultConnection';
  edges: Array<OwnershipSearchResultConnectionEdge>;
  nodes: Array<OwnershipSearchResult>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Int']['output'];
};

export type OwnershipSearchResultConnectionEdge = {
  __typename?: 'OwnershipSearchResultConnectionEdge';
  _id: Scalars['String']['output'];
  cursor: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  node: OwnershipSearchResult;
  previousCursor?: Maybe<Scalars['String']['output']>;
};

export type OwnershipSearchSuggest = {
  __typename?: 'OwnershipSearchSuggest';
  group: Scalars['String']['output'];
  label: Scalars['String']['output'];
  or_set?: Maybe<Scalars['String']['output']>;
  searches: OwnershipSearchSuggestInner;
};

export type OwnershipSearchSuggestInner = {
  __typename?: 'OwnershipSearchSuggestInner';
  company_name?: Maybe<Array<Scalars['String']['output']>>;
  company_reg_number?: Maybe<Array<Scalars['String']['output']>>;
  government_department?: Maybe<Array<Scalars['String']['output']>>;
  title_no?: Maybe<Array<Scalars['String']['output']>>;
};

export type OwnershipView = {
  __typename?: 'OwnershipView';
  created?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginatedOwnershipViews = {
  __typename?: 'PaginatedOwnershipViews';
  nodes: Array<Maybe<OwnershipView>>;
  pagination: PaginationType;
};

export type PaginatedTrasactions = {
  __typename?: 'PaginatedTrasactions';
  nodes: Array<Maybe<Transaction>>;
  pagination: PaginationType;
};

export type PaginationType = {
  __typename?: 'PaginationType';
  currentPage: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ParcelSearchByParcelId = {
  __typename?: 'ParcelSearchByParcelId';
  parcel_identifier: Scalars['String']['output'];
  title_no: Scalars['String']['output'];
};

export type Person = {
  __typename?: 'Person';
  address?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  is_foreign?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Planning = IGeocode & IPlanningBase & {
  __typename?: 'Planning';
  _id: Scalars['ID']['output'];
  address?: Maybe<Scalars['String']['output']>;
  agent_address?: Maybe<Scalars['String']['output']>;
  agent_name?: Maybe<Scalars['String']['output']>;
  agent_tel?: Maybe<Scalars['String']['output']>;
  appeal?: Maybe<PlanningAppeal>;
  appeal_appellant?: Maybe<Scalars['String']['output']>;
  appeal_application_ref?: Maybe<Scalars['String']['output']>;
  appeal_case_number?: Maybe<Scalars['String']['output']>;
  appeal_decision?: Maybe<Scalars['String']['output']>;
  appeal_decision_date?: Maybe<Scalars['Date']['output']>;
  appeal_development_type?: Maybe<Scalars['String']['output']>;
  appeal_inspector_name?: Maybe<Scalars['String']['output']>;
  appeal_planning_authority_name?: Maybe<Scalars['String']['output']>;
  appeal_received_date?: Maybe<Scalars['Date']['output']>;
  appeal_site_address?: Maybe<Scalars['String']['output']>;
  appeal_type_of_appeal?: Maybe<Scalars['String']['output']>;
  appeal_type_reason?: Maybe<Scalars['String']['output']>;
  appeal_updated_at?: Maybe<Scalars['Date']['output']>;
  applicant_name?: Maybe<Scalars['String']['output']>;
  authority?: Maybe<PlanningAuthority>;
  boundary?: Maybe<Scalars['String']['output']>;
  building_types_mentioned?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  change_of_use?: Maybe<Scalars['Boolean']['output']>;
  classification?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Date']['output']>;
  date_received?: Maybe<Scalars['Date']['output']>;
  date_valid?: Maybe<Scalars['Date']['output']>;
  decision?: Maybe<Scalars['String']['output']>;
  decision_date?: Maybe<Scalars['Date']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  document_stats?: Maybe<DocumentStats>;
  extract_date?: Maybe<Scalars['Date']['output']>;
  extract_url?: Maybe<Scalars['String']['output']>;
  geocode_accuracy?: Maybe<Scalars['String']['output']>;
  geocode_date?: Maybe<Scalars['Date']['output']>;
  geocode_failed_attempt?: Maybe<Array<Maybe<Scalars['Date']['output']>>>;
  geocode_match?: Maybe<Scalars['Int']['output']>;
  geocode_method?: Maybe<Scalars['String']['output']>;
  google_geocode?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  gss_code: Scalars['String']['output'];
  house_name_no?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  import_job_id?: Maybe<Scalars['String']['output']>;
  importance?: Maybe<Scalars['Int']['output']>;
  in_test_set?: Maybe<Scalars['Boolean']['output']>;
  is_minor?: Maybe<Scalars['Boolean']['output']>;
  labels: Array<Maybe<PlanningLabel>>;
  lastViewedAt?: Maybe<Scalars['Date']['output']>;
  local_id?: Maybe<Scalars['String']['output']>;
  location?: Maybe<GeoJsonGeometry>;
  location_within_authority_boundaries?: Maybe<Scalars['Boolean']['output']>;
  mentioned_by_refs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mentions_refs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  modified?: Maybe<Scalars['Date']['output']>;
  num_dwellings?: Maybe<Scalars['Int']['output']>;
  num_dwellings_regex?: Maybe<Scalars['Int']['output']>;
  old_geocodes?: Maybe<Array<Maybe<Geocode>>>;
  other?: Maybe<Scalars['JSON']['output']>;
  parish?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  previous_values?: Maybe<Planning>;
  ref: Scalars['String']['output'];
  ref_dashes?: Maybe<Scalars['String']['output']>;
  ref_nopunct?: Maybe<Scalars['String']['output']>;
  references?: Maybe<Array<Maybe<PlanningReference>>>;
  reprocess?: Maybe<Scalars['Boolean']['output']>;
  scraper_message_hash?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  special_word_count?: Maybe<Scalars['Int']['output']>;
  special_words?: Maybe<Array<Maybe<PlanningSpecialWord>>>;
  status?: Maybe<Scalars['String']['output']>;
  status_derived?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  target_date?: Maybe<Scalars['Date']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  title_derived_confidence?: Maybe<Scalars['Int']['output']>;
  title_parsed?: Maybe<Scalars['String']['output']>;
  town?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  types_derived?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  uprn?: Maybe<Scalars['String']['output']>;
  use_classes_created?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  use_classes_mentioned?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  use_classes_modified?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  use_classes_removed?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  village?: Maybe<Scalars['String']['output']>;
  ward?: Maybe<Scalars['String']['output']>;
};

export type PlanningAlertResult = {
  __typename?: 'PlanningAlertResult';
  _id: Scalars['ID']['output'];
  alert_date: Scalars['Date']['output'];
  alert_info?: Maybe<Array<Scalars['String']['output']>>;
  result_item: Planning;
};

export type PlanningAlertResultConnection = {
  __typename?: 'PlanningAlertResultConnection';
  edges: Array<PlanningAlertResultConnectionEdge>;
  nodes: Array<PlanningAlertResult>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Int']['output'];
};

export type PlanningAlertResultConnectionEdge = {
  __typename?: 'PlanningAlertResultConnectionEdge';
  _id: Scalars['String']['output'];
  cursor: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  node: PlanningAlertResult;
  previousCursor?: Maybe<Scalars['String']['output']>;
};

export type PlanningAlertSubscription = {
  __typename?: 'PlanningAlertSubscription';
  _id: Scalars['ID']['output'];
  _site?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Date']['output']>;
  modified?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  results_count: Scalars['Int']['output'];
  search?: Maybe<PlanningSearch>;
  subscribed?: Maybe<Scalars['Boolean']['output']>;
};


export type PlanningAlertSubscriptionResultsCountArgs = {
  emailed_at?: InputMaybe<Scalars['String']['input']>;
};

export type PlanningAlertSubscriptionConnection = {
  __typename?: 'PlanningAlertSubscriptionConnection';
  edges: Array<PlanningAlertSubscriptionConnectionEdge>;
  nodes: Array<PlanningAlertSubscription>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Int']['output'];
};

export type PlanningAlertSubscriptionConnectionEdge = {
  __typename?: 'PlanningAlertSubscriptionConnectionEdge';
  _id: Scalars['String']['output'];
  cursor: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  node: PlanningAlertSubscription;
  previousCursor?: Maybe<Scalars['String']['output']>;
};

export type PlanningAppeal = {
  __typename?: 'PlanningAppeal';
  _id?: Maybe<Scalars['ID']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  appeal_reason?: Maybe<Scalars['String']['output']>;
  appeal_type?: Maybe<Scalars['String']['output']>;
  appeal_type_reason?: Maybe<Scalars['String']['output']>;
  application_type_detail?: Maybe<Scalars['String']['output']>;
  being_redetermined?: Maybe<Scalars['Boolean']['output']>;
  bespoke_timetable?: Maybe<Scalars['Boolean']['output']>;
  call_in_date?: Maybe<Scalars['Date']['output']>;
  costs_applied_for?: Maybe<Scalars['Boolean']['output']>;
  date_not_recovered?: Maybe<Scalars['Date']['output']>;
  date_received?: Maybe<Scalars['Date']['output']>;
  date_recovered?: Maybe<Scalars['Date']['output']>;
  date_valid?: Maybe<Scalars['Date']['output']>;
  decision?: Maybe<Scalars['String']['output']>;
  decision_date?: Maybe<Scalars['Date']['output']>;
  development_or_allegation?: Maybe<Scalars['String']['output']>;
  development_type?: Maybe<Scalars['String']['output']>;
  enforcement_grounds?: Maybe<Scalars['String']['output']>;
  enforcement_grounds_count?: Maybe<Scalars['Int']['output']>;
  gss_code: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  inspector_name?: Maybe<Scalars['String']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  link_status?: Maybe<Scalars['String']['output']>;
  planning_application?: Maybe<Planning>;
  procedure?: Maybe<Scalars['String']['output']>;
  ref: Scalars['String']['output'];
  start_date?: Maybe<Scalars['Date']['output']>;
};

export enum PlanningApplicationCategory {
  Commercial = 'commercial',
  Leisure = 'leisure',
  Residential = 'residential',
  Retail = 'retail'
}

export enum PlanningApplicationDecision {
  Approved = 'approved',
  Pending = 'pending',
  Rejected = 'rejected',
  Unknown = 'unknown'
}

export enum PlanningApplicationType {
  Full = 'full'
}

export enum PlanningApplicationUseClass {
  A1 = 'A1',
  A2 = 'A2',
  A3 = 'A3',
  A4 = 'A4',
  A5 = 'A5',
  B1 = 'B1',
  B1a = 'B1a',
  B1b = 'B1b',
  B1c = 'B1c',
  B2 = 'B2',
  B8 = 'B8',
  C1 = 'C1',
  C2 = 'C2',
  C3 = 'C3',
  C4 = 'C4',
  D1 = 'D1',
  D2 = 'D2',
  Sg = 'SG'
}

export type PlanningArchivedItem = {
  __typename?: 'PlanningArchivedItem';
  _id: Scalars['ID']['output'];
  typename: Scalars['String']['output'];
};

export type PlanningAuthority = {
  __typename?: 'PlanningAuthority';
  _id: Scalars['ID']['output'];
  _scraper?: Maybe<Scraper>;
  additional_parameters?: Maybe<Scalars['JSON']['output']>;
  allow_document_scraping?: Maybe<Scalars['Boolean']['output']>;
  assignee?: Maybe<Scalars['String']['output']>;
  auto_scrape?: Maybe<Scalars['Boolean']['output']>;
  badMonths?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  count_scrape_enabled?: Maybe<Scalars['Boolean']['output']>;
  country: Scalars['String']['output'];
  crawlera_enabled?: Maybe<Scalars['Boolean']['output']>;
  crawlera_session_enabled?: Maybe<Scalars['Boolean']['output']>;
  daily_scraping_duration?: Maybe<Scalars['Int']['output']>;
  data_status?: Maybe<Scalars['String']['output']>;
  data_verifications?: Maybe<Array<Maybe<PlanningAuthorityVerification>>>;
  date_format?: Maybe<Scalars['String']['output']>;
  documents_crawlera_enabled?: Maybe<Scalars['Boolean']['output']>;
  documents_crawlera_session_enabled?: Maybe<Scalars['Boolean']['output']>;
  geocoding_quality?: Maybe<Scalars['Int']['output']>;
  gss_code: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  invalid_applications?: Maybe<Scalars['Int']['output']>;
  lastSuccessfulJob?: Maybe<ShStat>;
  lastTestJob?: Maybe<ShStat>;
  last_verification?: Maybe<PlanningAuthorityVerification>;
  link_markdown?: Maybe<Scalars['String']['output']>;
  live?: Maybe<Scalars['Boolean']['output']>;
  missingMonths?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  monthlyQuantities?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  notTriedMonths?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  notes?: Maybe<Scalars['String']['output']>;
  planningAppSample?: Maybe<Planning>;
  poor_month_rescrape_enabled?: Maybe<Scalars['Boolean']['output']>;
  poor_months?: Maybe<Array<Maybe<PoorMonth>>>;
  priority?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  scrape_daytime_only?: Maybe<Scalars['Boolean']['output']>;
  scraping_priority?: Maybe<Scalars['Int']['output']>;
  search_url?: Maybe<Scalars['String']['output']>;
  site_ref?: Maybe<Scalars['String']['output']>;
  stats_date_field?: Maybe<Scalars['String']['output']>;
  successfulMonths?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  test_job_type?: Maybe<Scalars['String']['output']>;
  use_daily_search_range?: Maybe<Scalars['Boolean']['output']>;
  verification_status?: Maybe<Scalars['String']['output']>;
};

export type PlanningAuthorityVerification = {
  __typename?: 'PlanningAuthorityVerification';
  _id: Scalars['ID']['output'];
  comparisons?: Maybe<PlanningAuthorityVerificationComparison>;
  gss_code?: Maybe<Scalars['String']['output']>;
  planning_app_modified?: Maybe<Scalars['Date']['output']>;
  ref?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type PlanningAuthorityVerificationComparison = {
  __typename?: 'PlanningAuthorityVerificationComparison';
  address?: Maybe<PlanningAuthorityVerificationComparisonElement>;
  agent_address?: Maybe<PlanningAuthorityVerificationComparisonElement>;
  agent_name?: Maybe<PlanningAuthorityVerificationComparisonElement>;
  agent_tel?: Maybe<PlanningAuthorityVerificationComparisonElement>;
  applicant_name?: Maybe<PlanningAuthorityVerificationComparisonElement>;
  date_received?: Maybe<PlanningAuthorityVerificationComparisonElement>;
  decision?: Maybe<PlanningAuthorityVerificationComparisonElement>;
  decision_date?: Maybe<PlanningAuthorityVerificationComparisonElement>;
  easting?: Maybe<PlanningAuthorityVerificationComparisonElement>;
  extract_url?: Maybe<PlanningAuthorityVerificationComparisonElement>;
  local_id?: Maybe<PlanningAuthorityVerificationComparisonElement>;
  northing?: Maybe<PlanningAuthorityVerificationComparisonElement>;
  status?: Maybe<PlanningAuthorityVerificationComparisonElement>;
  title?: Maybe<PlanningAuthorityVerificationComparisonElement>;
  type?: Maybe<PlanningAuthorityVerificationComparisonElement>;
  uprn?: Maybe<PlanningAuthorityVerificationComparisonElement>;
};

export type PlanningAuthorityVerificationComparisonElement = {
  __typename?: 'PlanningAuthorityVerificationComparisonElement';
  _id: Scalars['ID']['output'];
  application_input?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  important?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  user_error?: Maybe<Scalars['Boolean']['output']>;
  user_input?: Maybe<Scalars['String']['output']>;
};

export type PlanningAuthorityVerificationComparisonElementInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  application_input?: InputMaybe<Scalars['String']['input']>;
  important?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  user_error?: InputMaybe<Scalars['Boolean']['input']>;
  user_input?: InputMaybe<Scalars['String']['input']>;
};

export type PlanningAuthorityVerificationComparisonInput = {
  address?: InputMaybe<PlanningAuthorityVerificationComparisonElementInput>;
  agent_address?: InputMaybe<PlanningAuthorityVerificationComparisonElementInput>;
  agent_name?: InputMaybe<PlanningAuthorityVerificationComparisonElementInput>;
  agent_tel?: InputMaybe<PlanningAuthorityVerificationComparisonElementInput>;
  applicant_name?: InputMaybe<PlanningAuthorityVerificationComparisonElementInput>;
  date_received?: InputMaybe<PlanningAuthorityVerificationComparisonElementInput>;
  decision?: InputMaybe<PlanningAuthorityVerificationComparisonElementInput>;
  decision_date?: InputMaybe<PlanningAuthorityVerificationComparisonElementInput>;
  easting?: InputMaybe<PlanningAuthorityVerificationComparisonElementInput>;
  extract_url?: InputMaybe<PlanningAuthorityVerificationComparisonElementInput>;
  local_id?: InputMaybe<PlanningAuthorityVerificationComparisonElementInput>;
  northing?: InputMaybe<PlanningAuthorityVerificationComparisonElementInput>;
  status?: InputMaybe<PlanningAuthorityVerificationComparisonElementInput>;
  title?: InputMaybe<PlanningAuthorityVerificationComparisonElementInput>;
  type?: InputMaybe<PlanningAuthorityVerificationComparisonElementInput>;
  uprn?: InputMaybe<PlanningAuthorityVerificationComparisonElementInput>;
};

export type PlanningAuthorityVerificationComparisonValueInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  agent_address?: InputMaybe<Scalars['String']['input']>;
  agent_name?: InputMaybe<Scalars['String']['input']>;
  agent_tel?: InputMaybe<Scalars['String']['input']>;
  applicant_name?: InputMaybe<Scalars['String']['input']>;
  date_received?: InputMaybe<Scalars['String']['input']>;
  decision?: InputMaybe<Scalars['String']['input']>;
  decision_date?: InputMaybe<Scalars['String']['input']>;
  easting?: InputMaybe<Scalars['String']['input']>;
  extract_url?: InputMaybe<Scalars['String']['input']>;
  local_id?: InputMaybe<Scalars['String']['input']>;
  northing?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  uprn?: InputMaybe<Scalars['String']['input']>;
};

export type PlanningAuthorityVerificationInput = {
  _id: Scalars['ID']['input'];
  comparisons?: InputMaybe<PlanningAuthorityVerificationComparisonInput>;
  gss_code: Scalars['String']['input'];
  planning_app_modified?: InputMaybe<Scalars['Date']['input']>;
  ref: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PlanningAuthorityVerificationUserInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  comparisons?: InputMaybe<PlanningAuthorityVerificationComparisonValueInput>;
  gss_code?: InputMaybe<Scalars['String']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type PlanningCron = {
  __typename?: 'PlanningCron';
  enabled: Scalars['Boolean']['output'];
  expression: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PlanningCronInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  expression?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type PlanningDailyQuantities = {
  __typename?: 'PlanningDailyQuantities';
  count: Scalars['Int']['output'];
  d: Scalars['Int']['output'];
  m: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
};

export type PlanningDataIssue = {
  __typename?: 'PlanningDataIssue';
  _id?: Maybe<Scalars['ID']['output']>;
  created?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  gss_code?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['Date']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  relatedPlanningRefs?: Maybe<Array<Maybe<PlanningRefSet>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PlanningDataIssueTypePerGss = {
  __typename?: 'PlanningDataIssueTypePerGss';
  gss_code?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PlanningInput = {
  gss_code?: InputMaybe<Scalars['String']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type PlanningLabel = {
  __typename?: 'PlanningLabel';
  name: Scalars['String']['output'];
};

export type PlanningMonthlyQuantities = {
  __typename?: 'PlanningMonthlyQuantities';
  count: Scalars['Int']['output'];
  m: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
};

export type PlanningRefSet = {
  __typename?: 'PlanningRefSet';
  _id?: Maybe<Scalars['ID']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  planningRefs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  toBeFixed?: Maybe<Scalars['Boolean']['output']>;
};

export type PlanningReference = {
  __typename?: 'PlanningReference';
  calculatedRef?: Maybe<Scalars['String']['output']>;
  indexInTitle?: Maybe<Scalars['Int']['output']>;
  originalRef?: Maybe<Scalars['String']['output']>;
  planningId?: Maybe<Scalars['ID']['output']>;
};

export type PlanningRefs = {
  __typename?: 'PlanningRefs';
  _id: PlanningRefsId;
  available_refs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  potentional_refs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  running_refs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  undecided_refs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PlanningRefsId = {
  __typename?: 'PlanningRefsID';
  gss_code?: Maybe<Scalars['String']['output']>;
};

export type PlanningRefsPerGss = {
  __typename?: 'PlanningRefsPerGss';
  gss_code: Scalars['String']['output'];
  refs: Array<Maybe<Scalars['String']['output']>>;
};

export type PlanningRefsPerGssInput = {
  gss_code: Scalars['String']['input'];
  refs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PlanningSearch = {
  __typename?: 'PlanningSearch';
  _id?: Maybe<Scalars['ID']['output']>;
  _site?: Maybe<Scalars['ID']['output']>;
  composite_terms?: Maybe<CompositeTerms>;
  council_geometry?: Maybe<GeoJsonGeometry>;
  created?: Maybe<Scalars['Date']['output']>;
  date_received_range?: Maybe<DateRange>;
  geo_filter?: Maybe<GeoFilter>;
  gss_codes?: Maybe<Array<Scalars['String']['output']>>;
  modified?: Maybe<Scalars['Date']['output']>;
  must_not?: Maybe<Array<Maybe<MatchPhraseAllText>>>;
  resi_count_range?: Maybe<FloatRange>;
};

export type PlanningSearchFiltersLocationInput = {
  center: GeoJsonGeometryInput;
  radius: Scalars['Float']['input'];
};

export type PlanningSearchInput = {
  bounding_box_geo_filter?: InputMaybe<BoundingBoxGeoFilterInput>;
  composite_terms?: InputMaybe<CompositeTermsInput>;
  date_received_range?: InputMaybe<DateRangeInput>;
  gss_codes?: InputMaybe<Array<Scalars['String']['input']>>;
  must_not?: InputMaybe<Array<InputMaybe<MatchPhraseInput>>>;
  poly_geo_filter?: InputMaybe<PolygonGeoFilterInput>;
  radius_geo_filter?: InputMaybe<RadiusGeoFilterInput>;
  resi_count_range?: InputMaybe<FloatRangeInput>;
};

export type PlanningSearchResult = {
  __typename?: 'PlanningSearchResult';
  es_result?: Maybe<EsResult>;
  location?: Maybe<GeoJsonGeometry>;
  result_id?: Maybe<Scalars['ID']['output']>;
  result_item?: Maybe<Planning>;
};

export type PlanningSearchResultConnection = {
  __typename?: 'PlanningSearchResultConnection';
  edges: Array<PlanningSearchResultConnectionEdge>;
  nodes: Array<PlanningSearchResult>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Int']['output'];
};

export type PlanningSearchResultConnectionEdge = {
  __typename?: 'PlanningSearchResultConnectionEdge';
  _id: Scalars['String']['output'];
  cursor: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  node: PlanningSearchResult;
  previousCursor?: Maybe<Scalars['String']['output']>;
};

export type PlanningSpecialWord = {
  __typename?: 'PlanningSpecialWord';
  action?: Maybe<Scalars['String']['output']>;
  commerical_count?: Maybe<Scalars['Int']['output']>;
  special_word?: Maybe<Scalars['String']['output']>;
  start_offset?: Maybe<Scalars['Int']['output']>;
  text_content?: Maybe<Scalars['String']['output']>;
  token_idx?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PlanningValidationError = {
  __typename?: 'PlanningValidationError';
  dataPath?: Maybe<Scalars['String']['output']>;
  keyword?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PlanningViewBalance = {
  __typename?: 'PlanningViewBalance';
  cap?: Maybe<Scalars['Int']['output']>;
  next_reset_date?: Maybe<Scalars['Date']['output']>;
  used?: Maybe<Scalars['Int']['output']>;
};

export type PolygonGeoFilter = {
  __typename?: 'PolygonGeoFilter';
  coordinates: Array<CoordinatePair>;
};

export type PolygonGeoFilterInput = {
  coordinates: Array<CoordinatePairInput>;
};

export type PoorMonth = {
  __typename?: 'PoorMonth';
  actualCount?: Maybe<Scalars['Int']['output']>;
  expectedCount?: Maybe<Scalars['Int']['output']>;
  m?: Maybe<Scalars['Int']['output']>;
  y?: Maybe<Scalars['Int']['output']>;
};

export type PricepaidRecordIdentityInput = {
  transaction_id: Scalars['String']['input'];
};

export type ProcessFinishedJobsInput = {
  document_jobs?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProcessingState = {
  __typename?: 'ProcessingState';
  current_state?: Maybe<Scalars['String']['output']>;
  last_state_times?: Maybe<Array<Maybe<LastStateTime>>>;
  state_history?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum PropertyCategoryEnum {
  Agriculture = 'Agriculture',
  Bungalow = 'Bungalow',
  Flat = 'Flat',
  House = 'House',
  Industrial = 'Industrial',
  Land = 'Land',
  Maisonette = 'Maisonette',
  Office = 'Office',
  Other = 'Other',
  ParkHome = 'Park_Home',
  Retail = 'Retail'
}

export enum PropertyDesignationEnum {
  Commercial = 'Commercial',
  Other = 'Other',
  Residential = 'Residential'
}

export type PropertyInfoSearchSuggest = {
  __typename?: 'PropertyInfoSearchSuggest';
  group: Scalars['String']['output'];
  label: Scalars['String']['output'];
  or_set?: Maybe<Scalars['String']['output']>;
  searches: PropertyInfoSearchSuggestInner;
};

export type PropertyInfoSearchSuggestInner = {
  __typename?: 'PropertyInfoSearchSuggestInner';
  property_class_description?: Maybe<Array<Scalars['String']['output']>>;
};

export type PropertyInformation = {
  __typename?: 'PropertyInformation';
  address: AddressBaseRecord;
  building_height?: Maybe<BuildingHeight>;
  dimensions?: Maybe<Dimensions>;
  epc?: Maybe<EpcData>;
  nearby_building_heights?: Maybe<Array<Maybe<BuildingHeight>>>;
  vacant_lot?: Maybe<Scalars['String']['output']>;
  year_built?: Maybe<Scalars['Int']['output']>;
};


export type PropertyInformationNearbyBuildingHeightsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  radius?: InputMaybe<Scalars['Float']['input']>;
};

export enum PropertyOwnerTypeEnum {
  Company = 'Company',
  Government = 'Government',
  Individual = 'Individual',
  Unknown = 'Unknown'
}

export type PropertySearch = {
  __typename?: 'PropertySearch';
  _id?: Maybe<Scalars['ID']['output']>;
  composite_terms?: Maybe<CompositeTerms>;
  created?: Maybe<Scalars['Date']['output']>;
  geo_filter?: Maybe<GeoFilter>;
  modified?: Maybe<Scalars['Date']['output']>;
  search_name?: Maybe<Scalars['String']['output']>;
  total_area_range?: Maybe<IntRange>;
  total_value_range?: Maybe<IntRange>;
};

export type PropertySearchInput = {
  bounding_box_geo_filter?: InputMaybe<BoundingBoxGeoFilterInput>;
  composite_terms?: InputMaybe<CompositeTermsInput>;
  poly_geo_filter?: InputMaybe<PolygonGeoFilterInput>;
  ppsqm_range?: InputMaybe<IntRangeInput>;
  radius_geo_filter?: InputMaybe<RadiusGeoFilterInput>;
  search_name?: InputMaybe<Scalars['String']['input']>;
  total_area_range?: InputMaybe<IntRangeInput>;
  total_value_range?: InputMaybe<IntRangeInput>;
};

export type PropertySearchResult = {
  __typename?: 'PropertySearchResult';
  es_result?: Maybe<EsResult>;
  location?: Maybe<GeoJsonGeometry>;
  result_id?: Maybe<Scalars['ID']['output']>;
  result_item?: Maybe<AddressBaseRecord>;
};

export type PropertySearchResultConnection = {
  __typename?: 'PropertySearchResultConnection';
  edges: Array<PropertySearchResultConnectionEdge>;
  nodes: Array<PropertySearchResult>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Int']['output'];
};

export type PropertySearchResultConnectionEdge = {
  __typename?: 'PropertySearchResultConnectionEdge';
  _id: Scalars['String']['output'];
  cursor: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  node: PropertySearchResult;
  previousCursor?: Maybe<Scalars['String']['output']>;
};

export enum PropertySubCategoryEnum {
  Detached = 'Detached',
  Flat = 'Flat',
  Healthcare = 'Healthcare',
  HighStreetRetail = 'High_Street_Retail',
  Hotel = 'Hotel',
  Leisure = 'Leisure',
  Manufacturing = 'Manufacturing',
  Other = 'Other',
  SemiDetached = 'Semi_Detached',
  Speciality = 'Speciality',
  StorageAndDistribution = 'Storage_and_Distribution',
  Terraced = 'Terraced',
  Warehouse = 'Warehouse'
}

export type Query = {
  __typename?: 'Query';
  account: Account;
  /** @deprecated this is being deprecated in favour of: title(title_no){ addresses } from Ownership */
  address?: Maybe<Scalars['String']['output']>;
  adminGetSFUserDetails: SfUserDetails;
  adminGetUser: User;
  annotation?: Maybe<Annotation>;
  annotations: Array<Maybe<Annotation>>;
  attachmentDownloadUrl?: Maybe<SignedUrl>;
  authorities?: Maybe<Array<PlanningAuthority>>;
  company: Company;
  council: PlanningAuthority;
  councils: Array<PlanningAuthority>;
  createSitesDryRun?: Maybe<Array<Maybe<SiteSaving>>>;
  dailyQuantities?: Maybe<Array<Maybe<PlanningDailyQuantities>>>;
  getSelf: User;
  getTeamMembers: Array<TeamUser>;
  localAuthorities: Array<LocalAuthority>;
  monthlyJobs?: Maybe<Array<ShStat>>;
  notFixedScrapingIssueTypesPerGss?: Maybe<Array<Maybe<ScrapingIssueTypePerGss>>>;
  notFixedScrapingIssues?: Maybe<Array<Maybe<ScrapingIssue>>>;
  notMadeDecisionsQuantities?: Maybe<Array<Maybe<PlanningMonthlyQuantities>>>;
  ownershipSearch: OwnershipSearchResultConnection;
  ownershipSearchCount?: Maybe<Scalars['Int']['output']>;
  ownershipSearchSuggest?: Maybe<Array<OwnershipSearchSuggest>>;
  ownershipViews?: Maybe<PaginatedOwnershipViews>;
  pagedTransactions?: Maybe<PaginatedTrasactions>;
  parcelSearchByParcelId?: Maybe<Array<ParcelSearchByParcelId>>;
  planningAlertResults: PlanningAlertResultConnection;
  planningAlertSubscription?: Maybe<PlanningAlertSubscription>;
  planningAlertSubscriptions: PlanningAlertSubscriptionConnection;
  planningApplication?: Maybe<Planning>;
  planningAppsByLocation?: Maybe<Array<Maybe<Planning>>>;
  planningDataIssueTypesPerGss?: Maybe<Array<Maybe<PlanningDataIssueTypePerGss>>>;
  planningDataIssues?: Maybe<Array<Maybe<PlanningDataIssue>>>;
  planningRefsByQuery?: Maybe<Array<Maybe<PlanningRefsPerGss>>>;
  planningSearch: PlanningSearchResultConnection;
  planningSearchCount?: Maybe<Scalars['Int']['output']>;
  postcodeLookup: Array<AddressBaseRecord>;
  propertyInfoSearchSuggest?: Maybe<Array<PropertyInfoSearchSuggest>>;
  propertyInformationByGeometry?: Maybe<Array<Maybe<PropertyInformation>>>;
  propertyInformationByLatLng?: Maybe<PropertyInformation>;
  propertyInformationByTitleNumber?: Maybe<Array<Maybe<PropertyInformation>>>;
  propertyInformationByUPRN?: Maybe<PropertyInformation>;
  propertyInformationByUPRNs?: Maybe<Array<Maybe<PropertyInformation>>>;
  propertySearch: PropertySearchResultConnection;
  scraper: Scraper;
  scrapers?: Maybe<Array<Scraper>>;
  settings: Setting;
  site: Site;
  siteActivity: SiteActivityConnection;
  siteAttachmentAntivirusScanStatus?: Maybe<SiteAttachmentAntivirusScanStatus>;
  siteAttachmentSignedUploadUrl?: Maybe<SignedUrl>;
  siteEdgeSurroundingId: Array<SiteConnectionEdge>;
  siteFileAttachments: Array<SiteTidbitAttachment>;
  siteLabels?: Maybe<Array<Maybe<SiteLabel>>>;
  siteSearch: SiteConnection;
  siteStage: SiteStage;
  siteStagesPaginated: SiteStageConnection;
  siteTidbits: Array<SiteTidbit>;
  sites: SiteConnection;
  sitesByIds?: Maybe<Array<Maybe<Site>>>;
  sitesByLocation?: Maybe<Array<Maybe<Site>>>;
  sitesSharedWithUser: Array<Site>;
  taskDeclaration?: Maybe<PlanningCron>;
  taskDeclarations?: Maybe<Array<PlanningCron>>;
  title: Title;
  titles: Array<Title>;
  titlesByLocation?: Maybe<Array<Title>>;
  titlesPolygonsByLocation?: Maybe<Array<TitlePolyByLocation>>;
  totalSiteCount?: Maybe<Scalars['Int']['output']>;
  totalStageCount?: Maybe<Scalars['Int']['output']>;
  transactions?: Maybe<TransactionConnection>;
  undecidedPlanningAppsByDateReceivedMonth?: Maybe<Array<Maybe<Planning>>>;
  userAddresses?: Maybe<Array<UserAddress>>;
};


export type QueryAddressArgs = {
  titleNo: Scalars['String']['input'];
};


export type QueryAdminGetSfUserDetailsArgs = {
  email: Scalars['String']['input'];
};


export type QueryAdminGetUserArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryAnnotationArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryAttachmentDownloadUrlArgs = {
  link_duration?: InputMaybe<Scalars['Int']['input']>;
  thumb?: InputMaybe<Scalars['Boolean']['input']>;
  uploaded_file_id: Scalars['String']['input'];
};


export type QueryCompanyArgs = {
  company_no?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCouncilArgs = {
  input: CouncilInput;
};


export type QueryCreateSitesDryRunArgs = {
  projectId?: InputMaybe<Scalars['String']['input']>;
  siteMatchType?: InputMaybe<SiteMatchType>;
  sites: Array<CreateSiteInput>;
};


export type QueryDailyQuantitiesArgs = {
  gss_code: Scalars['String']['input'];
};


export type QueryMonthlyJobsArgs = {
  gss_code: Scalars['String']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type QueryNotFixedScrapingIssuesArgs = {
  gss_code: Scalars['String']['input'];
  jobsSlice?: InputMaybe<Scalars['Int']['input']>;
  refsSlice?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNotMadeDecisionsQuantitiesArgs = {
  gss_code: Scalars['String']['input'];
};


export type QueryOwnershipSearchArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  highlight?: InputMaybe<HighlightInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search: OwnershipSearchInput;
  search_location?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<EsSort>>>;
};


export type QueryOwnershipSearchCountArgs = {
  search: OwnershipSearchInput;
};


export type QueryOwnershipSearchSuggestArgs = {
  text?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOwnershipViewsArgs = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
};


export type QueryPagedTransactionsArgs = {
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryParcelSearchByParcelIdArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  partial_parcel_id: Scalars['String']['input'];
};


export type QueryPlanningAlertResultsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  emailed_at?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  site_id?: InputMaybe<Scalars['String']['input']>;
  subscription_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPlanningAlertSubscriptionArgs = {
  alert_id: Scalars['ID']['input'];
  wrap_terms?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPlanningAlertSubscriptionsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  emailed_at?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  site_id?: InputMaybe<Scalars['String']['input']>;
  wrap_terms?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPlanningApplicationArgs = {
  gss_code: Scalars['String']['input'];
  ref: Scalars['String']['input'];
};


export type QueryPlanningAppsByLocationArgs = {
  location: GeoJsonGeometryInput;
  pixelRadius?: InputMaybe<Scalars['Int']['input']>;
  zoomLevel?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPlanningDataIssuesArgs = {
  gss_code: Scalars['String']['input'];
  refsSlice?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPlanningRefsByQueryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPlanningSearchArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  highlight?: InputMaybe<HighlightInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search: PlanningSearchInput;
  search_location?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<EsSort>>>;
};


export type QueryPlanningSearchCountArgs = {
  search: PlanningSearchInput;
};


export type QueryPostcodeLookupArgs = {
  postcode: Scalars['String']['input'];
};


export type QueryPropertyInfoSearchSuggestArgs = {
  text?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPropertyInformationByGeometryArgs = {
  geometry: GeoJsonGeometryInput;
};


export type QueryPropertyInformationByLatLngArgs = {
  latLng: GeoJsonGeometryInput;
};


export type QueryPropertyInformationByTitleNumberArgs = {
  titleNumber: Scalars['String']['input'];
};


export type QueryPropertyInformationByUprnArgs = {
  uprn: Scalars['String']['input'];
};


export type QueryPropertyInformationByUprNsArgs = {
  uprns?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryPropertySearchArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  highlight?: InputMaybe<HighlightInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search: PropertySearchInput;
  search_location?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<EsSort>>>;
};


export type QueryScraperArgs = {
  input: ScraperInput;
};


export type QuerySiteArgs = {
  _id: Scalars['String']['input'];
};


export type QuerySiteActivityArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  exclude_verbs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit: Scalars['Int']['input'];
  site_id?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySiteAttachmentAntivirusScanStatusArgs = {
  file_name: Scalars['String']['input'];
  site_id: Scalars['String']['input'];
};


export type QuerySiteAttachmentSignedUploadUrlArgs = {
  file_name: Scalars['String']['input'];
  mime_type: Scalars['String']['input'];
  site_id: Scalars['String']['input'];
};


export type QuerySiteEdgeSurroundingIdArgs = {
  _id: Scalars['String']['input'];
  _stage?: InputMaybe<Scalars['String']['input']>;
  assignees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  displayMode?: InputMaybe<Scalars['String']['input']>;
  extent?: InputMaybe<Scalars['Int']['input']>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<SiteSearchInput>;
  siteLabels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  siteName?: InputMaybe<Scalars['String']['input']>;
  siteSort?: InputMaybe<SiteSorting>;
  sortBy?: InputMaybe<SiteSort>;
};


export type QuerySiteFileAttachmentsArgs = {
  site_id?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySiteSearchArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<SiteSearchInput>;
  siteSort?: InputMaybe<SiteSorting>;
};


export type QuerySiteStageArgs = {
  _id: Scalars['String']['input'];
};


export type QuerySiteStagesPaginatedArgs = {
  _id?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
  stageIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySiteTidbitsArgs = {
  is_pinned?: InputMaybe<Scalars['Boolean']['input']>;
  site_id?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  alertsEmailedAt?: InputMaybe<Scalars['String']['input']>;
  assignees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  geometry?: InputMaybe<GeoJsonGeometryInput>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  localAuthorities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  siteIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  siteLabels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  siteSort?: InputMaybe<SiteSorting>;
  stageIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  withPlanningAlertSubscriptionsOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySitesByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QuerySitesByLocationArgs = {
  location: GeoJsonGeometryInput;
  pixelRadius?: InputMaybe<Scalars['Int']['input']>;
  zoomLevel?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTaskDeclarationArgs = {
  input: PlanningCronInput;
};


export type QueryTitleArgs = {
  title_no: Scalars['String']['input'];
};


export type QueryTitlesArgs = {
  title_nos: Array<Scalars['String']['input']>;
};


export type QueryTitlesByLocationArgs = {
  geometry: GeoJsonGeometryInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<TitlesByLocationMode>;
};


export type QueryTitlesPolygonsByLocationArgs = {
  geometry: GeoJsonGeometryInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  title_id: Scalars['String']['input'];
};


export type QueryTotalSiteCountArgs = {
  projectId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTotalStageCountArgs = {
  projectId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTransactionsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUndecidedPlanningAppsByDateReceivedMonthArgs = {
  gss_code: Scalars['String']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type RadiusGeoFilter = {
  __typename?: 'RadiusGeoFilter';
  location: CoordinatePair;
  max_dist: Scalars['Float']['output'];
  min_dist?: Maybe<Scalars['Float']['output']>;
};

export type RadiusGeoFilterInput = {
  location: CoordinatePairInput;
  max_dist: Scalars['Float']['input'];
  min_dist?: InputMaybe<Scalars['Float']['input']>;
};

export type RawHighlightedField = {
  __typename?: 'RawHighlightedField';
  fieldName: Scalars['String']['output'];
  values: Array<Maybe<Scalars['String']['output']>>;
};

export type Recipient = {
  __typename?: 'Recipient';
  _id: Scalars['ID']['output'];
  address: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RegisteredLease = {
  __typename?: 'RegisteredLease';
  end_date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  price_paid?: Maybe<Scalars['Float']['output']>;
  start_date?: Maybe<Scalars['Date']['output']>;
};

export enum SaveSiteDryRunGeometryInfo {
  BadGeometry = 'BAD_GEOMETRY',
  NoPolygon = 'NO_POLYGON',
  Ok = 'OK'
}

export type SfUserDetails = {
  __typename?: 'SFUserDetails';
  firstname?: Maybe<Scalars['String']['output']>;
  job_title?: Maybe<Scalars['String']['output']>;
  job_title_other?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
};

export type ShStat = {
  __typename?: 'SHStat';
  _id: ShStatId;
  close_reason?: Maybe<Scalars['String']['output']>;
  count_results_job?: Maybe<Scalars['Boolean']['output']>;
  count_results_score?: Maybe<Array<Maybe<CountResultsScore>>>;
  created?: Maybe<Scalars['Date']['output']>;
  daily_job?: Maybe<Scalars['Boolean']['output']>;
  elapsed?: Maybe<Scalars['Int']['output']>;
  errors_count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  ignore_job_in_auto_scheduling?: Maybe<Scalars['Boolean']['output']>;
  items_invalid?: Maybe<Scalars['Int']['output']>;
  items_scraped?: Maybe<Scalars['Int']['output']>;
  job_settings?: Maybe<Scalars['JSON']['output']>;
  landdb_items_identical?: Maybe<Scalars['Int']['output']>;
  landdb_items_present?: Maybe<Scalars['Int']['output']>;
  landtech_processed?: Maybe<Scalars['Boolean']['output']>;
  logs?: Maybe<Scalars['Int']['output']>;
  monthly_job?: Maybe<Scalars['Boolean']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  responses_received?: Maybe<Scalars['Int']['output']>;
  spider?: Maybe<Scalars['String']['output']>;
  spider_args?: Maybe<Scalars['JSON']['output']>;
  spider_type?: Maybe<Scalars['String']['output']>;
  started_time?: Maybe<Scalars['Date']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  successful?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  test_job?: Maybe<Scalars['Boolean']['output']>;
  update_job?: Maybe<Scalars['Boolean']['output']>;
  updated_time?: Maybe<Scalars['Date']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type ShStatId = {
  __typename?: 'SHStatID';
  d?: Maybe<Scalars['Int']['output']>;
  gss_code?: Maybe<Scalars['String']['output']>;
  job_id?: Maybe<Scalars['String']['output']>;
  m?: Maybe<Scalars['Int']['output']>;
  y?: Maybe<Scalars['Int']['output']>;
};

export type ShStatInput = {
  creation_date_from?: InputMaybe<Scalars['Date']['input']>;
  creation_date_to?: InputMaybe<Scalars['Date']['input']>;
  gss_code: Scalars['String']['input'];
  job_type?: InputMaybe<JobType>;
  only_last?: InputMaybe<Scalars['Boolean']['input']>;
  successful?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SiteMatchType {
  Exact = 'EXACT',
  IntersectsPoint = 'INTERSECTS_POINT'
}

export type Scraper = {
  __typename?: 'Scraper';
  _id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ScraperInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ScrapingIssue = {
  __typename?: 'ScrapingIssue';
  _id?: Maybe<Scalars['ID']['output']>;
  affected_apps_count?: Maybe<Scalars['Int']['output']>;
  affected_jobs_count?: Maybe<Scalars['Int']['output']>;
  affected_planning_refs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  assignee?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fixed?: Maybe<Scalars['Boolean']['output']>;
  gss_code?: Maybe<Scalars['String']['output']>;
  last_seen?: Maybe<Scalars['Date']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  scraping_job_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sh_ticket_link?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ScrapingIssueTypePerGss = {
  __typename?: 'ScrapingIssueTypePerGss';
  _id?: Maybe<Scalars['ID']['output']>;
  gss_code?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ScrapingSetting = {
  __typename?: 'ScrapingSetting';
  automatic_rescraping_poor_months_enabled?: Maybe<Scalars['Boolean']['output']>;
  count_results_date_from?: Maybe<Scalars['String']['output']>;
  number_of_days_to_check_running_authorities?: Maybe<Scalars['Int']['output']>;
  number_of_jobs_with_equal_results?: Maybe<Scalars['Int']['output']>;
  test_monthly_scraping_date?: Maybe<Scalars['String']['output']>;
  update_job_refs_amount_limit?: Maybe<Scalars['Int']['output']>;
  year_to_scrape_documents_from?: Maybe<Scalars['Int']['output']>;
  year_to_scrape_from?: Maybe<Scalars['Int']['output']>;
};

export type ScrapingSettingInput = {
  automatic_rescraping_poor_months_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  count_results_date_from?: InputMaybe<Scalars['String']['input']>;
  number_of_days_to_check_running_authorities?: InputMaybe<Scalars['Int']['input']>;
  number_of_jobs_with_equal_results?: InputMaybe<Scalars['Int']['input']>;
  test_monthly_scraping_date?: InputMaybe<Scalars['String']['input']>;
  update_job_refs_amount_limit?: InputMaybe<Scalars['Int']['input']>;
  year_to_scrape_documents_from?: InputMaybe<Scalars['Int']['input']>;
  year_to_scrape_from?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchGroupDetails = {
  __typename?: 'SearchGroupDetails';
  id?: Maybe<Scalars['String']['output']>;
  isAggregate?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  unionCollectionId?: Maybe<Scalars['String']['output']>;
};

export type SearchGroupDetailsInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  isAggregate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orSet?: InputMaybe<Scalars['String']['input']>;
  unionCollectionId?: InputMaybe<Scalars['String']['input']>;
};

export type SelectionInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  mode: SelectionMode;
};

export enum SelectionMode {
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE'
}

export type Setting = {
  __typename?: 'Setting';
  _id: Scalars['ID']['output'];
  cachedSettings?: Maybe<CachedSettingsSetting>;
  data_quality?: Maybe<DataQualitySetting>;
  geocoding?: Maybe<GeocodingSetting>;
  id: Scalars['ID']['output'];
  scraping?: Maybe<ScrapingSetting>;
};

export type SettingInput = {
  cachedSettings?: InputMaybe<CachedSettingsSettingInput>;
  data_quality?: InputMaybe<DataQualitySettingInput>;
  geocoding?: InputMaybe<GeocodingSettingInput>;
  scraping?: InputMaybe<ScrapingSettingInput>;
};

export type SharedByUser = {
  __typename?: 'SharedByUser';
  _id: Scalars['ID']['output'];
  date?: Maybe<Scalars['Date']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type SignedUrl = {
  __typename?: 'SignedUrl';
  expires_at: Scalars['Date']['output'];
  generated_on: Scalars['Date']['output'];
  has_thumbnail?: Maybe<Scalars['Boolean']['output']>;
  url: Scalars['String']['output'];
  valid_for: Scalars['Int']['output'];
};

export type Site = {
  __typename?: 'Site';
  _account?: Maybe<Scalars['String']['output']>;
  _id: Scalars['ID']['output'];
  _intersectingTitleNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _lastModifiedUser?: Maybe<TeamUser>;
  _stage?: Maybe<SiteStage>;
  address?: Maybe<Scalars['String']['output']>;
  assignedUsers: Array<TeamUser>;
  assignees?: Maybe<Array<Scalars['ID']['output']>>;
  average_building_height?: Maybe<BuildingHeight>;
  average_rateable_value?: Maybe<Scalars['Float']['output']>;
  boundary_image: BoundaryImage;
  cached_location?: Maybe<GeoJsonGeometry>;
  cached_location_data_lat?: Maybe<Scalars['Float']['output']>;
  cached_location_data_long?: Maybe<Scalars['Float']['output']>;
  canSendLetter?: Maybe<Scalars['Boolean']['output']>;
  collaborators: Array<Collaborator>;
  created?: Maybe<Scalars['Date']['output']>;
  geometry?: Maybe<GeoJsonGeometry>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  internal_status?: Maybe<Scalars['Int']['output']>;
  labels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  local_authority?: Maybe<Scalars['String']['output']>;
  location?: Maybe<GeoJsonGeometry>;
  main_address?: Maybe<Address>;
  modified?: Maybe<Scalars['Date']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  number_of_planning_alert_subscriptions?: Maybe<Scalars['Int']['output']>;
  os_map_prints: Array<Maybe<OsMapPrint>>;
  photos?: Maybe<Array<Maybe<SiteTidbitAttachment>>>;
  planning_alert_subscriptions?: Maybe<Array<Maybe<PlanningAlertSubscription>>>;
  position_in_stage?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  ptal_rating?: Maybe<Scalars['String']['output']>;
  sharedByUser?: Maybe<SharedByUser>;
  site_labels?: Maybe<Array<Maybe<SiteLabel>>>;
  source: SiteSource;
  title?: Maybe<Scalars['String']['output']>;
  title_document_purchases: Array<Maybe<Transaction>>;
  titles?: Maybe<Array<Title>>;
  totalNumberOfTitlesSummary?: Maybe<Scalars['String']['output']>;
  use_classes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  use_classes_sep_2020?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SiteBoundaryImageArgs = {
  mapZoom?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteTitlesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<TitlesByLocationMode>;
};

export type SiteActivity = {
  _id: Scalars['ID']['output'];
  site?: Maybe<Site>;
  timestamp?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<TeamUser>;
};

export type SiteActivityConnection = {
  __typename?: 'SiteActivityConnection';
  edges: Array<SiteActivityConnectionEdge>;
  nodes: Array<SiteActivity>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Int']['output'];
};

export type SiteActivityConnectionEdge = {
  __typename?: 'SiteActivityConnectionEdge';
  _id: Scalars['String']['output'];
  cursor: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  node: SiteActivity;
  previousCursor?: Maybe<Scalars['String']['output']>;
};

export type SiteActivityFieldUpdate = SiteActivity & {
  __typename?: 'SiteActivityFieldUpdate';
  _id: Scalars['ID']['output'];
  changed_fields?: Maybe<SiteActivityFieldUpdateFields>;
  site?: Maybe<Site>;
  timestamp?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<TeamUser>;
};

export type SiteActivityFieldUpdateAssigneesUpdate = {
  __typename?: 'SiteActivityFieldUpdateAssigneesUpdate';
  new: Array<Maybe<TeamUser>>;
  old: Array<Maybe<TeamUser>>;
};

export type SiteActivityFieldUpdateFields = {
  __typename?: 'SiteActivityFieldUpdateFields';
  assignees?: Maybe<SiteActivityFieldUpdateAssigneesUpdate>;
  geometry?: Maybe<SiteActivityFieldUpdateGeoJsonUpdate>;
  hidden?: Maybe<SiteActivityFieldUpdateHiddenUpdate>;
  internal_status?: Maybe<SiteActivityFieldUpdateIntUpdate>;
  labels?: Maybe<SiteActivityFieldUpdateLabelUpdate>;
  notes?: Maybe<SiteActivityFieldUpdateStringUpdate>;
  priority?: Maybe<SiteActivityFieldUpdatePriorityUpdate>;
  site_labels?: Maybe<SiteActivityFieldUpdateSiteLabelUpdate>;
  stage?: Maybe<SiteActivityFieldUpdateStageUpdate>;
  title?: Maybe<SiteActivityFieldUpdateStringUpdate>;
};

export type SiteActivityFieldUpdateGeoJsonUpdate = {
  __typename?: 'SiteActivityFieldUpdateGeoJsonUpdate';
  new?: Maybe<GeoJsonGeometry>;
  old?: Maybe<GeoJsonGeometry>;
};

export type SiteActivityFieldUpdateHiddenUpdate = {
  __typename?: 'SiteActivityFieldUpdateHiddenUpdate';
  new?: Maybe<Scalars['Boolean']['output']>;
  old?: Maybe<Scalars['Boolean']['output']>;
};

export type SiteActivityFieldUpdateIntUpdate = {
  __typename?: 'SiteActivityFieldUpdateIntUpdate';
  new?: Maybe<Scalars['Int']['output']>;
  old?: Maybe<Scalars['Int']['output']>;
};

export type SiteActivityFieldUpdateLabelUpdate = {
  __typename?: 'SiteActivityFieldUpdateLabelUpdate';
  added?: Maybe<Array<Scalars['String']['output']>>;
  removed?: Maybe<Array<Scalars['String']['output']>>;
};

export type SiteActivityFieldUpdatePriorityUpdate = {
  __typename?: 'SiteActivityFieldUpdatePriorityUpdate';
  new?: Maybe<Scalars['Int']['output']>;
  old?: Maybe<Scalars['Int']['output']>;
};

export type SiteActivityFieldUpdateSiteLabelUpdate = {
  __typename?: 'SiteActivityFieldUpdateSiteLabelUpdate';
  added?: Maybe<SiteLabel>;
  removed?: Maybe<SiteLabel>;
};

export type SiteActivityFieldUpdateStageUpdate = {
  __typename?: 'SiteActivityFieldUpdateStageUpdate';
  new?: Maybe<SiteStage>;
  old?: Maybe<SiteStage>;
};

export type SiteActivityFieldUpdateStringUpdate = {
  __typename?: 'SiteActivityFieldUpdateStringUpdate';
  new?: Maybe<Scalars['String']['output']>;
  old?: Maybe<Scalars['String']['output']>;
};

export type SiteActivitySiteAction = SiteActivity & {
  __typename?: 'SiteActivitySiteAction';
  _id: Scalars['ID']['output'];
  site?: Maybe<Site>;
  timestamp?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<TeamUser>;
  verb?: Maybe<Scalars['String']['output']>;
};

export type SiteActivitySiteTidbit = SiteActivity & {
  __typename?: 'SiteActivitySiteTidbit';
  _id: Scalars['ID']['output'];
  site?: Maybe<Site>;
  tidbit?: Maybe<SiteTidbit>;
  timestamp?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<TeamUser>;
  verb?: Maybe<Scalars['String']['output']>;
};

export type SiteArchiveResponse = {
  __typename?: 'SiteArchiveResponse';
  archived_items?: Maybe<Array<Maybe<ArchivedItem>>>;
  new_activity?: Maybe<Array<SiteActivity>>;
};

export type SiteAttachmentAntivirusScanStatus = {
  __typename?: 'SiteAttachmentAntivirusScanStatus';
  antivirusScanStatus?: Maybe<Scalars['String']['output']>;
};

export type SiteConnection = {
  __typename?: 'SiteConnection';
  edges: Array<SiteConnectionEdge>;
  nodes: Array<Site>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Int']['output'];
};

export type SiteConnectionEdge = {
  __typename?: 'SiteConnectionEdge';
  _id: Scalars['String']['output'];
  cursor: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  node: Site;
  previousCursor?: Maybe<Scalars['String']['output']>;
};

export type SiteCreationSource = {
  drawingType?: InputMaybe<Scalars['String']['input']>;
  layer?: InputMaybe<Scalars['String']['input']>;
  ownership_search?: InputMaybe<OwnershipSearchInput>;
  planning_alert_result?: InputMaybe<Scalars['String']['input']>;
  planning_search?: InputMaybe<PlanningSearchInput>;
  property_search?: InputMaybe<PropertySearchInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
};

export type SiteCreationTidbit = {
  ownership_record?: InputMaybe<SiteTidbitOwnershipRecordIdentityInput>;
  planning_application?: InputMaybe<SiteTidbitPlanningRecordIdentityInput>;
};

export type SiteInput = {
  _stage: StageInput;
  geometry: GeoJsonGeometryInput;
  notes?: InputMaybe<Scalars['String']['input']>;
  site_labels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  title: Scalars['String']['input'];
};

export type SiteLabel = {
  __typename?: 'SiteLabel';
  _id: Scalars['ID']['output'];
  created?: Maybe<Scalars['Date']['output']>;
  modified?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SiteLabelArchiveResponse = {
  __typename?: 'SiteLabelArchiveResponse';
  archived_item: ArchivedItem;
  new_activity?: Maybe<Array<Maybe<SiteActivity>>>;
};

export type SiteLabelCreation = {
  name: Scalars['String']['input'];
};

export type SiteLabelUpdate = {
  name: Scalars['String']['input'];
};

export type SiteSaving = {
  __typename?: 'SiteSaving';
  geometry_info?: Maybe<SaveSiteDryRunGeometryInfo>;
  id?: Maybe<Scalars['ID']['output']>;
  saved_site?: Maybe<Site>;
  status?: Maybe<CreateSiteResponseStatus>;
};

export type SiteSearchInput = {
  _stage?: InputMaybe<Scalars['ID']['input']>;
  assignees?: InputMaybe<Array<Scalars['ID']['input']>>;
  local_authorities?: InputMaybe<Array<Scalars['ID']['input']>>;
  location?: InputMaybe<CoordinatePairInput>;
  site_labels?: InputMaybe<Array<Scalars['ID']['input']>>;
  stages?: InputMaybe<Array<Scalars['ID']['input']>>;
  terms?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum SiteSort {
  Id = '_id',
  Created = 'created',
  PositionInStage = 'position_in_stage',
  Updated = 'updated'
}

export type SiteSorting = {
  direction?: InputMaybe<Scalars['Int']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
};

export type SiteSource = {
  _id: Scalars['ID']['output'];
};

export type SiteSourceCompsLayer = SiteSource & {
  __typename?: 'SiteSourceCompsLayer';
  _id: Scalars['ID']['output'];
};

export type SiteSourceConstraintsLayer = SiteSource & {
  __typename?: 'SiteSourceConstraintsLayer';
  _id: Scalars['ID']['output'];
};

export type SiteSourceDrawingTool = SiteSource & {
  __typename?: 'SiteSourceDrawingTool';
  _id: Scalars['ID']['output'];
};

export type SiteSourceDrawingTools = SiteSource & {
  __typename?: 'SiteSourceDrawingTools';
  _id: Scalars['ID']['output'];
  drawingType: Scalars['String']['output'];
};

export type SiteSourceMobileApp = SiteSource & {
  __typename?: 'SiteSourceMobileApp';
  _id: Scalars['ID']['output'];
};

export type SiteSourceOwnershipLayer = SiteSource & {
  __typename?: 'SiteSourceOwnershipLayer';
  _id: Scalars['ID']['output'];
};

export type SiteSourceOwnershipParcel = SiteSource & {
  __typename?: 'SiteSourceOwnershipParcel';
  _id: Scalars['ID']['output'];
  company_name?: Maybe<Scalars['String']['output']>;
  tenure?: Maybe<Scalars['String']['output']>;
  title_no: Scalars['String']['output'];
};

export type SiteSourceOwnershipSearch = SiteSource & {
  __typename?: 'SiteSourceOwnershipSearch';
  _id: Scalars['ID']['output'];
  search: OwnershipSearch;
};

export type SiteSourcePlanningAlertResult = SiteSource & {
  __typename?: 'SiteSourcePlanningAlertResult';
  _id: Scalars['ID']['output'];
};

export type SiteSourcePlanningLayer = SiteSource & {
  __typename?: 'SiteSourcePlanningLayer';
  _id: Scalars['ID']['output'];
};

export type SiteSourcePlanningPolicyLayer = SiteSource & {
  __typename?: 'SiteSourcePlanningPolicyLayer';
  _id: Scalars['ID']['output'];
};

export type SiteSourcePlanningSearch = SiteSource & {
  __typename?: 'SiteSourcePlanningSearch';
  _id: Scalars['ID']['output'];
  search: PlanningSearch;
};

export type SiteSourcePropertyInfoLayer = SiteSource & {
  __typename?: 'SiteSourcePropertyInfoLayer';
  _id: Scalars['ID']['output'];
};

export type SiteSourcePropertySearch = SiteSource & {
  __typename?: 'SiteSourcePropertySearch';
  _id: Scalars['ID']['output'];
  search: PropertySearch;
};

export type SiteSourceSitesUploader = SiteSource & {
  __typename?: 'SiteSourceSitesUploader';
  _id: Scalars['ID']['output'];
  uploadId: Scalars['String']['output'];
};

export type SiteSourceZoningLayer = SiteSource & {
  __typename?: 'SiteSourceZoningLayer';
  _id: Scalars['ID']['output'];
};

export type SiteStage = {
  __typename?: 'SiteStage';
  _id: Scalars['ID']['output'];
  _sites?: Maybe<SiteConnection>;
  _workspace?: Maybe<SiteStageWorkspace>;
  color?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Date']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  modified?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position_in_pipeline?: Maybe<Scalars['Int']['output']>;
  ref?: Maybe<Scalars['String']['output']>;
};


export type SiteStageSitesArgs = {
  assignees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Filters>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  siteLabels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  siteName?: InputMaybe<Scalars['String']['input']>;
};

export type SiteStageConnection = {
  __typename?: 'SiteStageConnection';
  edges: Array<SiteStageConnectionEdge>;
  nodes: Array<SiteStage>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Int']['output'];
};

export type SiteStageConnectionEdge = {
  __typename?: 'SiteStageConnectionEdge';
  _id: Scalars['String']['output'];
  cursor: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  node: SiteStage;
  previousCursor?: Maybe<Scalars['String']['output']>;
};

export type SiteStageCreation = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['String']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type SiteStageUpdate = {
  _id: Scalars['String']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position_in_pipeline?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type SiteStageWorkspace = {
  __typename?: 'SiteStageWorkspace';
  developmentType: Array<DevelopmentType>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type SiteTidbit = {
  _id: Scalars['ID']['output'];
  archived?: Maybe<Scalars['Boolean']['output']>;
  children?: Maybe<Array<SiteTidbit>>;
  created: Scalars['Date']['output'];
  is_hidden?: Maybe<Scalars['Boolean']['output']>;
  is_pinned?: Maybe<Scalars['Boolean']['output']>;
  modified: Scalars['Date']['output'];
  site: Site;
};

export type SiteTidbitAlarm = SiteTidbit & {
  __typename?: 'SiteTidbitAlarm';
  _id: Scalars['ID']['output'];
  archived?: Maybe<Scalars['Boolean']['output']>;
  children?: Maybe<Array<SiteTidbit>>;
  created: Scalars['Date']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  has_rung?: Maybe<Scalars['Boolean']['output']>;
  is_hidden?: Maybe<Scalars['Boolean']['output']>;
  is_pinned?: Maybe<Scalars['Boolean']['output']>;
  is_ringing_now?: Maybe<Scalars['Boolean']['output']>;
  modified: Scalars['Date']['output'];
  site: Site;
  timestamp?: Maybe<Scalars['Date']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SiteTidbitAlert = SiteTidbit & {
  __typename?: 'SiteTidbitAlert';
  _id: Scalars['ID']['output'];
  alert: Scalars['String']['output'];
  archived?: Maybe<Scalars['Boolean']['output']>;
  children?: Maybe<Array<SiteTidbit>>;
  created: Scalars['Date']['output'];
  is_hidden?: Maybe<Scalars['Boolean']['output']>;
  is_pinned?: Maybe<Scalars['Boolean']['output']>;
  modified: Scalars['Date']['output'];
  site: Site;
  title?: Maybe<Scalars['String']['output']>;
};

export type SiteTidbitArchiveResponse = {
  __typename?: 'SiteTidbitArchiveResponse';
  archived_items?: Maybe<Array<Maybe<SiteTidbit>>>;
  new_activity?: Maybe<Array<SiteActivity>>;
};

export type SiteTidbitAttachment = SiteTidbit & {
  __typename?: 'SiteTidbitAttachment';
  _id: Scalars['ID']['output'];
  archived?: Maybe<Scalars['Boolean']['output']>;
  attachment?: Maybe<UploadedFile>;
  can_delete?: Maybe<Scalars['Boolean']['output']>;
  children?: Maybe<Array<SiteTidbit>>;
  created: Scalars['Date']['output'];
  extension?: Maybe<Scalars['String']['output']>;
  file_name: Scalars['String']['output'];
  is_hidden?: Maybe<Scalars['Boolean']['output']>;
  is_pinned?: Maybe<Scalars['Boolean']['output']>;
  modified: Scalars['Date']['output'];
  preview?: Maybe<UploadedFile>;
  site: Site;
  source?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  user: TeamUser;
};

export type SiteTidbitChecklist = SiteTidbit & {
  __typename?: 'SiteTidbitChecklist';
  _id: Scalars['ID']['output'];
  archived?: Maybe<Scalars['Boolean']['output']>;
  children?: Maybe<Array<SiteTidbit>>;
  created: Scalars['Date']['output'];
  is_hidden?: Maybe<Scalars['Boolean']['output']>;
  is_pinned?: Maybe<Scalars['Boolean']['output']>;
  items: Array<ChecklistItem>;
  modified: Scalars['Date']['output'];
  site: Site;
  title?: Maybe<Scalars['String']['output']>;
};

export type SiteTidbitComment = SiteTidbit & {
  __typename?: 'SiteTidbitComment';
  _id: Scalars['ID']['output'];
  archived?: Maybe<Scalars['Boolean']['output']>;
  can_delete?: Maybe<Scalars['Boolean']['output']>;
  children?: Maybe<Array<SiteTidbit>>;
  comment_body?: Maybe<Scalars['String']['output']>;
  created: Scalars['Date']['output'];
  is_hidden?: Maybe<Scalars['Boolean']['output']>;
  is_pinned?: Maybe<Scalars['Boolean']['output']>;
  modified: Scalars['Date']['output'];
  parent?: Maybe<SiteTidbit>;
  site: Site;
  user: TeamUser;
};

export type SiteTidbitCommentUpdate = {
  _id: Scalars['String']['input'];
  comment_body?: InputMaybe<Scalars['String']['input']>;
};

export type SiteTidbitComparableTransaction = SiteTidbit & {
  __typename?: 'SiteTidbitComparableTransaction';
  _id: Scalars['ID']['output'];
  archived?: Maybe<Scalars['Boolean']['output']>;
  children?: Maybe<Array<SiteTidbit>>;
  comparable_transaction: ComparableV2;
  created: Scalars['Date']['output'];
  is_hidden?: Maybe<Scalars['Boolean']['output']>;
  is_pinned?: Maybe<Scalars['Boolean']['output']>;
  modified: Scalars['Date']['output'];
  site: Site;
};

export type SiteTidbitComparableTransactionCreation = {
  comment_body?: InputMaybe<Scalars['String']['input']>;
  comparable_transaction: ComparableTransactionIdentityInput;
  is_hidden?: InputMaybe<Scalars['Boolean']['input']>;
  is_pinned?: InputMaybe<Scalars['Boolean']['input']>;
  site: Scalars['String']['input'];
};

export type SiteTidbitGdv = SiteTidbit & {
  __typename?: 'SiteTidbitGDV';
  _id: Scalars['ID']['output'];
  archived?: Maybe<Scalars['Boolean']['output']>;
  area_msq?: Maybe<Scalars['Float']['output']>;
  children?: Maybe<Array<SiteTidbit>>;
  created: Scalars['Date']['output'];
  gdv?: Maybe<Scalars['Float']['output']>;
  is_hidden?: Maybe<Scalars['Boolean']['output']>;
  is_pinned?: Maybe<Scalars['Boolean']['output']>;
  modified: Scalars['Date']['output'];
  price_per_msq?: Maybe<Scalars['Float']['output']>;
  site: Site;
  title?: Maybe<Scalars['String']['output']>;
};

export type SiteTidbitOsMapPrint = SiteTidbit & {
  __typename?: 'SiteTidbitOSMapPrint';
  _id: Scalars['ID']['output'];
  archived?: Maybe<Scalars['Boolean']['output']>;
  children?: Maybe<Array<SiteTidbit>>;
  created: Scalars['Date']['output'];
  is_hidden?: Maybe<Scalars['Boolean']['output']>;
  is_pinned?: Maybe<Scalars['Boolean']['output']>;
  modified: Scalars['Date']['output'];
  os_map_print: OsMapPrint;
  site: Site;
};

export type SiteTidbitOsMapPrintCreation = {
  comment_body?: InputMaybe<Scalars['String']['input']>;
  is_hidden?: InputMaybe<Scalars['Boolean']['input']>;
  is_pinned?: InputMaybe<Scalars['Boolean']['input']>;
  os_map_print: MongoRecordWithIdIdentityInput;
  site: Scalars['String']['input'];
};

export type SiteTidbitOwnershipRecord = SiteTidbit & {
  __typename?: 'SiteTidbitOwnershipRecord';
  _id: Scalars['ID']['output'];
  archived?: Maybe<Scalars['Boolean']['output']>;
  children?: Maybe<Array<SiteTidbit>>;
  created: Scalars['Date']['output'];
  is_hidden?: Maybe<Scalars['Boolean']['output']>;
  is_pinned?: Maybe<Scalars['Boolean']['output']>;
  modified: Scalars['Date']['output'];
  ownership_record: TitleOwnership;
  site: Site;
};

export type SiteTidbitOwnershipRecordCreation = {
  comment_body?: InputMaybe<Scalars['String']['input']>;
  is_hidden?: InputMaybe<Scalars['Boolean']['input']>;
  is_pinned?: InputMaybe<Scalars['Boolean']['input']>;
  ownership_record: SiteTidbitOwnershipRecordIdentityInput;
  site: Scalars['String']['input'];
};

export type SiteTidbitOwnershipRecordIdentityInput = {
  company_name?: InputMaybe<Scalars['String']['input']>;
  company_no?: InputMaybe<Scalars['String']['input']>;
  tenure: Scalars['String']['input'];
  title_no: Scalars['String']['input'];
};

export type SiteTidbitPlanningRecord = SiteTidbit & {
  __typename?: 'SiteTidbitPlanningRecord';
  _id: Scalars['ID']['output'];
  archived?: Maybe<Scalars['Boolean']['output']>;
  children?: Maybe<Array<SiteTidbit>>;
  created: Scalars['Date']['output'];
  is_hidden?: Maybe<Scalars['Boolean']['output']>;
  is_pinned?: Maybe<Scalars['Boolean']['output']>;
  modified: Scalars['Date']['output'];
  planning_record: Planning;
  site: Site;
};

export type SiteTidbitPlanningRecordCreation = {
  comment_body?: InputMaybe<Scalars['String']['input']>;
  is_hidden?: InputMaybe<Scalars['Boolean']['input']>;
  is_pinned?: InputMaybe<Scalars['Boolean']['input']>;
  planning_record: SiteTidbitPlanningRecordIdentityInput;
  site: Scalars['String']['input'];
};

export type SiteTidbitPlanningRecordIdentityInput = {
  gss_code: Scalars['String']['input'];
  ref: Scalars['String']['input'];
};

export type SiteTidbitPricepaidRecord = SiteTidbit & {
  __typename?: 'SiteTidbitPricepaidRecord';
  _id: Scalars['ID']['output'];
  archived?: Maybe<Scalars['Boolean']['output']>;
  children?: Maybe<Array<SiteTidbit>>;
  created: Scalars['Date']['output'];
  is_hidden?: Maybe<Scalars['Boolean']['output']>;
  is_pinned?: Maybe<Scalars['Boolean']['output']>;
  modified: Scalars['Date']['output'];
  pricepaid_record: Comparable;
  site: Site;
};

export type SiteTidbitPricepaidRecordCreation = {
  comment_body?: InputMaybe<Scalars['String']['input']>;
  is_hidden?: InputMaybe<Scalars['Boolean']['input']>;
  is_pinned?: InputMaybe<Scalars['Boolean']['input']>;
  pricepaid_record: PricepaidRecordIdentityInput;
  site: Scalars['String']['input'];
};

export type SiteTidbitTitleDocument = SiteTidbit & {
  __typename?: 'SiteTidbitTitleDocument';
  _id: Scalars['ID']['output'];
  archived?: Maybe<Scalars['Boolean']['output']>;
  children?: Maybe<Array<SiteTidbit>>;
  created: Scalars['Date']['output'];
  is_hidden?: Maybe<Scalars['Boolean']['output']>;
  is_pinned?: Maybe<Scalars['Boolean']['output']>;
  modified: Scalars['Date']['output'];
  site: Site;
  title_document: TitleDocument;
};

export type SiteTidbitTitleDocumentCreation = {
  comment_body?: InputMaybe<Scalars['String']['input']>;
  is_hidden?: InputMaybe<Scalars['Boolean']['input']>;
  is_pinned?: InputMaybe<Scalars['Boolean']['input']>;
  site: Scalars['String']['input'];
  title_document: MongoRecordWithIdIdentityInput;
};

export type SiteTidbitUpdate = {
  _id: Scalars['String']['input'];
  comment_body?: InputMaybe<Scalars['String']['input']>;
  is_hidden?: InputMaybe<Scalars['Boolean']['input']>;
  is_pinned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SiteUpdate = {
  _id?: InputMaybe<Scalars['String']['input']>;
  _stage?: InputMaybe<Scalars['String']['input']>;
  assignees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  geometry?: InputMaybe<GeoJsonGeometryInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  position_in_stage?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SiteUpdateResponse = {
  __typename?: 'SiteUpdateResponse';
  new_activity?: Maybe<Array<SiteActivity>>;
  site: Site;
};

export type SkipTracesCredit = {
  __typename?: 'SkipTracesCredit';
  cap?: Maybe<Scalars['Int']['output']>;
  next_reset_date?: Maybe<Scalars['Date']['output']>;
  used?: Maybe<Scalars['Int']['output']>;
};

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type StageInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
};

export type StripeCharge = {
  is_new_payment_method?: InputMaybe<Scalars['Boolean']['input']>;
  payment_method_id?: InputMaybe<Scalars['String']['input']>;
  pending_intent_id?: InputMaybe<Scalars['String']['input']>;
};

export type StripePaymentIntent = {
  __typename?: 'StripePaymentIntent';
  client_secret?: Maybe<Scalars['String']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  is_setup_intent?: Maybe<Scalars['Boolean']['output']>;
  payment_method_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type StripePlan = {
  __typename?: 'StripePlan';
  amount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export enum TitlesByLocationMode {
  All = 'ALL',
  PreferGreaterIntersectionFraction = 'PREFER_GREATER_INTERSECTION_FRACTION'
}

export type TeamUser = {
  __typename?: 'TeamUser';
  _id: Scalars['ID']['output'];
  firstname?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export enum Tenure {
  F = 'F',
  L = 'L'
}

export enum TenureType {
  Freehold = 'FREEHOLD',
  Leasehold = 'LEASEHOLD',
  UnknownOther = 'UNKNOWN_OTHER'
}

export type Title = {
  __typename?: 'Title';
  addresses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  intersectingTitles: Array<Title>;
  is_main_plot?: Maybe<Scalars['Boolean']['output']>;
  owners?: Maybe<Array<TitleOwnership>>;
  parcel_identifier?: Maybe<Scalars['String']['output']>;
  polygons?: Maybe<Array<TitlePoly>>;
  properties?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  properties_intersects?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  registered_lease?: Maybe<RegisteredLease>;
  tenure: TenureType;
  title_no?: Maybe<Scalars['String']['output']>;
  transactions?: Maybe<Array<Transaction>>;
};

export type TitleDocument = {
  _id: Scalars['ID']['output'];
  created: Scalars['Date']['output'];
  location?: Maybe<GeoJsonGeometry>;
  title_no: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type TitleOwnership = {
  __typename?: 'TitleOwnership';
  company?: Maybe<Company>;
  date_proprietor_added?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  person?: Maybe<Person>;
  registry_export_date?: Maybe<Scalars['Date']['output']>;
  title?: Maybe<Title>;
};

export type TitlePlanDocument = TitleDocument & {
  __typename?: 'TitlePlanDocument';
  _id: Scalars['ID']['output'];
  created: Scalars['Date']['output'];
  location?: Maybe<GeoJsonGeometry>;
  title_no: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type TitlePoly = {
  __typename?: 'TitlePoly';
  area: Scalars['Float']['output'];
  geometry: GeoJsonGeometry;
  id: Scalars['ID']['output'];
  location: GeoJsonGeometry;
};

export type TitlePolyByLocation = {
  __typename?: 'TitlePolyByLocation';
  area: Scalars['Float']['output'];
  geometry: GeoJsonGeometry;
  id: Scalars['ID']['output'];
  location: GeoJsonGeometry;
};

export type TitleRegisterDocument = TitleDocument & {
  __typename?: 'TitleRegisterDocument';
  _id: Scalars['ID']['output'];
  created: Scalars['Date']['output'];
  location?: Maybe<GeoJsonGeometry>;
  title_no: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Transaction = {
  __typename?: 'Transaction';
  amountInPence?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  purchase?: Maybe<TransactionPurchase>;
  purchaseMethod?: Maybe<Scalars['String']['output']>;
  state?: Maybe<TransactionState>;
  user?: Maybe<TeamUser>;
};

export type TransactionConnection = {
  __typename?: 'TransactionConnection';
  edges: Array<TransactionConnectionEdge>;
  nodes: Array<Transaction>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Int']['output'];
};

export type TransactionConnectionEdge = {
  __typename?: 'TransactionConnectionEdge';
  _id: Scalars['String']['output'];
  cursor: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  node: Transaction;
  previousCursor?: Maybe<Scalars['String']['output']>;
};

export type TransactionPurchase = {
  __typename?: 'TransactionPurchase';
  amount?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<GeoJsonGeometry>;
  map_print?: Maybe<OsMapPrint>;
  reference?: Maybe<Scalars['String']['output']>;
  title_document?: Maybe<TitleDocument>;
  type?: Maybe<TransactionPurchaseType>;
};

export enum TransactionPurchaseType {
  Atkins = 'Atkins',
  LetterSending = 'LetterSending',
  OsMapPrint = 'OSMapPrint',
  ThirdPartyOnDemand = 'ThirdPartyOnDemand',
  TitlePlanDocument = 'TitlePlanDocument',
  TitleRegisterDocument = 'TitleRegisterDocument'
}

export type TransactionState = {
  __typename?: 'TransactionState';
  expected_response_time?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TrialState = {
  __typename?: 'TrialState';
  active?: Maybe<Scalars['Boolean']['output']>;
  automatic_payment?: Maybe<Scalars['Boolean']['output']>;
  end_date?: Maybe<Scalars['Date']['output']>;
};

export enum UltimateOwnerMatchQuality {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E'
}

export type UltimateOwner = {
  __typename?: 'UltimateOwner';
  _id: Scalars['String']['output'];
  match_quality: UltimateOwnerMatchQuality;
  name: Scalars['String']['output'];
};

export type UpdateJobsInput = {
  gss_codes?: InputMaybe<Array<Scalars['String']['input']>>;
  planning_refs_per_gss?: InputMaybe<Array<PlanningRefsPerGssInput>>;
  priority?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSiteTidbitResponse = {
  __typename?: 'UpdateSiteTidbitResponse';
  new_activity?: Maybe<Array<SiteActivity>>;
  tidbit: SiteTidbit;
};

export type UploadedFile = {
  __typename?: 'UploadedFile';
  _id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  prefix: Scalars['String']['output'];
  signed_url: SignedUrl;
  thumb_url?: Maybe<SignedUrl>;
};


export type UploadedFileSignedUrlArgs = {
  link_duration?: InputMaybe<Scalars['Int']['input']>;
};


export type UploadedFileThumbUrlArgs = {
  link_duration?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadedFileMetadataInput = {
  mime_type?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertSiteTidbitResponse = {
  __typename?: 'UpsertSiteTidbitResponse';
  new_activity?: Maybe<Array<SiteActivity>>;
  tidbit?: Maybe<SiteTidbit>;
};

export type User = {
  __typename?: 'User';
  _id: Scalars['ID']['output'];
  _organisation?: Maybe<Organisation>;
  _team?: Maybe<Account>;
  api_key?: Maybe<Scalars['String']['output']>;
  beta_features?: Maybe<Array<Scalars['String']['output']>>;
  email: Scalars['String']['output'];
  features?: Maybe<Array<Scalars['String']['output']>>;
  firstname?: Maybe<Scalars['String']['output']>;
  has_overdue_invoices?: Maybe<Scalars['Boolean']['output']>;
  intercom_hash?: Maybe<Scalars['String']['output']>;
  job_title?: Maybe<Scalars['String']['output']>;
  job_title_other?: Maybe<Scalars['String']['output']>;
  last_seen_approx?: Maybe<Scalars['Date']['output']>;
  licence_summary?: Maybe<Scalars['String']['output']>;
  licences?: Maybe<Array<Licence>>;
  mfa_enabled?: Maybe<Scalars['Boolean']['output']>;
  permissions?: Maybe<Scalars['String']['output']>;
  plan_name?: Maybe<Scalars['String']['output']>;
  salesforce_id?: Maybe<Scalars['String']['output']>;
  self_service_trial_state?: Maybe<TrialState>;
  self_upgrade_options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  signup_date?: Maybe<Scalars['Date']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stripe_managed_signup?: Maybe<Scalars['Boolean']['output']>;
  stripe_territory?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
};

export type UserAddress = {
  __typename?: 'UserAddress';
  _id: Scalars['ID']['output'];
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  is_default?: Maybe<Scalars['Boolean']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  receiver_name?: Maybe<Scalars['String']['output']>;
};

export type UserAddressInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  postcode: Scalars['String']['input'];
  receiver_name: Scalars['String']['input'];
};

export type UserError = {
  __typename?: 'UserError';
  message?: Maybe<Scalars['String']['output']>;
};

export type UserInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  agreementId?: InputMaybe<Scalars['ID']['input']>;
  billingGroupId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  job_title?: InputMaybe<Scalars['String']['input']>;
  job_title_other?: InputMaybe<Scalars['String']['input']>;
  licences?: InputMaybe<Array<LicenceInput>>;
  mfa_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stripe_territory?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
};

export type UserResponse = {
  __typename?: 'UserResponse';
  error?: Maybe<UserError>;
  user?: Maybe<User>;
};

export type VoaRating = {
  __typename?: 'VoaRating';
  address: Scalars['String']['output'];
  company_name: Scalars['String']['output'];
  effective_date?: Maybe<Scalars['Date']['output']>;
  rateable_value: Scalars['Float']['output'];
  scat_code: Scalars['String']['output'];
  uarn: Scalars['ID']['output'];
  valuations: Array<VoaRatingListEntry>;
};

export type VoaRatingListEntry = {
  __typename?: 'VoaRatingListEntry';
  ba_name?: Maybe<Scalars['String']['output']>;
  list_year: Scalars['Int']['output'];
  ppsqm: Scalars['Float']['output'];
  primary_description: Scalars['String']['output'];
  total_area: Scalars['Float']['output'];
  total_value: Scalars['Float']['output'];
};

export type CreateSiteStageMutationVariables = Exact<{
  stageCreation: SiteStageCreation;
}>;


export type CreateSiteStageMutation = { __typename?: 'Mutation', createSiteStage?: { __typename?: 'SiteStage', _id: string, name?: string | null, color?: string | null, position_in_pipeline?: number | null, hidden?: boolean | null, ref?: string | null, _sites?: { __typename?: 'SiteConnection', totalCount: number, nodes: Array<{ __typename?: 'Site', _id: string, title?: string | null, notes?: string | null, hidden?: boolean | null, position_in_stage?: number | null, created?: any | null, site_labels?: Array<{ __typename?: 'SiteLabel', _id: string, name?: string | null } | null> | null, _stage?: { __typename?: 'SiteStage', _id: string } | null }>, pageInfo?: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null, startCursor?: string | null } | null } | null } | null };

export type ArchiveSiteMutationVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type ArchiveSiteMutation = { __typename?: 'Mutation', archiveSite: { __typename?: 'SiteArchiveResponse', archived_items?: Array<{ __typename?: 'ArchivedItem', _id: string } | null> | null } };

export type DeleteSitesMutationVariables = Exact<{
  search?: InputMaybe<SiteSearchInput>;
  selection?: InputMaybe<SelectionInput>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  siteSort?: InputMaybe<SiteSorting>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DeleteSitesMutation = { __typename?: 'Mutation', archiveSites: { __typename?: 'SiteArchiveResponse', archived_items?: Array<{ __typename?: 'ArchivedItem', _id: string } | null> | null } };

export type ArchiveSiteStageMutationVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type ArchiveSiteStageMutation = { __typename?: 'Mutation', archiveSiteStage?: Array<{ __typename?: 'ArchivedItem', _id: string, typename: string } | null> | null };

export type DeleteStageSitesMutationVariables = Exact<{
  _stage: Scalars['String']['input'];
  siteLabels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  assignees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  siteName?: InputMaybe<Scalars['String']['input']>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<Filters>;
}>;


export type DeleteStageSitesMutation = { __typename?: 'Mutation', archiveSites: { __typename?: 'SiteArchiveResponse', archived_items?: Array<{ __typename: 'ArchivedItem', _id: string } | null> | null } };

export type MoveAllSitesToStageMutationVariables = Exact<{
  stageFrom: Scalars['String']['input'];
  stageTo: Scalars['String']['input'];
  siteLabels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  assignees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  siteName?: InputMaybe<Scalars['String']['input']>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<Filters>;
}>;


export type MoveAllSitesToStageMutation = { __typename?: 'Mutation', moveAllSitesToStage: Array<{ __typename?: 'SiteUpdateResponse', site: { __typename?: 'Site', _id: string, title?: string | null, notes?: string | null, hidden?: boolean | null, position_in_stage?: number | null, created?: any | null, priority?: number | null, assignees?: Array<string> | null, site_labels?: Array<{ __typename?: 'SiteLabel', _id: string, name?: string | null } | null> | null, _stage?: { __typename?: 'SiteStage', _id: string } | null } }> };

export type UpdateSiteStageMutationVariables = Exact<{
  stageUpdate: SiteStageUpdate;
}>;


export type UpdateSiteStageMutation = { __typename?: 'Mutation', updateSiteStage?: { __typename?: 'SiteStage', _id: string } | null };

export type UpdateAllSitesInStageMutationVariables = Exact<{
  stageId: Scalars['String']['input'];
  updateData: SiteUpdate;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateAllSitesInStageMutation = { __typename?: 'Mutation', updateAllSitesInStage?: Array<{ __typename?: 'SiteUpdateResponse', site: { __typename?: 'Site', _id: string, title?: string | null, notes?: string | null, hidden?: boolean | null, position_in_stage?: number | null, created?: any | null, priority?: number | null, assignees?: Array<string> | null, site_labels?: Array<{ __typename?: 'SiteLabel', _id: string, name?: string | null } | null> | null, _stage?: { __typename?: 'SiteStage', _id: string } | null } }> | null };

export type UpdateSelectedSitesMutationVariables = Exact<{
  search?: InputMaybe<SiteSearchInput>;
  selection?: InputMaybe<SelectionInput>;
  siteUpdate: SiteUpdate;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  siteSort?: InputMaybe<SiteSorting>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateSelectedSitesMutation = { __typename?: 'Mutation', updateSelectedSites?: Array<{ __typename?: 'SiteUpdateResponse', site: { __typename?: 'Site', _id: string, title?: string | null, notes?: string | null, hidden?: boolean | null, position_in_stage?: number | null, created?: any | null, priority?: number | null, assignees?: Array<string> | null, site_labels?: Array<{ __typename?: 'SiteLabel', _id: string, name?: string | null } | null> | null, _stage?: { __typename?: 'SiteStage', _id: string } | null } } | null> | null };

export type UpdateSiteStagesMutationVariables = Exact<{
  stageUpdates: Array<SiteStageUpdate> | SiteStageUpdate;
}>;


export type UpdateSiteStagesMutation = { __typename?: 'Mutation', updateSiteStages?: Array<{ __typename?: 'SiteStage', _id: string, position_in_pipeline?: number | null } | null> | null };

export type UpdateSitesMutationVariables = Exact<{
  siteUpdates: Array<SiteUpdate> | SiteUpdate;
}>;


export type UpdateSitesMutation = { __typename?: 'Mutation', updateSites: Array<{ __typename?: 'SiteUpdateResponse', site: { __typename?: 'Site', _id: string, title?: string | null, notes?: string | null, hidden?: boolean | null, position_in_stage?: number | null, local_authority?: string | null, created?: any | null, priority?: number | null, assignees?: Array<string> | null, site_labels?: Array<{ __typename?: 'SiteLabel', _id: string, name?: string | null } | null> | null, geometry?: { __typename?: 'GeoJSONGeometry', type: string, coordinates: any } | null, _stage?: { __typename?: 'SiteStage', _id: string } | null } }> };

export type SiteStagesVueQueryVariables = Exact<{
  isStagesView: Scalars['Boolean']['input'];
  stageId?: InputMaybe<Scalars['String']['input']>;
  stageIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  siteLabels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  siteLimit?: InputMaybe<Scalars['Int']['input']>;
  stageLimit?: InputMaybe<Scalars['Int']['input']>;
  siteCursor?: InputMaybe<Scalars['String']['input']>;
  stageCursor?: InputMaybe<Scalars['String']['input']>;
  assignees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  siteName?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Filters>;
}>;


export type SiteStagesVueQuery = { __typename?: 'Query', siteStages: { __typename?: 'SiteStageConnection', totalCount: number, pageInfo?: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null, startCursor?: string | null } | null, nodes: Array<{ __typename?: 'SiteStage', _id: string, name?: string | null, color?: string | null, position_in_pipeline?: number | null, hidden?: boolean | null, ref?: string | null, _sites?: { __typename?: 'SiteConnection', totalCount: number, nodes: Array<{ __typename?: 'Site', _id: string, title?: string | null, notes?: string | null, hidden?: boolean | null, position_in_stage?: number | null, local_authority?: string | null, created?: any | null, priority?: number | null, assignees?: Array<string> | null, source: { __typename?: 'SiteSourceCompsLayer', _id: string } | { __typename?: 'SiteSourceConstraintsLayer', _id: string } | { __typename?: 'SiteSourceDrawingTool', _id: string } | { __typename?: 'SiteSourceDrawingTools', _id: string } | { __typename?: 'SiteSourceMobileApp', _id: string } | { __typename?: 'SiteSourceOwnershipLayer', _id: string } | { __typename?: 'SiteSourceOwnershipParcel', _id: string } | { __typename?: 'SiteSourceOwnershipSearch', _id: string } | { __typename?: 'SiteSourcePlanningAlertResult', _id: string } | { __typename?: 'SiteSourcePlanningLayer', _id: string } | { __typename?: 'SiteSourcePlanningPolicyLayer', _id: string } | { __typename?: 'SiteSourcePlanningSearch', _id: string } | { __typename?: 'SiteSourcePropertyInfoLayer', _id: string } | { __typename?: 'SiteSourcePropertySearch', _id: string } | { __typename?: 'SiteSourceSitesUploader', _id: string } | { __typename?: 'SiteSourceZoningLayer', _id: string }, site_labels?: Array<{ __typename?: 'SiteLabel', _id: string, name?: string | null } | null> | null, _stage?: { __typename?: 'SiteStage', _id: string } | null }>, pageInfo?: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null, startCursor?: string | null } | null } | null }> } };

export type SitesQueryVariables = Exact<{
  search?: InputMaybe<SiteSearchInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  siteSort?: InputMaybe<SiteSorting>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SitesQuery = { __typename?: 'Query', sites: { __typename?: 'SiteConnection', totalCount: number, nodes: Array<{ __typename?: 'Site', _id: string, title?: string | null, notes?: string | null, hidden?: boolean | null, position_in_stage?: number | null, created?: any | null, priority?: number | null, assignees?: Array<string> | null, local_authority?: string | null, site_labels?: Array<{ __typename?: 'SiteLabel', _id: string, name?: string | null } | null> | null, _stage?: { __typename?: 'SiteStage', _id: string } | null }>, pageInfo?: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null, startCursor?: string | null } | null } };

export type TeamMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type TeamMembersQuery = { __typename?: 'Query', getTeamMembers: Array<{ __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null }> };

export type TotalSiteCountVueQueryVariables = Exact<{ [key: string]: never; }>;


export type TotalSiteCountVueQuery = { __typename?: 'Query', totalSiteCount?: number | null };

export type TotalStageCountQueryVariables = Exact<{ [key: string]: never; }>;


export type TotalStageCountQuery = { __typename?: 'Query', totalStageCount?: number | null };

export type AttachmentTidbitDocFragmentFragment = { __typename?: 'SiteTidbitAttachment', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, can_delete?: boolean | null, created: any, modified: any, file_name: string, archived?: boolean | null, title?: string | null, extension?: string | null, source?: string | null, attachment?: { __typename?: 'UploadedFile', _id: string, signed_url: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null }, thumb_url?: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null } | null } | null, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } };

export type CommentTidbitFragmentFragment = { __typename?: 'SiteTidbitComment', comment_body?: string | null, created: any, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } };

type CoreTidbitFragmentSiteTidbitAlarmFragment = { __typename?: 'SiteTidbitAlarm', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', _id: string, comment_body?: string | null, created: any, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null };

type CoreTidbitFragmentSiteTidbitAlertFragment = { __typename?: 'SiteTidbitAlert', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', _id: string, comment_body?: string | null, created: any, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null };

type CoreTidbitFragmentSiteTidbitAttachmentFragment = { __typename?: 'SiteTidbitAttachment', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', _id: string, comment_body?: string | null, created: any, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null };

type CoreTidbitFragmentSiteTidbitChecklistFragment = { __typename?: 'SiteTidbitChecklist', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', _id: string, comment_body?: string | null, created: any, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null };

type CoreTidbitFragmentSiteTidbitCommentFragment = { __typename?: 'SiteTidbitComment', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', _id: string, comment_body?: string | null, created: any, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null };

type CoreTidbitFragmentSiteTidbitComparableTransactionFragment = { __typename?: 'SiteTidbitComparableTransaction', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', _id: string, comment_body?: string | null, created: any, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null };

type CoreTidbitFragmentSiteTidbitGdvFragment = { __typename?: 'SiteTidbitGDV', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', _id: string, comment_body?: string | null, created: any, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null };

type CoreTidbitFragmentSiteTidbitOsMapPrintFragment = { __typename?: 'SiteTidbitOSMapPrint', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', _id: string, comment_body?: string | null, created: any, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null };

type CoreTidbitFragmentSiteTidbitOwnershipRecordFragment = { __typename?: 'SiteTidbitOwnershipRecord', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', _id: string, comment_body?: string | null, created: any, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null };

type CoreTidbitFragmentSiteTidbitPlanningRecordFragment = { __typename?: 'SiteTidbitPlanningRecord', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', _id: string, comment_body?: string | null, created: any, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null };

type CoreTidbitFragmentSiteTidbitPricepaidRecordFragment = { __typename?: 'SiteTidbitPricepaidRecord', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', _id: string, comment_body?: string | null, created: any, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null };

type CoreTidbitFragmentSiteTidbitTitleDocumentFragment = { __typename?: 'SiteTidbitTitleDocument', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', _id: string, comment_body?: string | null, created: any, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null };

export type CoreTidbitFragmentFragment = CoreTidbitFragmentSiteTidbitAlarmFragment | CoreTidbitFragmentSiteTidbitAlertFragment | CoreTidbitFragmentSiteTidbitAttachmentFragment | CoreTidbitFragmentSiteTidbitChecklistFragment | CoreTidbitFragmentSiteTidbitCommentFragment | CoreTidbitFragmentSiteTidbitComparableTransactionFragment | CoreTidbitFragmentSiteTidbitGdvFragment | CoreTidbitFragmentSiteTidbitOsMapPrintFragment | CoreTidbitFragmentSiteTidbitOwnershipRecordFragment | CoreTidbitFragmentSiteTidbitPlanningRecordFragment | CoreTidbitFragmentSiteTidbitPricepaidRecordFragment | CoreTidbitFragmentSiteTidbitTitleDocumentFragment;

export type OsMapPrintPurchasedFragmentFragment = { __typename: 'OSMapPrint', _id: string, orientation: string, page_size: string, scale: string, created: any, url: string };

export type OsMapPrintTidbitActivityFragmentFragment = { __typename?: 'SiteTidbitOSMapPrint', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, archived?: boolean | null, os_map_print: { __typename?: 'OSMapPrint', _id: string, created: any, url: string } };

export type PurchaseFragmentFragment = { __typename?: 'Transaction', purchase?: { __typename?: 'TransactionPurchase', type?: TransactionPurchaseType | null, title_document?: { __typename: 'TitlePlanDocument', _id: string, title_no: string, created: any, url: string } | { __typename: 'TitleRegisterDocument', _id: string, title_no: string, created: any, url: string } | null } | null };

type SiteActivityFragmentSiteActivityFieldUpdateFragment = { __typename?: 'SiteActivityFieldUpdate', _id: string, timestamp?: any | null, changed_fields?: { __typename?: 'SiteActivityFieldUpdateFields', title?: { __typename?: 'SiteActivityFieldUpdateStringUpdate', old?: string | null, new?: string | null } | null, site_labels?: { __typename?: 'SiteActivityFieldUpdateSiteLabelUpdate', added?: { __typename?: 'SiteLabel', _id: string, name?: string | null } | null, removed?: { __typename?: 'SiteLabel', _id: string, name?: string | null } | null } | null, internal_status?: { __typename?: 'SiteActivityFieldUpdateIntUpdate', old?: number | null, new?: number | null } | null, hidden?: { __typename?: 'SiteActivityFieldUpdateHiddenUpdate', old?: boolean | null, new?: boolean | null } | null, priority?: { __typename?: 'SiteActivityFieldUpdatePriorityUpdate', old?: number | null, new?: number | null } | null, geometry?: { __typename?: 'SiteActivityFieldUpdateGeoJsonUpdate', new?: { __typename?: 'GeoJSONGeometry', type: string } | null } | null, notes?: { __typename?: 'SiteActivityFieldUpdateStringUpdate', new?: string | null } | null, stage?: { __typename?: 'SiteActivityFieldUpdateStageUpdate', old?: { __typename?: 'SiteStage', name?: string | null } | null, new?: { __typename?: 'SiteStage', name?: string | null } | null } | null, assignees?: { __typename?: 'SiteActivityFieldUpdateAssigneesUpdate', old: Array<{ __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null>, new: Array<{ __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null> } | null } | null, user?: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null, site?: { __typename?: 'Site', _id: string, source: { __typename?: 'SiteSourceCompsLayer', _id: string } | { __typename?: 'SiteSourceConstraintsLayer', _id: string } | { __typename?: 'SiteSourceDrawingTool', _id: string } | { __typename?: 'SiteSourceDrawingTools', drawingType: string, _id: string } | { __typename?: 'SiteSourceMobileApp', _id: string } | { __typename?: 'SiteSourceOwnershipLayer', _id: string } | { __typename?: 'SiteSourceOwnershipParcel', _id: string } | { __typename?: 'SiteSourceOwnershipSearch', _id: string } | { __typename?: 'SiteSourcePlanningAlertResult', _id: string } | { __typename?: 'SiteSourcePlanningLayer', _id: string } | { __typename?: 'SiteSourcePlanningPolicyLayer', _id: string } | { __typename?: 'SiteSourcePlanningSearch', _id: string } | { __typename?: 'SiteSourcePropertyInfoLayer', _id: string } | { __typename?: 'SiteSourcePropertySearch', _id: string } | { __typename?: 'SiteSourceSitesUploader', _id: string } | { __typename?: 'SiteSourceZoningLayer', _id: string } } | null };

type SiteActivityFragmentSiteActivitySiteActionFragment = { __typename?: 'SiteActivitySiteAction', verb?: string | null, _id: string, timestamp?: any | null, user?: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null, site?: { __typename?: 'Site', _id: string, source: { __typename?: 'SiteSourceCompsLayer', _id: string } | { __typename?: 'SiteSourceConstraintsLayer', _id: string } | { __typename?: 'SiteSourceDrawingTool', _id: string } | { __typename?: 'SiteSourceDrawingTools', drawingType: string, _id: string } | { __typename?: 'SiteSourceMobileApp', _id: string } | { __typename?: 'SiteSourceOwnershipLayer', _id: string } | { __typename?: 'SiteSourceOwnershipParcel', _id: string } | { __typename?: 'SiteSourceOwnershipSearch', _id: string } | { __typename?: 'SiteSourcePlanningAlertResult', _id: string } | { __typename?: 'SiteSourcePlanningLayer', _id: string } | { __typename?: 'SiteSourcePlanningPolicyLayer', _id: string } | { __typename?: 'SiteSourcePlanningSearch', _id: string } | { __typename?: 'SiteSourcePropertyInfoLayer', _id: string } | { __typename?: 'SiteSourcePropertySearch', _id: string } | { __typename?: 'SiteSourceSitesUploader', _id: string } | { __typename?: 'SiteSourceZoningLayer', _id: string } } | null };

type SiteActivityFragmentSiteActivitySiteTidbitFragment = { __typename?: 'SiteActivitySiteTidbit', verb?: string | null, _id: string, timestamp?: any | null, tidbit?: { __typename?: 'SiteTidbitAlarm', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAlert', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAttachment', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, can_delete?: boolean | null, created: any, modified: any, file_name: string, archived?: boolean | null, title?: string | null, extension?: string | null, source?: string | null, site: { __typename?: 'Site', _id: string }, attachment?: { __typename?: 'UploadedFile', _id: string, signed_url: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null }, thumb_url?: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null } | null } | null, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitChecklist', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComment', can_delete?: boolean | null, archived?: boolean | null, created: any, modified: any, comment_body?: string | null, _id: string, is_pinned?: boolean | null, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null }, parent?: { __typename?: 'SiteTidbitAlarm', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAlert', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAttachment', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, can_delete?: boolean | null, created: any, modified: any, file_name: string, archived?: boolean | null, title?: string | null, extension?: string | null, source?: string | null, site: { __typename?: 'Site', _id: string }, attachment?: { __typename?: 'UploadedFile', _id: string, signed_url: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null }, thumb_url?: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null } | null } | null, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitChecklist', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComment', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string, site: { __typename?: 'Site', _id: string }, comparable_transaction: { __typename?: 'ComparableV2', _id: string, transaction_id: string, price?: number | null, date_of_transfer?: any | null, post_code?: string | null, designation: PropertyDesignationEnum, category: PropertyCategoryEnum, sub_category: PropertySubCategoryEnum, is_new_property?: boolean | null, tenure?: Tenure | null, total_floor_area?: number | null, town?: string | null, region?: string | null, address?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, geometry?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitGDV', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitOSMapPrint', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, archived?: boolean | null, site: { __typename?: 'Site', _id: string }, os_map_print: { __typename?: 'OSMapPrint', _id: string, created: any, url: string } } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string, site: { __typename?: 'Site', _id: string }, ownership_record: { __typename?: 'TitleOwnership', id: string, company?: { __typename?: 'Company', name?: string | null } | null, title?: { __typename?: 'Title', id: string, title_no?: string | null, tenure: TenureType } | null } } | { __typename?: 'SiteTidbitPlanningRecord', _id: string, site: { __typename?: 'Site', _id: string }, planning_record: { __typename?: 'Planning', ref: string } } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string, site: { __typename?: 'Site', _id: string }, pricepaid_record: { __typename?: 'Comparable', _id: string, address?: string | null, transaction_id: string, price_paid?: number | null, deed_date?: any | null, date_of_transfer?: any | null, postcode?: string | null, property_type?: string | null, new_build?: string | null, estate_type?: string | null, transaction_type?: string | null, total_floor_area?: number | null, paon?: string | null, saon?: string | null, street?: string | null, town?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, location?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitTitleDocument', _id: string, site: { __typename?: 'Site', _id: string }, title_document: { __typename?: 'TitlePlanDocument', _id: string, title_no: string, url: string } | { __typename?: 'TitleRegisterDocument', _id: string, title_no: string, url: string } } | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, comparable_transaction: { __typename?: 'ComparableV2', _id: string, transaction_id: string, price?: number | null, date_of_transfer?: any | null, post_code?: string | null, designation: PropertyDesignationEnum, category: PropertyCategoryEnum, sub_category: PropertySubCategoryEnum, is_new_property?: boolean | null, tenure?: Tenure | null, total_floor_area?: number | null, town?: string | null, region?: string | null, address?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, geometry?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitGDV', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitOSMapPrint', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, archived?: boolean | null, site: { __typename?: 'Site', _id: string }, os_map_print: { __typename?: 'OSMapPrint', _id: string, created: any, url: string } } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, ownership_record: { __typename?: 'TitleOwnership', id: string, company?: { __typename?: 'Company', name?: string | null } | null, title?: { __typename?: 'Title', id: string, title_no?: string | null, tenure: TenureType } | null } } | { __typename?: 'SiteTidbitPlanningRecord', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, planning_record: { __typename?: 'Planning', ref: string } } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, pricepaid_record: { __typename?: 'Comparable', _id: string, address?: string | null, transaction_id: string, price_paid?: number | null, deed_date?: any | null, date_of_transfer?: any | null, postcode?: string | null, property_type?: string | null, new_build?: string | null, estate_type?: string | null, transaction_type?: string | null, total_floor_area?: number | null, paon?: string | null, saon?: string | null, street?: string | null, town?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, location?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitTitleDocument', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, title_document: { __typename?: 'TitlePlanDocument', _id: string, title_no: string, url: string } | { __typename?: 'TitleRegisterDocument', _id: string, title_no: string, url: string } } | null, user?: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null, site?: { __typename?: 'Site', _id: string, source: { __typename?: 'SiteSourceCompsLayer', _id: string } | { __typename?: 'SiteSourceConstraintsLayer', _id: string } | { __typename?: 'SiteSourceDrawingTool', _id: string } | { __typename?: 'SiteSourceDrawingTools', drawingType: string, _id: string } | { __typename?: 'SiteSourceMobileApp', _id: string } | { __typename?: 'SiteSourceOwnershipLayer', _id: string } | { __typename?: 'SiteSourceOwnershipParcel', _id: string } | { __typename?: 'SiteSourceOwnershipSearch', _id: string } | { __typename?: 'SiteSourcePlanningAlertResult', _id: string } | { __typename?: 'SiteSourcePlanningLayer', _id: string } | { __typename?: 'SiteSourcePlanningPolicyLayer', _id: string } | { __typename?: 'SiteSourcePlanningSearch', _id: string } | { __typename?: 'SiteSourcePropertyInfoLayer', _id: string } | { __typename?: 'SiteSourcePropertySearch', _id: string } | { __typename?: 'SiteSourceSitesUploader', _id: string } | { __typename?: 'SiteSourceZoningLayer', _id: string } } | null };

export type SiteActivityFragmentFragment = SiteActivityFragmentSiteActivityFieldUpdateFragment | SiteActivityFragmentSiteActivitySiteActionFragment | SiteActivityFragmentSiteActivitySiteTidbitFragment;

export type ActivityPlanningRecordFragment = { __typename?: 'SiteTidbitPlanningRecord', _id: string, planning_record: { __typename?: 'Planning', ref: string } };

export type ActivityOwnershipRecordFragment = { __typename?: 'SiteTidbitOwnershipRecord', _id: string, ownership_record: { __typename?: 'TitleOwnership', id: string, company?: { __typename?: 'Company', name?: string | null } | null, title?: { __typename?: 'Title', id: string, title_no?: string | null, tenure: TenureType } | null } };

export type PricepaidRecordTidbitFragmentFragment = { __typename?: 'SiteTidbitPricepaidRecord', pricepaid_record: { __typename?: 'Comparable', _id: string, address?: string | null, transaction_id: string, price_paid?: number | null, deed_date?: any | null, date_of_transfer?: any | null, postcode?: string | null, property_type?: string | null, new_build?: string | null, estate_type?: string | null, transaction_type?: string | null, total_floor_area?: number | null, paon?: string | null, saon?: string | null, street?: string | null, town?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, location?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } };

export type ComparableTransactionTidbitFragmentFragment = { __typename?: 'SiteTidbitComparableTransaction', comparable_transaction: { __typename?: 'ComparableV2', _id: string, transaction_id: string, price?: number | null, date_of_transfer?: any | null, post_code?: string | null, designation: PropertyDesignationEnum, category: PropertyCategoryEnum, sub_category: PropertySubCategoryEnum, is_new_property?: boolean | null, tenure?: Tenure | null, total_floor_area?: number | null, town?: string | null, region?: string | null, address?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, geometry?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } };

export type TitleDocumentTidbitFragmentFragment = { __typename?: 'SiteTidbitTitleDocument', title_document: { __typename?: 'TitlePlanDocument', _id: string, title_no: string, url: string } | { __typename?: 'TitleRegisterDocument', _id: string, title_no: string, url: string } };

export type SiteTidbitTitleDocumentFragmentFragment = { __typename?: 'SiteTidbitTitleDocument', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, archived?: boolean | null, title_document: { __typename?: 'TitlePlanDocument', _id: string, title_no: string, url: string, created: any } | { __typename?: 'TitleRegisterDocument', _id: string, title_no: string, url: string, created: any } };

type TidbitUpdateFragmentSiteTidbitAlarmFragment = { __typename?: 'SiteTidbitAlarm', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', comment_body?: string | null, created: any, _id: string, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null };

type TidbitUpdateFragmentSiteTidbitAlertFragment = { __typename?: 'SiteTidbitAlert', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', comment_body?: string | null, created: any, _id: string, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null };

type TidbitUpdateFragmentSiteTidbitAttachmentFragment = { __typename?: 'SiteTidbitAttachment', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', comment_body?: string | null, created: any, _id: string, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null };

type TidbitUpdateFragmentSiteTidbitChecklistFragment = { __typename?: 'SiteTidbitChecklist', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', comment_body?: string | null, created: any, _id: string, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null };

type TidbitUpdateFragmentSiteTidbitCommentFragment = { __typename?: 'SiteTidbitComment', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', comment_body?: string | null, created: any, _id: string, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null };

type TidbitUpdateFragmentSiteTidbitComparableTransactionFragment = { __typename?: 'SiteTidbitComparableTransaction', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', comment_body?: string | null, created: any, _id: string, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null };

type TidbitUpdateFragmentSiteTidbitGdvFragment = { __typename?: 'SiteTidbitGDV', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', comment_body?: string | null, created: any, _id: string, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null };

type TidbitUpdateFragmentSiteTidbitOsMapPrintFragment = { __typename?: 'SiteTidbitOSMapPrint', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', comment_body?: string | null, created: any, _id: string, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null };

type TidbitUpdateFragmentSiteTidbitOwnershipRecordFragment = { __typename?: 'SiteTidbitOwnershipRecord', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', comment_body?: string | null, created: any, _id: string, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null };

type TidbitUpdateFragmentSiteTidbitPlanningRecordFragment = { __typename?: 'SiteTidbitPlanningRecord', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', comment_body?: string | null, created: any, _id: string, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null };

type TidbitUpdateFragmentSiteTidbitPricepaidRecordFragment = { __typename?: 'SiteTidbitPricepaidRecord', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', comment_body?: string | null, created: any, _id: string, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null };

type TidbitUpdateFragmentSiteTidbitTitleDocumentFragment = { __typename?: 'SiteTidbitTitleDocument', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', comment_body?: string | null, created: any, _id: string, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null };

export type TidbitUpdateFragmentFragment = TidbitUpdateFragmentSiteTidbitAlarmFragment | TidbitUpdateFragmentSiteTidbitAlertFragment | TidbitUpdateFragmentSiteTidbitAttachmentFragment | TidbitUpdateFragmentSiteTidbitChecklistFragment | TidbitUpdateFragmentSiteTidbitCommentFragment | TidbitUpdateFragmentSiteTidbitComparableTransactionFragment | TidbitUpdateFragmentSiteTidbitGdvFragment | TidbitUpdateFragmentSiteTidbitOsMapPrintFragment | TidbitUpdateFragmentSiteTidbitOwnershipRecordFragment | TidbitUpdateFragmentSiteTidbitPlanningRecordFragment | TidbitUpdateFragmentSiteTidbitPricepaidRecordFragment | TidbitUpdateFragmentSiteTidbitTitleDocumentFragment;

export type TitlePlanDocumentFragmentFragment = { __typename?: 'TitlePlanDocument', _id: string, title_no: string, url: string, created: any };

export type TitleRegisterDocumentFragmentFragment = { __typename?: 'TitleRegisterDocument', _id: string, title_no: string, url: string, created: any };

export type GetSiteAttachmentSignedUploadUrlQueryVariables = Exact<{
  site_id: Scalars['String']['input'];
  file_name: Scalars['String']['input'];
  mime_type: Scalars['String']['input'];
}>;


export type GetSiteAttachmentSignedUploadUrlQuery = { __typename?: 'Query', siteAttachmentSignedUploadUrl?: { __typename?: 'SignedUrl', url: string } | null };

export type AddSiteCommentMutationVariables = Exact<{
  site: Scalars['ID']['input'];
  comment_body: Scalars['String']['input'];
}>;


export type AddSiteCommentMutation = { __typename?: 'Mutation', addSiteComment: { __typename?: 'UpdateSiteTidbitResponse', new_activity?: Array<{ __typename?: 'SiteActivityFieldUpdate', _id: string, timestamp?: any | null, changed_fields?: { __typename?: 'SiteActivityFieldUpdateFields', title?: { __typename?: 'SiteActivityFieldUpdateStringUpdate', old?: string | null, new?: string | null } | null, site_labels?: { __typename?: 'SiteActivityFieldUpdateSiteLabelUpdate', added?: { __typename?: 'SiteLabel', _id: string, name?: string | null } | null, removed?: { __typename?: 'SiteLabel', _id: string, name?: string | null } | null } | null, internal_status?: { __typename?: 'SiteActivityFieldUpdateIntUpdate', old?: number | null, new?: number | null } | null, hidden?: { __typename?: 'SiteActivityFieldUpdateHiddenUpdate', old?: boolean | null, new?: boolean | null } | null, priority?: { __typename?: 'SiteActivityFieldUpdatePriorityUpdate', old?: number | null, new?: number | null } | null, geometry?: { __typename?: 'SiteActivityFieldUpdateGeoJsonUpdate', new?: { __typename?: 'GeoJSONGeometry', type: string } | null } | null, notes?: { __typename?: 'SiteActivityFieldUpdateStringUpdate', new?: string | null } | null, stage?: { __typename?: 'SiteActivityFieldUpdateStageUpdate', old?: { __typename?: 'SiteStage', name?: string | null } | null, new?: { __typename?: 'SiteStage', name?: string | null } | null } | null, assignees?: { __typename?: 'SiteActivityFieldUpdateAssigneesUpdate', old: Array<{ __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null>, new: Array<{ __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null> } | null } | null, user?: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null, site?: { __typename?: 'Site', _id: string, source: { __typename?: 'SiteSourceCompsLayer', _id: string } | { __typename?: 'SiteSourceConstraintsLayer', _id: string } | { __typename?: 'SiteSourceDrawingTool', _id: string } | { __typename?: 'SiteSourceDrawingTools', drawingType: string, _id: string } | { __typename?: 'SiteSourceMobileApp', _id: string } | { __typename?: 'SiteSourceOwnershipLayer', _id: string } | { __typename?: 'SiteSourceOwnershipParcel', _id: string } | { __typename?: 'SiteSourceOwnershipSearch', _id: string } | { __typename?: 'SiteSourcePlanningAlertResult', _id: string } | { __typename?: 'SiteSourcePlanningLayer', _id: string } | { __typename?: 'SiteSourcePlanningPolicyLayer', _id: string } | { __typename?: 'SiteSourcePlanningSearch', _id: string } | { __typename?: 'SiteSourcePropertyInfoLayer', _id: string } | { __typename?: 'SiteSourcePropertySearch', _id: string } | { __typename?: 'SiteSourceSitesUploader', _id: string } | { __typename?: 'SiteSourceZoningLayer', _id: string } } | null } | { __typename?: 'SiteActivitySiteAction', verb?: string | null, _id: string, timestamp?: any | null, user?: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null, site?: { __typename?: 'Site', _id: string, source: { __typename?: 'SiteSourceCompsLayer', _id: string } | { __typename?: 'SiteSourceConstraintsLayer', _id: string } | { __typename?: 'SiteSourceDrawingTool', _id: string } | { __typename?: 'SiteSourceDrawingTools', drawingType: string, _id: string } | { __typename?: 'SiteSourceMobileApp', _id: string } | { __typename?: 'SiteSourceOwnershipLayer', _id: string } | { __typename?: 'SiteSourceOwnershipParcel', _id: string } | { __typename?: 'SiteSourceOwnershipSearch', _id: string } | { __typename?: 'SiteSourcePlanningAlertResult', _id: string } | { __typename?: 'SiteSourcePlanningLayer', _id: string } | { __typename?: 'SiteSourcePlanningPolicyLayer', _id: string } | { __typename?: 'SiteSourcePlanningSearch', _id: string } | { __typename?: 'SiteSourcePropertyInfoLayer', _id: string } | { __typename?: 'SiteSourcePropertySearch', _id: string } | { __typename?: 'SiteSourceSitesUploader', _id: string } | { __typename?: 'SiteSourceZoningLayer', _id: string } } | null } | { __typename?: 'SiteActivitySiteTidbit', verb?: string | null, _id: string, timestamp?: any | null, tidbit?: { __typename?: 'SiteTidbitAlarm', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAlert', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAttachment', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, can_delete?: boolean | null, created: any, modified: any, file_name: string, archived?: boolean | null, title?: string | null, extension?: string | null, source?: string | null, site: { __typename?: 'Site', _id: string }, attachment?: { __typename?: 'UploadedFile', _id: string, signed_url: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null }, thumb_url?: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null } | null } | null, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitChecklist', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComment', can_delete?: boolean | null, archived?: boolean | null, created: any, modified: any, comment_body?: string | null, _id: string, is_pinned?: boolean | null, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null }, parent?: { __typename?: 'SiteTidbitAlarm', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAlert', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAttachment', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, can_delete?: boolean | null, created: any, modified: any, file_name: string, archived?: boolean | null, title?: string | null, extension?: string | null, source?: string | null, site: { __typename?: 'Site', _id: string }, attachment?: { __typename?: 'UploadedFile', _id: string, signed_url: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null }, thumb_url?: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null } | null } | null, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitChecklist', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComment', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string, site: { __typename?: 'Site', _id: string }, comparable_transaction: { __typename?: 'ComparableV2', _id: string, transaction_id: string, price?: number | null, date_of_transfer?: any | null, post_code?: string | null, designation: PropertyDesignationEnum, category: PropertyCategoryEnum, sub_category: PropertySubCategoryEnum, is_new_property?: boolean | null, tenure?: Tenure | null, total_floor_area?: number | null, town?: string | null, region?: string | null, address?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, geometry?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitGDV', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitOSMapPrint', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, archived?: boolean | null, site: { __typename?: 'Site', _id: string }, os_map_print: { __typename?: 'OSMapPrint', _id: string, created: any, url: string } } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string, site: { __typename?: 'Site', _id: string }, ownership_record: { __typename?: 'TitleOwnership', id: string, company?: { __typename?: 'Company', name?: string | null } | null, title?: { __typename?: 'Title', id: string, title_no?: string | null, tenure: TenureType } | null } } | { __typename?: 'SiteTidbitPlanningRecord', _id: string, site: { __typename?: 'Site', _id: string }, planning_record: { __typename?: 'Planning', ref: string } } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string, site: { __typename?: 'Site', _id: string }, pricepaid_record: { __typename?: 'Comparable', _id: string, address?: string | null, transaction_id: string, price_paid?: number | null, deed_date?: any | null, date_of_transfer?: any | null, postcode?: string | null, property_type?: string | null, new_build?: string | null, estate_type?: string | null, transaction_type?: string | null, total_floor_area?: number | null, paon?: string | null, saon?: string | null, street?: string | null, town?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, location?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitTitleDocument', _id: string, site: { __typename?: 'Site', _id: string }, title_document: { __typename?: 'TitlePlanDocument', _id: string, title_no: string, url: string } | { __typename?: 'TitleRegisterDocument', _id: string, title_no: string, url: string } } | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, comparable_transaction: { __typename?: 'ComparableV2', _id: string, transaction_id: string, price?: number | null, date_of_transfer?: any | null, post_code?: string | null, designation: PropertyDesignationEnum, category: PropertyCategoryEnum, sub_category: PropertySubCategoryEnum, is_new_property?: boolean | null, tenure?: Tenure | null, total_floor_area?: number | null, town?: string | null, region?: string | null, address?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, geometry?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitGDV', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitOSMapPrint', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, archived?: boolean | null, site: { __typename?: 'Site', _id: string }, os_map_print: { __typename?: 'OSMapPrint', _id: string, created: any, url: string } } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, ownership_record: { __typename?: 'TitleOwnership', id: string, company?: { __typename?: 'Company', name?: string | null } | null, title?: { __typename?: 'Title', id: string, title_no?: string | null, tenure: TenureType } | null } } | { __typename?: 'SiteTidbitPlanningRecord', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, planning_record: { __typename?: 'Planning', ref: string } } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, pricepaid_record: { __typename?: 'Comparable', _id: string, address?: string | null, transaction_id: string, price_paid?: number | null, deed_date?: any | null, date_of_transfer?: any | null, postcode?: string | null, property_type?: string | null, new_build?: string | null, estate_type?: string | null, transaction_type?: string | null, total_floor_area?: number | null, paon?: string | null, saon?: string | null, street?: string | null, town?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, location?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitTitleDocument', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, title_document: { __typename?: 'TitlePlanDocument', _id: string, title_no: string, url: string } | { __typename?: 'TitleRegisterDocument', _id: string, title_no: string, url: string } } | null, user?: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null, site?: { __typename?: 'Site', _id: string, source: { __typename?: 'SiteSourceCompsLayer', _id: string } | { __typename?: 'SiteSourceConstraintsLayer', _id: string } | { __typename?: 'SiteSourceDrawingTool', _id: string } | { __typename?: 'SiteSourceDrawingTools', drawingType: string, _id: string } | { __typename?: 'SiteSourceMobileApp', _id: string } | { __typename?: 'SiteSourceOwnershipLayer', _id: string } | { __typename?: 'SiteSourceOwnershipParcel', _id: string } | { __typename?: 'SiteSourceOwnershipSearch', _id: string } | { __typename?: 'SiteSourcePlanningAlertResult', _id: string } | { __typename?: 'SiteSourcePlanningLayer', _id: string } | { __typename?: 'SiteSourcePlanningPolicyLayer', _id: string } | { __typename?: 'SiteSourcePlanningSearch', _id: string } | { __typename?: 'SiteSourcePropertyInfoLayer', _id: string } | { __typename?: 'SiteSourcePropertySearch', _id: string } | { __typename?: 'SiteSourceSitesUploader', _id: string } | { __typename?: 'SiteSourceZoningLayer', _id: string } } | null }> | null } };

export type DeleteSiteAttachmentMutationVariables = Exact<{
  tidbit_id: Scalars['String']['input'];
}>;


export type DeleteSiteAttachmentMutation = { __typename?: 'Mutation', deleteSiteAttachment?: { __typename?: 'SiteTidbitArchiveResponse', archived_items?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', _id: string } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string } | null> | null, new_activity?: Array<{ __typename?: 'SiteActivityFieldUpdate', _id: string, timestamp?: any | null, changed_fields?: { __typename?: 'SiteActivityFieldUpdateFields', title?: { __typename?: 'SiteActivityFieldUpdateStringUpdate', old?: string | null, new?: string | null } | null, site_labels?: { __typename?: 'SiteActivityFieldUpdateSiteLabelUpdate', added?: { __typename?: 'SiteLabel', _id: string, name?: string | null } | null, removed?: { __typename?: 'SiteLabel', _id: string, name?: string | null } | null } | null, internal_status?: { __typename?: 'SiteActivityFieldUpdateIntUpdate', old?: number | null, new?: number | null } | null, hidden?: { __typename?: 'SiteActivityFieldUpdateHiddenUpdate', old?: boolean | null, new?: boolean | null } | null, priority?: { __typename?: 'SiteActivityFieldUpdatePriorityUpdate', old?: number | null, new?: number | null } | null, geometry?: { __typename?: 'SiteActivityFieldUpdateGeoJsonUpdate', new?: { __typename?: 'GeoJSONGeometry', type: string } | null } | null, notes?: { __typename?: 'SiteActivityFieldUpdateStringUpdate', new?: string | null } | null, stage?: { __typename?: 'SiteActivityFieldUpdateStageUpdate', old?: { __typename?: 'SiteStage', name?: string | null } | null, new?: { __typename?: 'SiteStage', name?: string | null } | null } | null, assignees?: { __typename?: 'SiteActivityFieldUpdateAssigneesUpdate', old: Array<{ __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null>, new: Array<{ __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null> } | null } | null, user?: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null, site?: { __typename?: 'Site', _id: string, source: { __typename?: 'SiteSourceCompsLayer', _id: string } | { __typename?: 'SiteSourceConstraintsLayer', _id: string } | { __typename?: 'SiteSourceDrawingTool', _id: string } | { __typename?: 'SiteSourceDrawingTools', drawingType: string, _id: string } | { __typename?: 'SiteSourceMobileApp', _id: string } | { __typename?: 'SiteSourceOwnershipLayer', _id: string } | { __typename?: 'SiteSourceOwnershipParcel', _id: string } | { __typename?: 'SiteSourceOwnershipSearch', _id: string } | { __typename?: 'SiteSourcePlanningAlertResult', _id: string } | { __typename?: 'SiteSourcePlanningLayer', _id: string } | { __typename?: 'SiteSourcePlanningPolicyLayer', _id: string } | { __typename?: 'SiteSourcePlanningSearch', _id: string } | { __typename?: 'SiteSourcePropertyInfoLayer', _id: string } | { __typename?: 'SiteSourcePropertySearch', _id: string } | { __typename?: 'SiteSourceSitesUploader', _id: string } | { __typename?: 'SiteSourceZoningLayer', _id: string } } | null } | { __typename?: 'SiteActivitySiteAction', verb?: string | null, _id: string, timestamp?: any | null, user?: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null, site?: { __typename?: 'Site', _id: string, source: { __typename?: 'SiteSourceCompsLayer', _id: string } | { __typename?: 'SiteSourceConstraintsLayer', _id: string } | { __typename?: 'SiteSourceDrawingTool', _id: string } | { __typename?: 'SiteSourceDrawingTools', drawingType: string, _id: string } | { __typename?: 'SiteSourceMobileApp', _id: string } | { __typename?: 'SiteSourceOwnershipLayer', _id: string } | { __typename?: 'SiteSourceOwnershipParcel', _id: string } | { __typename?: 'SiteSourceOwnershipSearch', _id: string } | { __typename?: 'SiteSourcePlanningAlertResult', _id: string } | { __typename?: 'SiteSourcePlanningLayer', _id: string } | { __typename?: 'SiteSourcePlanningPolicyLayer', _id: string } | { __typename?: 'SiteSourcePlanningSearch', _id: string } | { __typename?: 'SiteSourcePropertyInfoLayer', _id: string } | { __typename?: 'SiteSourcePropertySearch', _id: string } | { __typename?: 'SiteSourceSitesUploader', _id: string } | { __typename?: 'SiteSourceZoningLayer', _id: string } } | null } | { __typename?: 'SiteActivitySiteTidbit', verb?: string | null, _id: string, timestamp?: any | null, tidbit?: { __typename?: 'SiteTidbitAlarm', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAlert', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAttachment', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, can_delete?: boolean | null, created: any, modified: any, file_name: string, archived?: boolean | null, title?: string | null, extension?: string | null, source?: string | null, site: { __typename?: 'Site', _id: string }, attachment?: { __typename?: 'UploadedFile', _id: string, signed_url: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null }, thumb_url?: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null } | null } | null, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitChecklist', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComment', can_delete?: boolean | null, archived?: boolean | null, created: any, modified: any, comment_body?: string | null, _id: string, is_pinned?: boolean | null, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null }, parent?: { __typename?: 'SiteTidbitAlarm', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAlert', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAttachment', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, can_delete?: boolean | null, created: any, modified: any, file_name: string, archived?: boolean | null, title?: string | null, extension?: string | null, source?: string | null, site: { __typename?: 'Site', _id: string }, attachment?: { __typename?: 'UploadedFile', _id: string, signed_url: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null }, thumb_url?: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null } | null } | null, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitChecklist', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComment', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string, site: { __typename?: 'Site', _id: string }, comparable_transaction: { __typename?: 'ComparableV2', _id: string, transaction_id: string, price?: number | null, date_of_transfer?: any | null, post_code?: string | null, designation: PropertyDesignationEnum, category: PropertyCategoryEnum, sub_category: PropertySubCategoryEnum, is_new_property?: boolean | null, tenure?: Tenure | null, total_floor_area?: number | null, town?: string | null, region?: string | null, address?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, geometry?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitGDV', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitOSMapPrint', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, archived?: boolean | null, site: { __typename?: 'Site', _id: string }, os_map_print: { __typename?: 'OSMapPrint', _id: string, created: any, url: string } } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string, site: { __typename?: 'Site', _id: string }, ownership_record: { __typename?: 'TitleOwnership', id: string, company?: { __typename?: 'Company', name?: string | null } | null, title?: { __typename?: 'Title', id: string, title_no?: string | null, tenure: TenureType } | null } } | { __typename?: 'SiteTidbitPlanningRecord', _id: string, site: { __typename?: 'Site', _id: string }, planning_record: { __typename?: 'Planning', ref: string } } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string, site: { __typename?: 'Site', _id: string }, pricepaid_record: { __typename?: 'Comparable', _id: string, address?: string | null, transaction_id: string, price_paid?: number | null, deed_date?: any | null, date_of_transfer?: any | null, postcode?: string | null, property_type?: string | null, new_build?: string | null, estate_type?: string | null, transaction_type?: string | null, total_floor_area?: number | null, paon?: string | null, saon?: string | null, street?: string | null, town?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, location?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitTitleDocument', _id: string, site: { __typename?: 'Site', _id: string }, title_document: { __typename?: 'TitlePlanDocument', _id: string, title_no: string, url: string } | { __typename?: 'TitleRegisterDocument', _id: string, title_no: string, url: string } } | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, comparable_transaction: { __typename?: 'ComparableV2', _id: string, transaction_id: string, price?: number | null, date_of_transfer?: any | null, post_code?: string | null, designation: PropertyDesignationEnum, category: PropertyCategoryEnum, sub_category: PropertySubCategoryEnum, is_new_property?: boolean | null, tenure?: Tenure | null, total_floor_area?: number | null, town?: string | null, region?: string | null, address?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, geometry?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitGDV', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitOSMapPrint', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, archived?: boolean | null, site: { __typename?: 'Site', _id: string }, os_map_print: { __typename?: 'OSMapPrint', _id: string, created: any, url: string } } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, ownership_record: { __typename?: 'TitleOwnership', id: string, company?: { __typename?: 'Company', name?: string | null } | null, title?: { __typename?: 'Title', id: string, title_no?: string | null, tenure: TenureType } | null } } | { __typename?: 'SiteTidbitPlanningRecord', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, planning_record: { __typename?: 'Planning', ref: string } } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, pricepaid_record: { __typename?: 'Comparable', _id: string, address?: string | null, transaction_id: string, price_paid?: number | null, deed_date?: any | null, date_of_transfer?: any | null, postcode?: string | null, property_type?: string | null, new_build?: string | null, estate_type?: string | null, transaction_type?: string | null, total_floor_area?: number | null, paon?: string | null, saon?: string | null, street?: string | null, town?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, location?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitTitleDocument', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, title_document: { __typename?: 'TitlePlanDocument', _id: string, title_no: string, url: string } | { __typename?: 'TitleRegisterDocument', _id: string, title_no: string, url: string } } | null, user?: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null, site?: { __typename?: 'Site', _id: string, source: { __typename?: 'SiteSourceCompsLayer', _id: string } | { __typename?: 'SiteSourceConstraintsLayer', _id: string } | { __typename?: 'SiteSourceDrawingTool', _id: string } | { __typename?: 'SiteSourceDrawingTools', drawingType: string, _id: string } | { __typename?: 'SiteSourceMobileApp', _id: string } | { __typename?: 'SiteSourceOwnershipLayer', _id: string } | { __typename?: 'SiteSourceOwnershipParcel', _id: string } | { __typename?: 'SiteSourceOwnershipSearch', _id: string } | { __typename?: 'SiteSourcePlanningAlertResult', _id: string } | { __typename?: 'SiteSourcePlanningLayer', _id: string } | { __typename?: 'SiteSourcePlanningPolicyLayer', _id: string } | { __typename?: 'SiteSourcePlanningSearch', _id: string } | { __typename?: 'SiteSourcePropertyInfoLayer', _id: string } | { __typename?: 'SiteSourcePropertySearch', _id: string } | { __typename?: 'SiteSourceSitesUploader', _id: string } | { __typename?: 'SiteSourceZoningLayer', _id: string } } | null }> | null } | null };

export type DeleteSiteTidbitMutationVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type DeleteSiteTidbitMutation = { __typename?: 'Mutation', deleteSiteTidbit: { __typename?: 'SiteTidbitArchiveResponse', archived_items?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string, archived?: boolean | null } | { __typename?: 'SiteTidbitAlert', _id: string, archived?: boolean | null } | { __typename?: 'SiteTidbitAttachment', _id: string, archived?: boolean | null } | { __typename?: 'SiteTidbitChecklist', _id: string, archived?: boolean | null } | { __typename?: 'SiteTidbitComment', _id: string, archived?: boolean | null } | { __typename?: 'SiteTidbitComparableTransaction', _id: string, archived?: boolean | null } | { __typename?: 'SiteTidbitGDV', _id: string, archived?: boolean | null } | { __typename?: 'SiteTidbitOSMapPrint', _id: string, archived?: boolean | null } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string, archived?: boolean | null } | { __typename?: 'SiteTidbitPlanningRecord', _id: string, archived?: boolean | null } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string, archived?: boolean | null } | { __typename?: 'SiteTidbitTitleDocument', _id: string, archived?: boolean | null } | null> | null, new_activity?: Array<{ __typename?: 'SiteActivityFieldUpdate', _id: string, timestamp?: any | null, changed_fields?: { __typename?: 'SiteActivityFieldUpdateFields', title?: { __typename?: 'SiteActivityFieldUpdateStringUpdate', old?: string | null, new?: string | null } | null, site_labels?: { __typename?: 'SiteActivityFieldUpdateSiteLabelUpdate', added?: { __typename?: 'SiteLabel', _id: string, name?: string | null } | null, removed?: { __typename?: 'SiteLabel', _id: string, name?: string | null } | null } | null, internal_status?: { __typename?: 'SiteActivityFieldUpdateIntUpdate', old?: number | null, new?: number | null } | null, hidden?: { __typename?: 'SiteActivityFieldUpdateHiddenUpdate', old?: boolean | null, new?: boolean | null } | null, priority?: { __typename?: 'SiteActivityFieldUpdatePriorityUpdate', old?: number | null, new?: number | null } | null, geometry?: { __typename?: 'SiteActivityFieldUpdateGeoJsonUpdate', new?: { __typename?: 'GeoJSONGeometry', type: string } | null } | null, notes?: { __typename?: 'SiteActivityFieldUpdateStringUpdate', new?: string | null } | null, stage?: { __typename?: 'SiteActivityFieldUpdateStageUpdate', old?: { __typename?: 'SiteStage', name?: string | null } | null, new?: { __typename?: 'SiteStage', name?: string | null } | null } | null, assignees?: { __typename?: 'SiteActivityFieldUpdateAssigneesUpdate', old: Array<{ __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null>, new: Array<{ __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null> } | null } | null, user?: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null, site?: { __typename?: 'Site', _id: string, source: { __typename?: 'SiteSourceCompsLayer', _id: string } | { __typename?: 'SiteSourceConstraintsLayer', _id: string } | { __typename?: 'SiteSourceDrawingTool', _id: string } | { __typename?: 'SiteSourceDrawingTools', drawingType: string, _id: string } | { __typename?: 'SiteSourceMobileApp', _id: string } | { __typename?: 'SiteSourceOwnershipLayer', _id: string } | { __typename?: 'SiteSourceOwnershipParcel', _id: string } | { __typename?: 'SiteSourceOwnershipSearch', _id: string } | { __typename?: 'SiteSourcePlanningAlertResult', _id: string } | { __typename?: 'SiteSourcePlanningLayer', _id: string } | { __typename?: 'SiteSourcePlanningPolicyLayer', _id: string } | { __typename?: 'SiteSourcePlanningSearch', _id: string } | { __typename?: 'SiteSourcePropertyInfoLayer', _id: string } | { __typename?: 'SiteSourcePropertySearch', _id: string } | { __typename?: 'SiteSourceSitesUploader', _id: string } | { __typename?: 'SiteSourceZoningLayer', _id: string } } | null } | { __typename?: 'SiteActivitySiteAction', verb?: string | null, _id: string, timestamp?: any | null, user?: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null, site?: { __typename?: 'Site', _id: string, source: { __typename?: 'SiteSourceCompsLayer', _id: string } | { __typename?: 'SiteSourceConstraintsLayer', _id: string } | { __typename?: 'SiteSourceDrawingTool', _id: string } | { __typename?: 'SiteSourceDrawingTools', drawingType: string, _id: string } | { __typename?: 'SiteSourceMobileApp', _id: string } | { __typename?: 'SiteSourceOwnershipLayer', _id: string } | { __typename?: 'SiteSourceOwnershipParcel', _id: string } | { __typename?: 'SiteSourceOwnershipSearch', _id: string } | { __typename?: 'SiteSourcePlanningAlertResult', _id: string } | { __typename?: 'SiteSourcePlanningLayer', _id: string } | { __typename?: 'SiteSourcePlanningPolicyLayer', _id: string } | { __typename?: 'SiteSourcePlanningSearch', _id: string } | { __typename?: 'SiteSourcePropertyInfoLayer', _id: string } | { __typename?: 'SiteSourcePropertySearch', _id: string } | { __typename?: 'SiteSourceSitesUploader', _id: string } | { __typename?: 'SiteSourceZoningLayer', _id: string } } | null } | { __typename?: 'SiteActivitySiteTidbit', verb?: string | null, _id: string, timestamp?: any | null, tidbit?: { __typename?: 'SiteTidbitAlarm', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAlert', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAttachment', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, can_delete?: boolean | null, created: any, modified: any, file_name: string, archived?: boolean | null, title?: string | null, extension?: string | null, source?: string | null, site: { __typename?: 'Site', _id: string }, attachment?: { __typename?: 'UploadedFile', _id: string, signed_url: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null }, thumb_url?: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null } | null } | null, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitChecklist', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComment', can_delete?: boolean | null, archived?: boolean | null, created: any, modified: any, comment_body?: string | null, _id: string, is_pinned?: boolean | null, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null }, parent?: { __typename?: 'SiteTidbitAlarm', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAlert', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAttachment', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, can_delete?: boolean | null, created: any, modified: any, file_name: string, archived?: boolean | null, title?: string | null, extension?: string | null, source?: string | null, site: { __typename?: 'Site', _id: string }, attachment?: { __typename?: 'UploadedFile', _id: string, signed_url: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null }, thumb_url?: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null } | null } | null, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitChecklist', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComment', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string, site: { __typename?: 'Site', _id: string }, comparable_transaction: { __typename?: 'ComparableV2', _id: string, transaction_id: string, price?: number | null, date_of_transfer?: any | null, post_code?: string | null, designation: PropertyDesignationEnum, category: PropertyCategoryEnum, sub_category: PropertySubCategoryEnum, is_new_property?: boolean | null, tenure?: Tenure | null, total_floor_area?: number | null, town?: string | null, region?: string | null, address?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, geometry?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitGDV', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitOSMapPrint', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, archived?: boolean | null, site: { __typename?: 'Site', _id: string }, os_map_print: { __typename?: 'OSMapPrint', _id: string, created: any, url: string } } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string, site: { __typename?: 'Site', _id: string }, ownership_record: { __typename?: 'TitleOwnership', id: string, company?: { __typename?: 'Company', name?: string | null } | null, title?: { __typename?: 'Title', id: string, title_no?: string | null, tenure: TenureType } | null } } | { __typename?: 'SiteTidbitPlanningRecord', _id: string, site: { __typename?: 'Site', _id: string }, planning_record: { __typename?: 'Planning', ref: string } } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string, site: { __typename?: 'Site', _id: string }, pricepaid_record: { __typename?: 'Comparable', _id: string, address?: string | null, transaction_id: string, price_paid?: number | null, deed_date?: any | null, date_of_transfer?: any | null, postcode?: string | null, property_type?: string | null, new_build?: string | null, estate_type?: string | null, transaction_type?: string | null, total_floor_area?: number | null, paon?: string | null, saon?: string | null, street?: string | null, town?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, location?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitTitleDocument', _id: string, site: { __typename?: 'Site', _id: string }, title_document: { __typename?: 'TitlePlanDocument', _id: string, title_no: string, url: string } | { __typename?: 'TitleRegisterDocument', _id: string, title_no: string, url: string } } | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, comparable_transaction: { __typename?: 'ComparableV2', _id: string, transaction_id: string, price?: number | null, date_of_transfer?: any | null, post_code?: string | null, designation: PropertyDesignationEnum, category: PropertyCategoryEnum, sub_category: PropertySubCategoryEnum, is_new_property?: boolean | null, tenure?: Tenure | null, total_floor_area?: number | null, town?: string | null, region?: string | null, address?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, geometry?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitGDV', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitOSMapPrint', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, archived?: boolean | null, site: { __typename?: 'Site', _id: string }, os_map_print: { __typename?: 'OSMapPrint', _id: string, created: any, url: string } } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, ownership_record: { __typename?: 'TitleOwnership', id: string, company?: { __typename?: 'Company', name?: string | null } | null, title?: { __typename?: 'Title', id: string, title_no?: string | null, tenure: TenureType } | null } } | { __typename?: 'SiteTidbitPlanningRecord', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, planning_record: { __typename?: 'Planning', ref: string } } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, pricepaid_record: { __typename?: 'Comparable', _id: string, address?: string | null, transaction_id: string, price_paid?: number | null, deed_date?: any | null, date_of_transfer?: any | null, postcode?: string | null, property_type?: string | null, new_build?: string | null, estate_type?: string | null, transaction_type?: string | null, total_floor_area?: number | null, paon?: string | null, saon?: string | null, street?: string | null, town?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, location?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitTitleDocument', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, title_document: { __typename?: 'TitlePlanDocument', _id: string, title_no: string, url: string } | { __typename?: 'TitleRegisterDocument', _id: string, title_no: string, url: string } } | null, user?: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null, site?: { __typename?: 'Site', _id: string, source: { __typename?: 'SiteSourceCompsLayer', _id: string } | { __typename?: 'SiteSourceConstraintsLayer', _id: string } | { __typename?: 'SiteSourceDrawingTool', _id: string } | { __typename?: 'SiteSourceDrawingTools', drawingType: string, _id: string } | { __typename?: 'SiteSourceMobileApp', _id: string } | { __typename?: 'SiteSourceOwnershipLayer', _id: string } | { __typename?: 'SiteSourceOwnershipParcel', _id: string } | { __typename?: 'SiteSourceOwnershipSearch', _id: string } | { __typename?: 'SiteSourcePlanningAlertResult', _id: string } | { __typename?: 'SiteSourcePlanningLayer', _id: string } | { __typename?: 'SiteSourcePlanningPolicyLayer', _id: string } | { __typename?: 'SiteSourcePlanningSearch', _id: string } | { __typename?: 'SiteSourcePropertyInfoLayer', _id: string } | { __typename?: 'SiteSourcePropertySearch', _id: string } | { __typename?: 'SiteSourceSitesUploader', _id: string } | { __typename?: 'SiteSourceZoningLayer', _id: string } } | null }> | null } };

export type UpdateSiteDescriptionMutationVariables = Exact<{
  updateData: SiteUpdate;
}>;


export type UpdateSiteDescriptionMutation = { __typename?: 'Mutation', updateSiteDescription: Array<{ __typename?: 'SiteUpdateResponse', site: { __typename?: 'Site', _id: string, notes?: string | null } }> };

export type UpdateSiteCommentMutationVariables = Exact<{
  updateData: SiteTidbitCommentUpdate;
}>;


export type UpdateSiteCommentMutation = { __typename?: 'Mutation', updateSiteTidbitComment: { __typename?: 'UpdateSiteTidbitResponse', tidbit: { __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', comment_body?: string | null, modified: any, _id: string } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string } } };

export type UpdateSiteTidbitMutationVariables = Exact<{
  updateData: SiteTidbitUpdate;
}>;


export type UpdateSiteTidbitMutation = { __typename?: 'Mutation', updateSiteTidbit: { __typename?: 'UpdateSiteTidbitResponse', tidbit: { __typename?: 'SiteTidbitAlarm', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', comment_body?: string | null, created: any, _id: string, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null } | { __typename?: 'SiteTidbitAlert', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', comment_body?: string | null, created: any, _id: string, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null } | { __typename?: 'SiteTidbitAttachment', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', comment_body?: string | null, created: any, _id: string, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null } | { __typename?: 'SiteTidbitChecklist', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', comment_body?: string | null, created: any, _id: string, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null } | { __typename?: 'SiteTidbitComment', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', comment_body?: string | null, created: any, _id: string, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null } | { __typename?: 'SiteTidbitComparableTransaction', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', comment_body?: string | null, created: any, _id: string, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null } | { __typename?: 'SiteTidbitGDV', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', comment_body?: string | null, created: any, _id: string, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null } | { __typename?: 'SiteTidbitOSMapPrint', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', comment_body?: string | null, created: any, _id: string, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', comment_body?: string | null, created: any, _id: string, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null } | { __typename?: 'SiteTidbitPlanningRecord', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', comment_body?: string | null, created: any, _id: string, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', comment_body?: string | null, created: any, _id: string, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null } | { __typename?: 'SiteTidbitTitleDocument', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', comment_body?: string | null, created: any, _id: string, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null }, new_activity?: Array<{ __typename?: 'SiteActivityFieldUpdate', _id: string, timestamp?: any | null, changed_fields?: { __typename?: 'SiteActivityFieldUpdateFields', title?: { __typename?: 'SiteActivityFieldUpdateStringUpdate', old?: string | null, new?: string | null } | null, site_labels?: { __typename?: 'SiteActivityFieldUpdateSiteLabelUpdate', added?: { __typename?: 'SiteLabel', _id: string, name?: string | null } | null, removed?: { __typename?: 'SiteLabel', _id: string, name?: string | null } | null } | null, internal_status?: { __typename?: 'SiteActivityFieldUpdateIntUpdate', old?: number | null, new?: number | null } | null, hidden?: { __typename?: 'SiteActivityFieldUpdateHiddenUpdate', old?: boolean | null, new?: boolean | null } | null, priority?: { __typename?: 'SiteActivityFieldUpdatePriorityUpdate', old?: number | null, new?: number | null } | null, geometry?: { __typename?: 'SiteActivityFieldUpdateGeoJsonUpdate', new?: { __typename?: 'GeoJSONGeometry', type: string } | null } | null, notes?: { __typename?: 'SiteActivityFieldUpdateStringUpdate', new?: string | null } | null, stage?: { __typename?: 'SiteActivityFieldUpdateStageUpdate', old?: { __typename?: 'SiteStage', name?: string | null } | null, new?: { __typename?: 'SiteStage', name?: string | null } | null } | null, assignees?: { __typename?: 'SiteActivityFieldUpdateAssigneesUpdate', old: Array<{ __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null>, new: Array<{ __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null> } | null } | null, user?: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null, site?: { __typename?: 'Site', _id: string, source: { __typename?: 'SiteSourceCompsLayer', _id: string } | { __typename?: 'SiteSourceConstraintsLayer', _id: string } | { __typename?: 'SiteSourceDrawingTool', _id: string } | { __typename?: 'SiteSourceDrawingTools', drawingType: string, _id: string } | { __typename?: 'SiteSourceMobileApp', _id: string } | { __typename?: 'SiteSourceOwnershipLayer', _id: string } | { __typename?: 'SiteSourceOwnershipParcel', _id: string } | { __typename?: 'SiteSourceOwnershipSearch', _id: string } | { __typename?: 'SiteSourcePlanningAlertResult', _id: string } | { __typename?: 'SiteSourcePlanningLayer', _id: string } | { __typename?: 'SiteSourcePlanningPolicyLayer', _id: string } | { __typename?: 'SiteSourcePlanningSearch', _id: string } | { __typename?: 'SiteSourcePropertyInfoLayer', _id: string } | { __typename?: 'SiteSourcePropertySearch', _id: string } | { __typename?: 'SiteSourceSitesUploader', _id: string } | { __typename?: 'SiteSourceZoningLayer', _id: string } } | null } | { __typename?: 'SiteActivitySiteAction', verb?: string | null, _id: string, timestamp?: any | null, user?: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null, site?: { __typename?: 'Site', _id: string, source: { __typename?: 'SiteSourceCompsLayer', _id: string } | { __typename?: 'SiteSourceConstraintsLayer', _id: string } | { __typename?: 'SiteSourceDrawingTool', _id: string } | { __typename?: 'SiteSourceDrawingTools', drawingType: string, _id: string } | { __typename?: 'SiteSourceMobileApp', _id: string } | { __typename?: 'SiteSourceOwnershipLayer', _id: string } | { __typename?: 'SiteSourceOwnershipParcel', _id: string } | { __typename?: 'SiteSourceOwnershipSearch', _id: string } | { __typename?: 'SiteSourcePlanningAlertResult', _id: string } | { __typename?: 'SiteSourcePlanningLayer', _id: string } | { __typename?: 'SiteSourcePlanningPolicyLayer', _id: string } | { __typename?: 'SiteSourcePlanningSearch', _id: string } | { __typename?: 'SiteSourcePropertyInfoLayer', _id: string } | { __typename?: 'SiteSourcePropertySearch', _id: string } | { __typename?: 'SiteSourceSitesUploader', _id: string } | { __typename?: 'SiteSourceZoningLayer', _id: string } } | null } | { __typename?: 'SiteActivitySiteTidbit', verb?: string | null, _id: string, timestamp?: any | null, tidbit?: { __typename?: 'SiteTidbitAlarm', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAlert', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAttachment', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, can_delete?: boolean | null, created: any, modified: any, file_name: string, archived?: boolean | null, title?: string | null, extension?: string | null, source?: string | null, site: { __typename?: 'Site', _id: string }, attachment?: { __typename?: 'UploadedFile', _id: string, signed_url: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null }, thumb_url?: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null } | null } | null, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitChecklist', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComment', can_delete?: boolean | null, archived?: boolean | null, created: any, modified: any, comment_body?: string | null, _id: string, is_pinned?: boolean | null, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null }, parent?: { __typename?: 'SiteTidbitAlarm', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAlert', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAttachment', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, can_delete?: boolean | null, created: any, modified: any, file_name: string, archived?: boolean | null, title?: string | null, extension?: string | null, source?: string | null, site: { __typename?: 'Site', _id: string }, attachment?: { __typename?: 'UploadedFile', _id: string, signed_url: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null }, thumb_url?: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null } | null } | null, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitChecklist', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComment', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string, site: { __typename?: 'Site', _id: string }, comparable_transaction: { __typename?: 'ComparableV2', _id: string, transaction_id: string, price?: number | null, date_of_transfer?: any | null, post_code?: string | null, designation: PropertyDesignationEnum, category: PropertyCategoryEnum, sub_category: PropertySubCategoryEnum, is_new_property?: boolean | null, tenure?: Tenure | null, total_floor_area?: number | null, town?: string | null, region?: string | null, address?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, geometry?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitGDV', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitOSMapPrint', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, archived?: boolean | null, site: { __typename?: 'Site', _id: string }, os_map_print: { __typename?: 'OSMapPrint', _id: string, created: any, url: string } } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string, site: { __typename?: 'Site', _id: string }, ownership_record: { __typename?: 'TitleOwnership', id: string, company?: { __typename?: 'Company', name?: string | null } | null, title?: { __typename?: 'Title', id: string, title_no?: string | null, tenure: TenureType } | null } } | { __typename?: 'SiteTidbitPlanningRecord', _id: string, site: { __typename?: 'Site', _id: string }, planning_record: { __typename?: 'Planning', ref: string } } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string, site: { __typename?: 'Site', _id: string }, pricepaid_record: { __typename?: 'Comparable', _id: string, address?: string | null, transaction_id: string, price_paid?: number | null, deed_date?: any | null, date_of_transfer?: any | null, postcode?: string | null, property_type?: string | null, new_build?: string | null, estate_type?: string | null, transaction_type?: string | null, total_floor_area?: number | null, paon?: string | null, saon?: string | null, street?: string | null, town?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, location?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitTitleDocument', _id: string, site: { __typename?: 'Site', _id: string }, title_document: { __typename?: 'TitlePlanDocument', _id: string, title_no: string, url: string } | { __typename?: 'TitleRegisterDocument', _id: string, title_no: string, url: string } } | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, comparable_transaction: { __typename?: 'ComparableV2', _id: string, transaction_id: string, price?: number | null, date_of_transfer?: any | null, post_code?: string | null, designation: PropertyDesignationEnum, category: PropertyCategoryEnum, sub_category: PropertySubCategoryEnum, is_new_property?: boolean | null, tenure?: Tenure | null, total_floor_area?: number | null, town?: string | null, region?: string | null, address?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, geometry?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitGDV', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitOSMapPrint', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, archived?: boolean | null, site: { __typename?: 'Site', _id: string }, os_map_print: { __typename?: 'OSMapPrint', _id: string, created: any, url: string } } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, ownership_record: { __typename?: 'TitleOwnership', id: string, company?: { __typename?: 'Company', name?: string | null } | null, title?: { __typename?: 'Title', id: string, title_no?: string | null, tenure: TenureType } | null } } | { __typename?: 'SiteTidbitPlanningRecord', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, planning_record: { __typename?: 'Planning', ref: string } } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, pricepaid_record: { __typename?: 'Comparable', _id: string, address?: string | null, transaction_id: string, price_paid?: number | null, deed_date?: any | null, date_of_transfer?: any | null, postcode?: string | null, property_type?: string | null, new_build?: string | null, estate_type?: string | null, transaction_type?: string | null, total_floor_area?: number | null, paon?: string | null, saon?: string | null, street?: string | null, town?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, location?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitTitleDocument', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, title_document: { __typename?: 'TitlePlanDocument', _id: string, title_no: string, url: string } | { __typename?: 'TitleRegisterDocument', _id: string, title_no: string, url: string } } | null, user?: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null, site?: { __typename?: 'Site', _id: string, source: { __typename?: 'SiteSourceCompsLayer', _id: string } | { __typename?: 'SiteSourceConstraintsLayer', _id: string } | { __typename?: 'SiteSourceDrawingTool', _id: string } | { __typename?: 'SiteSourceDrawingTools', drawingType: string, _id: string } | { __typename?: 'SiteSourceMobileApp', _id: string } | { __typename?: 'SiteSourceOwnershipLayer', _id: string } | { __typename?: 'SiteSourceOwnershipParcel', _id: string } | { __typename?: 'SiteSourceOwnershipSearch', _id: string } | { __typename?: 'SiteSourcePlanningAlertResult', _id: string } | { __typename?: 'SiteSourcePlanningLayer', _id: string } | { __typename?: 'SiteSourcePlanningPolicyLayer', _id: string } | { __typename?: 'SiteSourcePlanningSearch', _id: string } | { __typename?: 'SiteSourcePropertyInfoLayer', _id: string } | { __typename?: 'SiteSourcePropertySearch', _id: string } | { __typename?: 'SiteSourceSitesUploader', _id: string } | { __typename?: 'SiteSourceZoningLayer', _id: string } } | null }> | null } };

export type UpsertTidbitMutationVariables = Exact<{
  site_id: Scalars['String']['input'];
  file_name: Scalars['String']['input'];
}>;


export type UpsertTidbitMutation = { __typename?: 'Mutation', registerSiteAttachmentUpload: { __typename?: 'UpsertSiteTidbitResponse', tidbit?: { __typename?: 'SiteTidbitAlarm', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', _id: string, comment_body?: string | null, created: any, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null } | { __typename?: 'SiteTidbitAlert', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', _id: string, comment_body?: string | null, created: any, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null } | { __typename?: 'SiteTidbitAttachment', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, can_delete?: boolean | null, file_name: string, archived?: boolean | null, title?: string | null, extension?: string | null, source?: string | null, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', _id: string, comment_body?: string | null, created: any, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null, attachment?: { __typename?: 'UploadedFile', _id: string, signed_url: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null }, thumb_url?: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null } | null } | null, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitChecklist', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', _id: string, comment_body?: string | null, created: any, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null } | { __typename?: 'SiteTidbitComment', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', _id: string, comment_body?: string | null, created: any, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null } | { __typename?: 'SiteTidbitComparableTransaction', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', _id: string, comment_body?: string | null, created: any, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null } | { __typename?: 'SiteTidbitGDV', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', _id: string, comment_body?: string | null, created: any, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null } | { __typename?: 'SiteTidbitOSMapPrint', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', _id: string, comment_body?: string | null, created: any, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', _id: string, comment_body?: string | null, created: any, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null } | { __typename?: 'SiteTidbitPlanningRecord', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', _id: string, comment_body?: string | null, created: any, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', _id: string, comment_body?: string | null, created: any, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null } | { __typename?: 'SiteTidbitTitleDocument', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, site: { __typename?: 'Site', _id: string }, children?: Array<{ __typename?: 'SiteTidbitAlarm', _id: string } | { __typename?: 'SiteTidbitAlert', _id: string } | { __typename?: 'SiteTidbitAttachment', _id: string } | { __typename?: 'SiteTidbitChecklist', _id: string } | { __typename?: 'SiteTidbitComment', _id: string, comment_body?: string | null, created: any, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string } | { __typename?: 'SiteTidbitGDV', _id: string } | { __typename?: 'SiteTidbitOSMapPrint', _id: string } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string } | { __typename?: 'SiteTidbitPlanningRecord', _id: string } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string } | { __typename?: 'SiteTidbitTitleDocument', _id: string }> | null } | null, new_activity?: Array<{ __typename?: 'SiteActivityFieldUpdate', _id: string, timestamp?: any | null, changed_fields?: { __typename?: 'SiteActivityFieldUpdateFields', title?: { __typename?: 'SiteActivityFieldUpdateStringUpdate', old?: string | null, new?: string | null } | null, site_labels?: { __typename?: 'SiteActivityFieldUpdateSiteLabelUpdate', added?: { __typename?: 'SiteLabel', _id: string, name?: string | null } | null, removed?: { __typename?: 'SiteLabel', _id: string, name?: string | null } | null } | null, internal_status?: { __typename?: 'SiteActivityFieldUpdateIntUpdate', old?: number | null, new?: number | null } | null, hidden?: { __typename?: 'SiteActivityFieldUpdateHiddenUpdate', old?: boolean | null, new?: boolean | null } | null, priority?: { __typename?: 'SiteActivityFieldUpdatePriorityUpdate', old?: number | null, new?: number | null } | null, geometry?: { __typename?: 'SiteActivityFieldUpdateGeoJsonUpdate', new?: { __typename?: 'GeoJSONGeometry', type: string } | null } | null, notes?: { __typename?: 'SiteActivityFieldUpdateStringUpdate', new?: string | null } | null, stage?: { __typename?: 'SiteActivityFieldUpdateStageUpdate', old?: { __typename?: 'SiteStage', name?: string | null } | null, new?: { __typename?: 'SiteStage', name?: string | null } | null } | null, assignees?: { __typename?: 'SiteActivityFieldUpdateAssigneesUpdate', old: Array<{ __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null>, new: Array<{ __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null> } | null } | null, user?: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null, site?: { __typename?: 'Site', _id: string, source: { __typename?: 'SiteSourceCompsLayer', _id: string } | { __typename?: 'SiteSourceConstraintsLayer', _id: string } | { __typename?: 'SiteSourceDrawingTool', _id: string } | { __typename?: 'SiteSourceDrawingTools', drawingType: string, _id: string } | { __typename?: 'SiteSourceMobileApp', _id: string } | { __typename?: 'SiteSourceOwnershipLayer', _id: string } | { __typename?: 'SiteSourceOwnershipParcel', _id: string } | { __typename?: 'SiteSourceOwnershipSearch', _id: string } | { __typename?: 'SiteSourcePlanningAlertResult', _id: string } | { __typename?: 'SiteSourcePlanningLayer', _id: string } | { __typename?: 'SiteSourcePlanningPolicyLayer', _id: string } | { __typename?: 'SiteSourcePlanningSearch', _id: string } | { __typename?: 'SiteSourcePropertyInfoLayer', _id: string } | { __typename?: 'SiteSourcePropertySearch', _id: string } | { __typename?: 'SiteSourceSitesUploader', _id: string } | { __typename?: 'SiteSourceZoningLayer', _id: string } } | null } | { __typename?: 'SiteActivitySiteAction', verb?: string | null, _id: string, timestamp?: any | null, user?: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null, site?: { __typename?: 'Site', _id: string, source: { __typename?: 'SiteSourceCompsLayer', _id: string } | { __typename?: 'SiteSourceConstraintsLayer', _id: string } | { __typename?: 'SiteSourceDrawingTool', _id: string } | { __typename?: 'SiteSourceDrawingTools', drawingType: string, _id: string } | { __typename?: 'SiteSourceMobileApp', _id: string } | { __typename?: 'SiteSourceOwnershipLayer', _id: string } | { __typename?: 'SiteSourceOwnershipParcel', _id: string } | { __typename?: 'SiteSourceOwnershipSearch', _id: string } | { __typename?: 'SiteSourcePlanningAlertResult', _id: string } | { __typename?: 'SiteSourcePlanningLayer', _id: string } | { __typename?: 'SiteSourcePlanningPolicyLayer', _id: string } | { __typename?: 'SiteSourcePlanningSearch', _id: string } | { __typename?: 'SiteSourcePropertyInfoLayer', _id: string } | { __typename?: 'SiteSourcePropertySearch', _id: string } | { __typename?: 'SiteSourceSitesUploader', _id: string } | { __typename?: 'SiteSourceZoningLayer', _id: string } } | null } | { __typename?: 'SiteActivitySiteTidbit', verb?: string | null, _id: string, timestamp?: any | null, tidbit?: { __typename?: 'SiteTidbitAlarm', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAlert', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAttachment', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, can_delete?: boolean | null, created: any, modified: any, file_name: string, archived?: boolean | null, title?: string | null, extension?: string | null, source?: string | null, site: { __typename?: 'Site', _id: string }, attachment?: { __typename?: 'UploadedFile', _id: string, signed_url: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null }, thumb_url?: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null } | null } | null, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitChecklist', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComment', can_delete?: boolean | null, archived?: boolean | null, created: any, modified: any, comment_body?: string | null, _id: string, is_pinned?: boolean | null, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null }, parent?: { __typename?: 'SiteTidbitAlarm', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAlert', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAttachment', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, can_delete?: boolean | null, created: any, modified: any, file_name: string, archived?: boolean | null, title?: string | null, extension?: string | null, source?: string | null, site: { __typename?: 'Site', _id: string }, attachment?: { __typename?: 'UploadedFile', _id: string, signed_url: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null }, thumb_url?: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null } | null } | null, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitChecklist', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComment', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string, site: { __typename?: 'Site', _id: string }, comparable_transaction: { __typename?: 'ComparableV2', _id: string, transaction_id: string, price?: number | null, date_of_transfer?: any | null, post_code?: string | null, designation: PropertyDesignationEnum, category: PropertyCategoryEnum, sub_category: PropertySubCategoryEnum, is_new_property?: boolean | null, tenure?: Tenure | null, total_floor_area?: number | null, town?: string | null, region?: string | null, address?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, geometry?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitGDV', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitOSMapPrint', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, archived?: boolean | null, site: { __typename?: 'Site', _id: string }, os_map_print: { __typename?: 'OSMapPrint', _id: string, created: any, url: string } } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string, site: { __typename?: 'Site', _id: string }, ownership_record: { __typename?: 'TitleOwnership', id: string, company?: { __typename?: 'Company', name?: string | null } | null, title?: { __typename?: 'Title', id: string, title_no?: string | null, tenure: TenureType } | null } } | { __typename?: 'SiteTidbitPlanningRecord', _id: string, site: { __typename?: 'Site', _id: string }, planning_record: { __typename?: 'Planning', ref: string } } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string, site: { __typename?: 'Site', _id: string }, pricepaid_record: { __typename?: 'Comparable', _id: string, address?: string | null, transaction_id: string, price_paid?: number | null, deed_date?: any | null, date_of_transfer?: any | null, postcode?: string | null, property_type?: string | null, new_build?: string | null, estate_type?: string | null, transaction_type?: string | null, total_floor_area?: number | null, paon?: string | null, saon?: string | null, street?: string | null, town?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, location?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitTitleDocument', _id: string, site: { __typename?: 'Site', _id: string }, title_document: { __typename?: 'TitlePlanDocument', _id: string, title_no: string, url: string } | { __typename?: 'TitleRegisterDocument', _id: string, title_no: string, url: string } } | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, comparable_transaction: { __typename?: 'ComparableV2', _id: string, transaction_id: string, price?: number | null, date_of_transfer?: any | null, post_code?: string | null, designation: PropertyDesignationEnum, category: PropertyCategoryEnum, sub_category: PropertySubCategoryEnum, is_new_property?: boolean | null, tenure?: Tenure | null, total_floor_area?: number | null, town?: string | null, region?: string | null, address?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, geometry?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitGDV', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitOSMapPrint', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, archived?: boolean | null, site: { __typename?: 'Site', _id: string }, os_map_print: { __typename?: 'OSMapPrint', _id: string, created: any, url: string } } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, ownership_record: { __typename?: 'TitleOwnership', id: string, company?: { __typename?: 'Company', name?: string | null } | null, title?: { __typename?: 'Title', id: string, title_no?: string | null, tenure: TenureType } | null } } | { __typename?: 'SiteTidbitPlanningRecord', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, planning_record: { __typename?: 'Planning', ref: string } } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, pricepaid_record: { __typename?: 'Comparable', _id: string, address?: string | null, transaction_id: string, price_paid?: number | null, deed_date?: any | null, date_of_transfer?: any | null, postcode?: string | null, property_type?: string | null, new_build?: string | null, estate_type?: string | null, transaction_type?: string | null, total_floor_area?: number | null, paon?: string | null, saon?: string | null, street?: string | null, town?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, location?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitTitleDocument', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, title_document: { __typename?: 'TitlePlanDocument', _id: string, title_no: string, url: string } | { __typename?: 'TitleRegisterDocument', _id: string, title_no: string, url: string } } | null, user?: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null, site?: { __typename?: 'Site', _id: string, source: { __typename?: 'SiteSourceCompsLayer', _id: string } | { __typename?: 'SiteSourceConstraintsLayer', _id: string } | { __typename?: 'SiteSourceDrawingTool', _id: string } | { __typename?: 'SiteSourceDrawingTools', drawingType: string, _id: string } | { __typename?: 'SiteSourceMobileApp', _id: string } | { __typename?: 'SiteSourceOwnershipLayer', _id: string } | { __typename?: 'SiteSourceOwnershipParcel', _id: string } | { __typename?: 'SiteSourceOwnershipSearch', _id: string } | { __typename?: 'SiteSourcePlanningAlertResult', _id: string } | { __typename?: 'SiteSourcePlanningLayer', _id: string } | { __typename?: 'SiteSourcePlanningPolicyLayer', _id: string } | { __typename?: 'SiteSourcePlanningSearch', _id: string } | { __typename?: 'SiteSourcePropertyInfoLayer', _id: string } | { __typename?: 'SiteSourcePropertySearch', _id: string } | { __typename?: 'SiteSourceSitesUploader', _id: string } | { __typename?: 'SiteSourceZoningLayer', _id: string } } | null }> | null } };

export type SitesIntersectingQueryVariables = Exact<{
  geometry?: InputMaybe<GeoJsonGeometryInput>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SitesIntersectingQuery = { __typename?: 'Query', sites: { __typename?: 'SiteConnection', edges: Array<{ __typename?: 'SiteConnectionEdge', node: { __typename?: 'Site', _id: string, title?: string | null, hidden?: boolean | null, geometry?: { __typename?: 'GeoJSONGeometry', type: string, coordinates: any } | null, sharedByUser?: { __typename?: 'SharedByUser', _id: string } | null, _stage?: { __typename?: 'SiteStage', _id: string, color?: string | null, _workspace?: { __typename?: 'SiteStageWorkspace', id: string, title: string, developmentType: Array<DevelopmentType> } | null } | null } }> } };

export type AllSiteLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSiteLabelsQuery = { __typename?: 'Query', siteLabels?: Array<{ __typename?: 'SiteLabel', _id: string, name?: string | null } | null> | null };

export type GetAllAttachmentsQueryVariables = Exact<{
  siteId: Scalars['String']['input'];
}>;


export type GetAllAttachmentsQuery = { __typename?: 'Query', siteFileAttachments: Array<{ __typename: 'SiteTidbitAttachment', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, can_delete?: boolean | null, created: any, modified: any, file_name: string, archived?: boolean | null, title?: string | null, extension?: string | null, source?: string | null, attachment?: { __typename?: 'UploadedFile', _id: string, signed_url: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null }, thumb_url?: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null } | null } | null, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } }> };

export type GetPinnedItemsQueryVariables = Exact<{
  siteId: Scalars['String']['input'];
}>;


export type GetPinnedItemsQuery = { __typename?: 'Query', siteTidbits: Array<{ __typename: 'SiteTidbitAlarm', is_pinned?: boolean | null } | { __typename: 'SiteTidbitAlert', is_pinned?: boolean | null } | { __typename: 'SiteTidbitAttachment', _id: string, is_pinned?: boolean | null, can_delete?: boolean | null, created: any, file_name: string, title?: string | null, extension?: string | null, attachment?: { __typename?: 'UploadedFile', _id: string, signed_url: { __typename?: 'SignedUrl', url: string }, thumb_url?: { __typename?: 'SignedUrl', url: string, has_thumbnail?: boolean | null } | null } | null, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename: 'SiteTidbitChecklist', is_pinned?: boolean | null } | { __typename: 'SiteTidbitComment', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, can_delete?: boolean | null, created: any, modified: any, comment_body?: string | null, archived?: boolean | null, parent?: { __typename: 'SiteTidbitAlarm' } | { __typename: 'SiteTidbitAlert' } | { __typename: 'SiteTidbitAttachment', file_name: string } | { __typename: 'SiteTidbitChecklist' } | { __typename: 'SiteTidbitComment' } | { __typename: 'SiteTidbitComparableTransaction' } | { __typename: 'SiteTidbitGDV' } | { __typename: 'SiteTidbitOSMapPrint' } | { __typename: 'SiteTidbitOwnershipRecord' } | { __typename: 'SiteTidbitPlanningRecord' } | { __typename: 'SiteTidbitPricepaidRecord' } | { __typename: 'SiteTidbitTitleDocument' } | null, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null }, site: { __typename?: 'Site', _id: string, title?: string | null } } | { __typename: 'SiteTidbitComparableTransaction', is_pinned?: boolean | null } | { __typename: 'SiteTidbitGDV', is_pinned?: boolean | null } | { __typename: 'SiteTidbitOSMapPrint', is_pinned?: boolean | null } | { __typename: 'SiteTidbitOwnershipRecord', is_pinned?: boolean | null } | { __typename: 'SiteTidbitPlanningRecord', is_pinned?: boolean | null } | { __typename: 'SiteTidbitPricepaidRecord', is_pinned?: boolean | null } | { __typename: 'SiteTidbitTitleDocument', is_pinned?: boolean | null }> };

export type GetPurchasedDocumentsQueryVariables = Exact<{
  siteId: Scalars['String']['input'];
}>;


export type GetPurchasedDocumentsQuery = { __typename?: 'Query', site: { __typename?: 'Site', title_document_purchases: Array<{ __typename?: 'Transaction', purchase?: { __typename?: 'TransactionPurchase', type?: TransactionPurchaseType | null, title_document?: { __typename: 'TitlePlanDocument', _id: string, title_no: string, created: any, url: string } | { __typename: 'TitleRegisterDocument', _id: string, title_no: string, created: any, url: string } | null } | null } | null>, os_map_prints: Array<{ __typename: 'OSMapPrint', _id: string, orientation: string, page_size: string, scale: string, created: any, url: string } | null> } };

export type GetSignedAttachmentUrlQueryVariables = Exact<{
  attachment_id: Scalars['String']['input'];
  link_duration_minutes?: InputMaybe<Scalars['Int']['input']>;
  is_thumbnail?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetSignedAttachmentUrlQuery = { __typename?: 'Query', attachmentDownloadUrl?: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null } | null };

export type GetSiteAttachmentsQueryVariables = Exact<{
  siteId: Scalars['String']['input'];
}>;


export type GetSiteAttachmentsQuery = { __typename?: 'Query', siteTidbits: Array<{ __typename: 'SiteTidbitAlarm' } | { __typename: 'SiteTidbitAlert' } | { __typename: 'SiteTidbitAttachment', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, can_delete?: boolean | null, created: any, modified: any, file_name: string, archived?: boolean | null, title?: string | null, extension?: string | null, source?: string | null, attachment?: { __typename?: 'UploadedFile', _id: string, signed_url: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null }, thumb_url?: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null } | null } | null, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename: 'SiteTidbitChecklist' } | { __typename: 'SiteTidbitComment' } | { __typename: 'SiteTidbitComparableTransaction' } | { __typename: 'SiteTidbitGDV' } | { __typename: 'SiteTidbitOSMapPrint' } | { __typename: 'SiteTidbitOwnershipRecord' } | { __typename: 'SiteTidbitPlanningRecord' } | { __typename: 'SiteTidbitPricepaidRecord' } | { __typename: 'SiteTidbitTitleDocument' }> };

export type GetTeamMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTeamMembersQuery = { __typename?: 'Query', getTeamMembers: Array<{ __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null }> };

export type OwnershipSummaryQueryVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type OwnershipSummaryQuery = { __typename?: 'Query', ownershipSummary: { __typename?: 'Site', _id: string, totalNumberOfTitlesSummary?: string | null, geometry?: { __typename?: 'GeoJSONGeometry', type: string, coordinates: any } | null, location?: { __typename?: 'GeoJSONGeometry', type: string, coordinates: any } | null } };

export type SiteActivityQueryVariables = Exact<{
  _id: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  exclude_verbs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type SiteActivityQuery = { __typename?: 'Query', siteActivity: { __typename?: 'SiteActivityConnection', totalCount: number, nodes: Array<{ __typename?: 'SiteActivityFieldUpdate', _id: string, timestamp?: any | null, changed_fields?: { __typename?: 'SiteActivityFieldUpdateFields', title?: { __typename?: 'SiteActivityFieldUpdateStringUpdate', old?: string | null, new?: string | null } | null, site_labels?: { __typename?: 'SiteActivityFieldUpdateSiteLabelUpdate', added?: { __typename?: 'SiteLabel', _id: string, name?: string | null } | null, removed?: { __typename?: 'SiteLabel', _id: string, name?: string | null } | null } | null, internal_status?: { __typename?: 'SiteActivityFieldUpdateIntUpdate', old?: number | null, new?: number | null } | null, hidden?: { __typename?: 'SiteActivityFieldUpdateHiddenUpdate', old?: boolean | null, new?: boolean | null } | null, priority?: { __typename?: 'SiteActivityFieldUpdatePriorityUpdate', old?: number | null, new?: number | null } | null, geometry?: { __typename?: 'SiteActivityFieldUpdateGeoJsonUpdate', new?: { __typename?: 'GeoJSONGeometry', type: string } | null } | null, notes?: { __typename?: 'SiteActivityFieldUpdateStringUpdate', new?: string | null } | null, stage?: { __typename?: 'SiteActivityFieldUpdateStageUpdate', old?: { __typename?: 'SiteStage', name?: string | null } | null, new?: { __typename?: 'SiteStage', name?: string | null } | null } | null, assignees?: { __typename?: 'SiteActivityFieldUpdateAssigneesUpdate', old: Array<{ __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null>, new: Array<{ __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null> } | null } | null, user?: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null, site?: { __typename?: 'Site', _id: string, source: { __typename?: 'SiteSourceCompsLayer', _id: string } | { __typename?: 'SiteSourceConstraintsLayer', _id: string } | { __typename?: 'SiteSourceDrawingTool', _id: string } | { __typename?: 'SiteSourceDrawingTools', drawingType: string, _id: string } | { __typename?: 'SiteSourceMobileApp', _id: string } | { __typename?: 'SiteSourceOwnershipLayer', _id: string } | { __typename?: 'SiteSourceOwnershipParcel', _id: string } | { __typename?: 'SiteSourceOwnershipSearch', _id: string } | { __typename?: 'SiteSourcePlanningAlertResult', _id: string } | { __typename?: 'SiteSourcePlanningLayer', _id: string } | { __typename?: 'SiteSourcePlanningPolicyLayer', _id: string } | { __typename?: 'SiteSourcePlanningSearch', _id: string } | { __typename?: 'SiteSourcePropertyInfoLayer', _id: string } | { __typename?: 'SiteSourcePropertySearch', _id: string } | { __typename?: 'SiteSourceSitesUploader', _id: string } | { __typename?: 'SiteSourceZoningLayer', _id: string } } | null } | { __typename?: 'SiteActivitySiteAction', verb?: string | null, _id: string, timestamp?: any | null, user?: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null, site?: { __typename?: 'Site', _id: string, source: { __typename?: 'SiteSourceCompsLayer', _id: string } | { __typename?: 'SiteSourceConstraintsLayer', _id: string } | { __typename?: 'SiteSourceDrawingTool', _id: string } | { __typename?: 'SiteSourceDrawingTools', drawingType: string, _id: string } | { __typename?: 'SiteSourceMobileApp', _id: string } | { __typename?: 'SiteSourceOwnershipLayer', _id: string } | { __typename?: 'SiteSourceOwnershipParcel', _id: string } | { __typename?: 'SiteSourceOwnershipSearch', _id: string } | { __typename?: 'SiteSourcePlanningAlertResult', _id: string } | { __typename?: 'SiteSourcePlanningLayer', _id: string } | { __typename?: 'SiteSourcePlanningPolicyLayer', _id: string } | { __typename?: 'SiteSourcePlanningSearch', _id: string } | { __typename?: 'SiteSourcePropertyInfoLayer', _id: string } | { __typename?: 'SiteSourcePropertySearch', _id: string } | { __typename?: 'SiteSourceSitesUploader', _id: string } | { __typename?: 'SiteSourceZoningLayer', _id: string } } | null } | { __typename?: 'SiteActivitySiteTidbit', verb?: string | null, _id: string, timestamp?: any | null, tidbit?: { __typename?: 'SiteTidbitAlarm', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAlert', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAttachment', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, can_delete?: boolean | null, created: any, modified: any, file_name: string, archived?: boolean | null, title?: string | null, extension?: string | null, source?: string | null, site: { __typename?: 'Site', _id: string }, attachment?: { __typename?: 'UploadedFile', _id: string, signed_url: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null }, thumb_url?: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null } | null } | null, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitChecklist', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComment', can_delete?: boolean | null, archived?: boolean | null, created: any, modified: any, comment_body?: string | null, _id: string, is_pinned?: boolean | null, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null }, parent?: { __typename?: 'SiteTidbitAlarm', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAlert', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitAttachment', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, can_delete?: boolean | null, created: any, modified: any, file_name: string, archived?: boolean | null, title?: string | null, extension?: string | null, source?: string | null, site: { __typename?: 'Site', _id: string }, attachment?: { __typename?: 'UploadedFile', _id: string, signed_url: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null }, thumb_url?: { __typename?: 'SignedUrl', url: string, expires_at: any, has_thumbnail?: boolean | null } | null } | null, user: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } } | { __typename?: 'SiteTidbitChecklist', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComment', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string, site: { __typename?: 'Site', _id: string }, comparable_transaction: { __typename?: 'ComparableV2', _id: string, transaction_id: string, price?: number | null, date_of_transfer?: any | null, post_code?: string | null, designation: PropertyDesignationEnum, category: PropertyCategoryEnum, sub_category: PropertySubCategoryEnum, is_new_property?: boolean | null, tenure?: Tenure | null, total_floor_area?: number | null, town?: string | null, region?: string | null, address?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, geometry?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitGDV', _id: string, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitOSMapPrint', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, archived?: boolean | null, site: { __typename?: 'Site', _id: string }, os_map_print: { __typename?: 'OSMapPrint', _id: string, created: any, url: string } } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string, site: { __typename?: 'Site', _id: string }, ownership_record: { __typename?: 'TitleOwnership', id: string, company?: { __typename?: 'Company', name?: string | null } | null, title?: { __typename?: 'Title', id: string, title_no?: string | null, tenure: TenureType } | null } } | { __typename?: 'SiteTidbitPlanningRecord', _id: string, site: { __typename?: 'Site', _id: string }, planning_record: { __typename?: 'Planning', ref: string } } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string, site: { __typename?: 'Site', _id: string }, pricepaid_record: { __typename?: 'Comparable', _id: string, address?: string | null, transaction_id: string, price_paid?: number | null, deed_date?: any | null, date_of_transfer?: any | null, postcode?: string | null, property_type?: string | null, new_build?: string | null, estate_type?: string | null, transaction_type?: string | null, total_floor_area?: number | null, paon?: string | null, saon?: string | null, street?: string | null, town?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, location?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitTitleDocument', _id: string, site: { __typename?: 'Site', _id: string }, title_document: { __typename?: 'TitlePlanDocument', _id: string, title_no: string, url: string } | { __typename?: 'TitleRegisterDocument', _id: string, title_no: string, url: string } } | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitComparableTransaction', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, comparable_transaction: { __typename?: 'ComparableV2', _id: string, transaction_id: string, price?: number | null, date_of_transfer?: any | null, post_code?: string | null, designation: PropertyDesignationEnum, category: PropertyCategoryEnum, sub_category: PropertySubCategoryEnum, is_new_property?: boolean | null, tenure?: Tenure | null, total_floor_area?: number | null, town?: string | null, region?: string | null, address?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, geometry?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitGDV', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string } } | { __typename?: 'SiteTidbitOSMapPrint', _id: string, is_pinned?: boolean | null, is_hidden?: boolean | null, created: any, modified: any, archived?: boolean | null, site: { __typename?: 'Site', _id: string }, os_map_print: { __typename?: 'OSMapPrint', _id: string, created: any, url: string } } | { __typename?: 'SiteTidbitOwnershipRecord', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, ownership_record: { __typename?: 'TitleOwnership', id: string, company?: { __typename?: 'Company', name?: string | null } | null, title?: { __typename?: 'Title', id: string, title_no?: string | null, tenure: TenureType } | null } } | { __typename?: 'SiteTidbitPlanningRecord', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, planning_record: { __typename?: 'Planning', ref: string } } | { __typename?: 'SiteTidbitPricepaidRecord', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, pricepaid_record: { __typename?: 'Comparable', _id: string, address?: string | null, transaction_id: string, price_paid?: number | null, deed_date?: any | null, date_of_transfer?: any | null, postcode?: string | null, property_type?: string | null, new_build?: string | null, estate_type?: string | null, transaction_type?: string | null, total_floor_area?: number | null, paon?: string | null, saon?: string | null, street?: string | null, town?: string | null, num_bedrooms?: number | null, est_bedrooms?: Array<number | null> | null, est_price?: number | null, number_habitable_rooms?: number | null, location?: { __typename?: 'GeoJSONGeometry', coordinates: any } | null } } | { __typename?: 'SiteTidbitTitleDocument', _id: string, is_pinned?: boolean | null, site: { __typename?: 'Site', _id: string }, title_document: { __typename?: 'TitlePlanDocument', _id: string, title_no: string, url: string } | { __typename?: 'TitleRegisterDocument', _id: string, title_no: string, url: string } } | null, user?: { __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null } | null, site?: { __typename?: 'Site', _id: string, source: { __typename?: 'SiteSourceCompsLayer', _id: string } | { __typename?: 'SiteSourceConstraintsLayer', _id: string } | { __typename?: 'SiteSourceDrawingTool', _id: string } | { __typename?: 'SiteSourceDrawingTools', drawingType: string, _id: string } | { __typename?: 'SiteSourceMobileApp', _id: string } | { __typename?: 'SiteSourceOwnershipLayer', _id: string } | { __typename?: 'SiteSourceOwnershipParcel', _id: string } | { __typename?: 'SiteSourceOwnershipSearch', _id: string } | { __typename?: 'SiteSourcePlanningAlertResult', _id: string } | { __typename?: 'SiteSourcePlanningLayer', _id: string } | { __typename?: 'SiteSourcePlanningPolicyLayer', _id: string } | { __typename?: 'SiteSourcePlanningSearch', _id: string } | { __typename?: 'SiteSourcePropertyInfoLayer', _id: string } | { __typename?: 'SiteSourcePropertySearch', _id: string } | { __typename?: 'SiteSourceSitesUploader', _id: string } | { __typename?: 'SiteSourceZoningLayer', _id: string } } | null }>, pageInfo?: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null } | null } };

export type SiteAttachmentAntivirusScanStatusQueryVariables = Exact<{
  site_id: Scalars['String']['input'];
  file_name: Scalars['String']['input'];
}>;


export type SiteAttachmentAntivirusScanStatusQuery = { __typename?: 'Query', siteAttachmentAntivirusScanStatus?: { __typename?: 'SiteAttachmentAntivirusScanStatus', antivirusScanStatus?: string | null } | null };

export type SiteBoundaryImageBulkQueryVariables = Exact<{
  siteIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  stageIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  limit: Scalars['Int']['input'];
}>;


export type SiteBoundaryImageBulkQuery = { __typename?: 'Query', siteBoundaryImageBulk: { __typename?: 'SiteConnection', edges: Array<{ __typename?: 'SiteConnectionEdge', node: { __typename?: 'Site', _id: string, boundary_image: { __typename?: 'BoundaryImage', id: string, uri: string } } }> } };

export type SiteGeometryQueryVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type SiteGeometryQuery = { __typename?: 'Query', siteGeometry: { __typename?: 'Site', geometry?: { __typename?: 'GeoJSONGeometry', type: string, coordinates: any } | null } };

export type SiteImageQueryVariables = Exact<{
  siteId: Scalars['String']['input'];
  mapZoom: Scalars['Int']['input'];
}>;


export type SiteImageQuery = { __typename?: 'Query', siteImage: { __typename?: 'Site', _id: string, boundary_image: { __typename?: 'BoundaryImage', id: string, uri: string } } };

export type SiteLabelOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SiteLabelOptionsQuery = { __typename?: 'Query', siteLabelOptions?: Array<{ __typename?: 'SiteLabel', _id: string, name?: string | null } | null> | null };

export type SiteLocalAuthorityOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SiteLocalAuthorityOptionsQuery = { __typename?: 'Query', siteLocalAuthorityOptions?: Array<{ __typename?: 'PlanningAuthority', name?: string | null }> | null };

export type SiteMapQueryVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type SiteMapQuery = { __typename?: 'Query', siteMap: { __typename?: 'Site', _id: string, title?: string | null, notes?: string | null, geometry?: { __typename?: 'GeoJSONGeometry', type: string, coordinates: any } | null, location?: { __typename?: 'GeoJSONGeometry', type: string, coordinates: any } | null, _stage?: { __typename?: 'SiteStage', _id: string, color?: string | null } | null } };

export type SiteOverviewQueryVariables = Exact<{
  _id: Scalars['String']['input'];
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  includeSiteSummary?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SiteOverviewQuery = { __typename?: 'Query', siteOverview: { __typename?: 'Site', _id: string, title?: string | null, notes?: string | null, assignees?: Array<string> | null, ptal_rating?: string | null, local_authority?: string | null, use_classes_sep_2020?: Array<string | null> | null, use_classes?: Array<string | null> | null, average_building_height?: { __typename?: 'BuildingHeight', rel_h_to_roof?: number | null, rel_h_max?: number | null } | null, geometry?: { __typename?: 'GeoJSONGeometry', type: string, coordinates: any } | null, location?: { __typename?: 'GeoJSONGeometry', type: string, coordinates: any } | null, _stage?: { __typename?: 'SiteStage', color?: string | null, _id: string, name?: string | null } | null, sharedByUser?: { __typename?: 'SharedByUser', _id: string, firstname?: string | null, surname?: string | null, date?: any | null } | null, assignedUsers?: Array<{ __typename?: 'TeamUser', _id: string, firstname?: string | null, surname?: string | null }>, site_labels?: Array<{ __typename?: 'SiteLabel', _id: string, name?: string | null } | null> | null, source: { __typename?: 'SiteSourceCompsLayer', _id: string } | { __typename?: 'SiteSourceConstraintsLayer', _id: string } | { __typename?: 'SiteSourceDrawingTool', _id: string } | { __typename?: 'SiteSourceDrawingTools', _id: string } | { __typename?: 'SiteSourceMobileApp', _id: string } | { __typename?: 'SiteSourceOwnershipLayer', _id: string } | { __typename?: 'SiteSourceOwnershipParcel', _id: string } | { __typename?: 'SiteSourceOwnershipSearch', _id: string } | { __typename?: 'SiteSourcePlanningAlertResult', _id: string } | { __typename?: 'SiteSourcePlanningLayer', _id: string } | { __typename?: 'SiteSourcePlanningPolicyLayer', _id: string } | { __typename?: 'SiteSourcePlanningSearch', _id: string } | { __typename?: 'SiteSourcePropertyInfoLayer', _id: string } | { __typename?: 'SiteSourcePropertySearch', _id: string } | { __typename?: 'SiteSourceSitesUploader', _id: string } | { __typename?: 'SiteSourceZoningLayer', _id: string }, collaborators?: Array<{ __typename?: 'Collaborator', _id?: string | null, email: string, firstname?: string | null, surname?: string | null }> } };

export type SiteOverviewUsQueryVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type SiteOverviewUsQuery = { __typename?: 'Query', siteOverview: { __typename?: 'Site', _id: string, title?: string | null, notes?: string | null, ptal_rating?: string | null, local_authority?: string | null, use_classes_sep_2020?: Array<string | null> | null, use_classes?: Array<string | null> | null, average_building_height?: { __typename?: 'BuildingHeight', rel_h_to_roof?: number | null, rel_h_max?: number | null } | null, geometry?: { __typename?: 'GeoJSONGeometry', type: string, coordinates: any } | null, location?: { __typename?: 'GeoJSONGeometry', type: string, coordinates: any } | null, _stage?: { __typename?: 'SiteStage', _id: string, color?: string | null } | null } };

export type SiteStagesListQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SiteStagesListQuery = { __typename?: 'Query', siteStagesPaginated: { __typename?: 'SiteStageConnection', nodes: Array<{ __typename?: 'SiteStage', _id: string, name?: string | null, color?: string | null, hidden?: boolean | null, ref?: string | null }> } };

export type SitesSharedWithUserQueryVariables = Exact<{ [key: string]: never; }>;


export type SitesSharedWithUserQuery = { __typename?: 'Query', sitesSharedWithUser: Array<{ __typename?: 'Site', _id: string, title?: string | null, geometry?: { __typename?: 'GeoJSONGeometry', type: string, coordinates: any } | null, location?: { __typename?: 'GeoJSONGeometry', type: string, coordinates: any } | null, sharedByUser?: { __typename?: 'SharedByUser', _id: string, firstname?: string | null, surname?: string | null, date?: any | null } | null }> };

export type LetterCreditsQueryVariables = Exact<{ [key: string]: never; }>;


export type LetterCreditsQuery = { __typename?: 'Query', accountWithViews: { __typename?: 'Account', included_letter_send?: { __typename?: 'IncludedLetterSendCredit', cap?: number | null, used?: number | null } | null } };

export type SitesUploaderCreateSitesMutationVariables = Exact<{
  sites?: InputMaybe<Array<CreateSiteInput> | CreateSiteInput>;
  stageId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SitesUploaderCreateSitesMutation = { __typename?: 'Mutation', createSites?: Array<{ __typename?: 'SiteSaving', id?: string | null, status?: CreateSiteResponseStatus | null, saved_site?: { __typename?: 'Site', _id: string } | null } | null> | null };

export type SitesListArchiveSitesMutationVariables = Exact<{
  search?: InputMaybe<SiteSearchInput>;
  selection?: InputMaybe<SelectionInput>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  siteSort?: InputMaybe<SiteSorting>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SitesListArchiveSitesMutation = { __typename?: 'Mutation', archiveSites: { __typename?: 'SiteArchiveResponse', archived_items?: Array<{ __typename?: 'ArchivedItem', _id: string } | null> | null } };

export type SitesListSitesQueryVariables = Exact<{
  assignees?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  localAuthorities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  siteIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  siteLabels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  siteSort?: InputMaybe<SiteSorting>;
  stageIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  projectId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SitesListSitesQuery = { __typename?: 'Query', sites: { __typename?: 'SiteConnection', totalCount: number, edges: Array<{ __typename?: 'SiteConnectionEdge', _id: string, cursor: string, nextCursor?: string | null, previousCursor?: string | null, node: { __typename?: 'Site', _id: string, title?: string | null, notes?: string | null, hidden?: boolean | null, created?: any | null, priority?: number | null, site_labels?: Array<{ __typename?: 'SiteLabel', _id: string, name?: string | null } | null> | null, _stage?: { __typename?: 'SiteStage', _id: string, color?: string | null, name?: string | null, _workspace?: { __typename?: 'SiteStageWorkspace', id: string, title: string, developmentType: Array<DevelopmentType> } | null } | null } }>, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } | null } };

export type SitesListStagesQueryVariables = Exact<{
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SitesListStagesQuery = { __typename?: 'Query', siteStagesPaginated: { __typename?: 'SiteStageConnection', totalCount: number, edges: Array<{ __typename?: 'SiteStageConnectionEdge', node: { __typename?: 'SiteStage', _id: string, name?: string | null, color?: string | null, position_in_pipeline?: number | null } }>, pageInfo?: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null, startCursor?: string | null } | null } };

export type SitesListTotalSiteCountQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SitesListTotalSiteCountQuery = { __typename?: 'Query', totalSiteCount?: number | null };

export type SitesListUpdateSitesMutationVariables = Exact<{
  search?: InputMaybe<SiteSearchInput>;
  selection?: InputMaybe<SelectionInput>;
  siteUpdate: SiteUpdate;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  siteSort?: InputMaybe<SiteSorting>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SitesListUpdateSitesMutation = { __typename?: 'Mutation', updateSelectedSites?: Array<{ __typename?: 'SiteUpdateResponse', site: { __typename?: 'Site', _id: string, title?: string | null, notes?: string | null, hidden?: boolean | null, position_in_stage?: number | null, created?: any | null, priority?: number | null, assignees?: Array<string> | null, site_labels?: Array<{ __typename?: 'SiteLabel', _id: string, name?: string | null } | null> | null, _stage?: { __typename?: 'SiteStage', _id: string } | null } } | null> | null };

export type SkipTracingCreditsQueryVariables = Exact<{ [key: string]: never; }>;


export type SkipTracingCreditsQuery = { __typename?: 'Query', accountWithViews: { __typename?: 'Account', skip_traces?: { __typename?: 'SkipTracesCredit', cap?: number | null, used?: number | null } | null } };

export type SkipTracingSitesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  stageIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type SkipTracingSitesQuery = { __typename?: 'Query', sites: { __typename?: 'SiteConnection', totalCount: number, edges: Array<{ __typename?: 'SiteConnectionEdge', _id: string, cursor: string, nextCursor?: string | null, previousCursor?: string | null, node: { __typename?: 'Site', _id: string, title?: string | null, address?: string | null, geometry?: { __typename?: 'GeoJSONGeometry', type: string, coordinates: any } | null, titles?: Array<{ __typename?: 'Title', id: string, title_no?: string | null, parcel_identifier?: string | null, polygons?: Array<{ __typename?: 'TitlePoly', geometry: { __typename?: 'GeoJSONGeometry', type: string, coordinates: any } }> | null, owners?: Array<{ __typename?: 'TitleOwnership', company?: { __typename?: 'Company', name?: string | null } | null, person?: { __typename?: 'Person', name?: string | null } | null }> | null }> | null } }>, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } | null } };

export const CommentTidbitFragmentFragmentDoc = gql`
    fragment CommentTidbitFragment on SiteTidbitComment {
  user {
    _id
    firstname
    surname
  }
  comment_body
  created
}
    `;
export const CoreTidbitFragmentFragmentDoc = gql`
    fragment CoreTidbitFragment on SiteTidbit {
  _id
  is_pinned
  is_hidden
  created
  modified
  site {
    _id
  }
  children {
    _id
    ...CommentTidbitFragment
  }
}
    ${CommentTidbitFragmentFragmentDoc}`;
export const OsMapPrintPurchasedFragmentFragmentDoc = gql`
    fragment OSMapPrintPurchasedFragment on OSMapPrint {
  _id
  __typename
  orientation
  page_size
  scale
  created
  url
}
    `;
export const PurchaseFragmentFragmentDoc = gql`
    fragment PurchaseFragment on Transaction {
  purchase {
    title_document {
      _id
      __typename
      title_no
      created
      url
    }
    type
  }
}
    `;
export const ActivityPlanningRecordFragmentDoc = gql`
    fragment ActivityPlanningRecord on SiteTidbitPlanningRecord {
  _id
  planning_record {
    ref
  }
}
    `;
export const ActivityOwnershipRecordFragmentDoc = gql`
    fragment ActivityOwnershipRecord on SiteTidbitOwnershipRecord {
  _id
  ownership_record {
    id
    company {
      name
    }
    title {
      id
      title_no
      tenure
    }
  }
}
    `;
export const PricepaidRecordTidbitFragmentFragmentDoc = gql`
    fragment PricepaidRecordTidbitFragment on SiteTidbitPricepaidRecord {
  pricepaid_record {
    _id
    address
    transaction_id
    price_paid
    deed_date
    date_of_transfer
    postcode
    property_type
    new_build
    estate_type
    transaction_type
    total_floor_area
    location {
      coordinates
    }
    paon
    saon
    street
    town
    num_bedrooms
    est_bedrooms
    est_price
    number_habitable_rooms
  }
}
    `;
export const ComparableTransactionTidbitFragmentFragmentDoc = gql`
    fragment ComparableTransactionTidbitFragment on SiteTidbitComparableTransaction {
  comparable_transaction {
    _id
    transaction_id
    price
    date_of_transfer
    post_code
    designation
    category
    sub_category
    is_new_property
    tenure
    total_floor_area
    geometry {
      coordinates
    }
    town
    region
    address
    num_bedrooms
    est_bedrooms
    est_price
    number_habitable_rooms
  }
}
    `;
export const AttachmentTidbitDocFragmentFragmentDoc = gql`
    fragment AttachmentTidbitDocFragment on SiteTidbitAttachment {
  _id
  is_pinned
  is_hidden
  can_delete
  created
  modified
  file_name
  archived
  title
  extension
  source
  attachment {
    _id
    signed_url {
      url
      expires_at
      has_thumbnail
    }
    thumb_url {
      url
      expires_at
      has_thumbnail
    }
  }
  user {
    _id
    firstname
    surname
  }
}
    `;
export const OsMapPrintTidbitActivityFragmentFragmentDoc = gql`
    fragment OSMapPrintTidbitActivityFragment on SiteTidbitOSMapPrint {
  _id
  is_pinned
  is_hidden
  created
  modified
  archived
  os_map_print {
    _id
    created
    url
  }
}
    `;
export const TitleDocumentTidbitFragmentFragmentDoc = gql`
    fragment TitleDocumentTidbitFragment on SiteTidbitTitleDocument {
  title_document {
    _id
    title_no
    url
  }
}
    `;
export const SiteActivityFragmentFragmentDoc = gql`
    fragment SiteActivityFragment on SiteActivity {
  _id
  timestamp
  user {
    _id
    firstname
    surname
  }
  site {
    _id
    source {
      _id
      ... on SiteSourceDrawingTools {
        drawingType
      }
    }
  }
  ... on SiteActivitySiteAction {
    verb
  }
  ... on SiteActivityFieldUpdate {
    changed_fields {
      title {
        old
        new
      }
      site_labels {
        added {
          _id
          name
        }
        removed {
          _id
          name
        }
      }
      internal_status {
        old
        new
      }
      hidden {
        old
        new
      }
      priority {
        old
        new
      }
      geometry {
        new {
          type
        }
      }
      notes {
        new
      }
      stage {
        old {
          name
        }
        new {
          name
        }
      }
      assignees {
        old {
          _id
          firstname
          surname
        }
        new {
          _id
          firstname
          surname
        }
      }
    }
  }
  ... on SiteActivitySiteTidbit {
    verb
    tidbit {
      _id
      site {
        _id
      }
      is_pinned
      ...ActivityPlanningRecord
      ...ActivityOwnershipRecord
      ...PricepaidRecordTidbitFragment
      ...ComparableTransactionTidbitFragment
      ...AttachmentTidbitDocFragment
      ...OSMapPrintTidbitActivityFragment
      ...TitleDocumentTidbitFragment
      ... on SiteTidbitComment {
        can_delete
        archived
        created
        modified
        comment_body
        user {
          _id
          firstname
          surname
        }
        parent {
          _id
          site {
            _id
          }
          ...ActivityPlanningRecord
          ...ActivityOwnershipRecord
          ...PricepaidRecordTidbitFragment
          ...ComparableTransactionTidbitFragment
          ...AttachmentTidbitDocFragment
          ...OSMapPrintTidbitActivityFragment
          ...TitleDocumentTidbitFragment
        }
      }
    }
  }
}
    ${ActivityPlanningRecordFragmentDoc}
${ActivityOwnershipRecordFragmentDoc}
${PricepaidRecordTidbitFragmentFragmentDoc}
${ComparableTransactionTidbitFragmentFragmentDoc}
${AttachmentTidbitDocFragmentFragmentDoc}
${OsMapPrintTidbitActivityFragmentFragmentDoc}
${TitleDocumentTidbitFragmentFragmentDoc}`;
export const TitleRegisterDocumentFragmentFragmentDoc = gql`
    fragment TitleRegisterDocumentFragment on TitleRegisterDocument {
  _id
  title_no
  url
  created
}
    `;
export const TitlePlanDocumentFragmentFragmentDoc = gql`
    fragment TitlePlanDocumentFragment on TitlePlanDocument {
  _id
  title_no
  url
  created
}
    `;
export const SiteTidbitTitleDocumentFragmentFragmentDoc = gql`
    fragment SiteTidbitTitleDocumentFragment on SiteTidbitTitleDocument {
  _id
  is_pinned
  is_hidden
  created
  modified
  archived
  title_document {
    _id
    title_no
    url
    ...TitleRegisterDocumentFragment
    ...TitlePlanDocumentFragment
  }
}
    ${TitleRegisterDocumentFragmentFragmentDoc}
${TitlePlanDocumentFragmentFragmentDoc}`;
export const TidbitUpdateFragmentFragmentDoc = gql`
    fragment TidbitUpdateFragment on SiteTidbit {
  _id
  is_pinned
  is_hidden
  created
  modified
  site {
    _id
  }
  children {
    _id
    ... on SiteTidbitComment {
      user {
        _id
        firstname
        surname
      }
      comment_body
      created
    }
  }
}
    `;
export const CreateSiteStageDocument = gql`
    mutation createSiteStage($stageCreation: SiteStageCreation!) {
  createSiteStage(stageCreation: $stageCreation) {
    _id
    name
    color
    position_in_pipeline
    hidden
    ref
    _sites {
      totalCount
      nodes {
        _id
        title
        notes
        site_labels {
          _id
          name
        }
        hidden
        position_in_stage
        created
        _stage {
          _id
        }
      }
      pageInfo {
        hasNextPage
        endCursor
        startCursor
      }
    }
  }
}
    `;
export type CreateSiteStageMutationFn = Apollo.MutationFunction<CreateSiteStageMutation, CreateSiteStageMutationVariables>;

/**
 * __useCreateSiteStageMutation__
 *
 * To run a mutation, you first call `useCreateSiteStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSiteStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSiteStageMutation, { data, loading, error }] = useCreateSiteStageMutation({
 *   variables: {
 *      stageCreation: // value for 'stageCreation'
 *   },
 * });
 */
export function useCreateSiteStageMutation(baseOptions?: Apollo.MutationHookOptions<CreateSiteStageMutation, CreateSiteStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSiteStageMutation, CreateSiteStageMutationVariables>(CreateSiteStageDocument, options);
      }
export type CreateSiteStageMutationHookResult = ReturnType<typeof useCreateSiteStageMutation>;
export type CreateSiteStageMutationResult = Apollo.MutationResult<CreateSiteStageMutation>;
export type CreateSiteStageMutationOptions = Apollo.BaseMutationOptions<CreateSiteStageMutation, CreateSiteStageMutationVariables>;
export const ArchiveSiteDocument = gql`
    mutation archiveSite($_id: String!) {
  archiveSite(_id: $_id) {
    archived_items {
      _id
    }
  }
}
    `;
export type ArchiveSiteMutationFn = Apollo.MutationFunction<ArchiveSiteMutation, ArchiveSiteMutationVariables>;

/**
 * __useArchiveSiteMutation__
 *
 * To run a mutation, you first call `useArchiveSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveSiteMutation, { data, loading, error }] = useArchiveSiteMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useArchiveSiteMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveSiteMutation, ArchiveSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveSiteMutation, ArchiveSiteMutationVariables>(ArchiveSiteDocument, options);
      }
export type ArchiveSiteMutationHookResult = ReturnType<typeof useArchiveSiteMutation>;
export type ArchiveSiteMutationResult = Apollo.MutationResult<ArchiveSiteMutation>;
export type ArchiveSiteMutationOptions = Apollo.BaseMutationOptions<ArchiveSiteMutation, ArchiveSiteMutationVariables>;
export const DeleteSitesDocument = gql`
    mutation deleteSites($search: SiteSearchInput, $selection: SelectionInput, $includeHidden: Boolean, $siteSort: SiteSorting, $limit: Int) {
  archiveSites(
    search: $search
    selection: $selection
    includeHidden: $includeHidden
    siteSort: $siteSort
    limit: $limit
  ) {
    archived_items {
      _id
    }
  }
}
    `;
export type DeleteSitesMutationFn = Apollo.MutationFunction<DeleteSitesMutation, DeleteSitesMutationVariables>;

/**
 * __useDeleteSitesMutation__
 *
 * To run a mutation, you first call `useDeleteSitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSitesMutation, { data, loading, error }] = useDeleteSitesMutation({
 *   variables: {
 *      search: // value for 'search'
 *      selection: // value for 'selection'
 *      includeHidden: // value for 'includeHidden'
 *      siteSort: // value for 'siteSort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useDeleteSitesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSitesMutation, DeleteSitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSitesMutation, DeleteSitesMutationVariables>(DeleteSitesDocument, options);
      }
export type DeleteSitesMutationHookResult = ReturnType<typeof useDeleteSitesMutation>;
export type DeleteSitesMutationResult = Apollo.MutationResult<DeleteSitesMutation>;
export type DeleteSitesMutationOptions = Apollo.BaseMutationOptions<DeleteSitesMutation, DeleteSitesMutationVariables>;
export const ArchiveSiteStageDocument = gql`
    mutation archiveSiteStage($_id: String!) {
  archiveSiteStage(_id: $_id) {
    _id
    typename
  }
}
    `;
export type ArchiveSiteStageMutationFn = Apollo.MutationFunction<ArchiveSiteStageMutation, ArchiveSiteStageMutationVariables>;

/**
 * __useArchiveSiteStageMutation__
 *
 * To run a mutation, you first call `useArchiveSiteStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveSiteStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveSiteStageMutation, { data, loading, error }] = useArchiveSiteStageMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useArchiveSiteStageMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveSiteStageMutation, ArchiveSiteStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveSiteStageMutation, ArchiveSiteStageMutationVariables>(ArchiveSiteStageDocument, options);
      }
export type ArchiveSiteStageMutationHookResult = ReturnType<typeof useArchiveSiteStageMutation>;
export type ArchiveSiteStageMutationResult = Apollo.MutationResult<ArchiveSiteStageMutation>;
export type ArchiveSiteStageMutationOptions = Apollo.BaseMutationOptions<ArchiveSiteStageMutation, ArchiveSiteStageMutationVariables>;
export const DeleteStageSitesDocument = gql`
    mutation deleteStageSites($_stage: String!, $siteLabels: [ID], $assignees: [ID], $siteName: String, $includeHidden: Boolean, $filters: Filters) {
  archiveSites(
    _stage: $_stage
    siteLabels: $siteLabels
    assignees: $assignees
    siteName: $siteName
    includeHidden: $includeHidden
    filters: $filters
  ) {
    archived_items {
      __typename
      _id
    }
  }
}
    `;
export type DeleteStageSitesMutationFn = Apollo.MutationFunction<DeleteStageSitesMutation, DeleteStageSitesMutationVariables>;

/**
 * __useDeleteStageSitesMutation__
 *
 * To run a mutation, you first call `useDeleteStageSitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStageSitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStageSitesMutation, { data, loading, error }] = useDeleteStageSitesMutation({
 *   variables: {
 *      _stage: // value for '_stage'
 *      siteLabels: // value for 'siteLabels'
 *      assignees: // value for 'assignees'
 *      siteName: // value for 'siteName'
 *      includeHidden: // value for 'includeHidden'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useDeleteStageSitesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStageSitesMutation, DeleteStageSitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStageSitesMutation, DeleteStageSitesMutationVariables>(DeleteStageSitesDocument, options);
      }
export type DeleteStageSitesMutationHookResult = ReturnType<typeof useDeleteStageSitesMutation>;
export type DeleteStageSitesMutationResult = Apollo.MutationResult<DeleteStageSitesMutation>;
export type DeleteStageSitesMutationOptions = Apollo.BaseMutationOptions<DeleteStageSitesMutation, DeleteStageSitesMutationVariables>;
export const MoveAllSitesToStageDocument = gql`
    mutation moveAllSitesToStage($stageFrom: String!, $stageTo: String!, $siteLabels: [ID], $assignees: [ID], $siteName: String, $includeHidden: Boolean, $filters: Filters) {
  moveAllSitesToStage(
    _stageFrom: $stageFrom
    _stageTo: $stageTo
    siteLabels: $siteLabels
    assignees: $assignees
    siteName: $siteName
    includeHidden: $includeHidden
    filters: $filters
  ) {
    site {
      _id
      title
      notes
      site_labels {
        _id
        name
      }
      hidden
      position_in_stage
      created
      priority
      assignees
      _stage {
        _id
      }
    }
  }
}
    `;
export type MoveAllSitesToStageMutationFn = Apollo.MutationFunction<MoveAllSitesToStageMutation, MoveAllSitesToStageMutationVariables>;

/**
 * __useMoveAllSitesToStageMutation__
 *
 * To run a mutation, you first call `useMoveAllSitesToStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveAllSitesToStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveAllSitesToStageMutation, { data, loading, error }] = useMoveAllSitesToStageMutation({
 *   variables: {
 *      stageFrom: // value for 'stageFrom'
 *      stageTo: // value for 'stageTo'
 *      siteLabels: // value for 'siteLabels'
 *      assignees: // value for 'assignees'
 *      siteName: // value for 'siteName'
 *      includeHidden: // value for 'includeHidden'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useMoveAllSitesToStageMutation(baseOptions?: Apollo.MutationHookOptions<MoveAllSitesToStageMutation, MoveAllSitesToStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveAllSitesToStageMutation, MoveAllSitesToStageMutationVariables>(MoveAllSitesToStageDocument, options);
      }
export type MoveAllSitesToStageMutationHookResult = ReturnType<typeof useMoveAllSitesToStageMutation>;
export type MoveAllSitesToStageMutationResult = Apollo.MutationResult<MoveAllSitesToStageMutation>;
export type MoveAllSitesToStageMutationOptions = Apollo.BaseMutationOptions<MoveAllSitesToStageMutation, MoveAllSitesToStageMutationVariables>;
export const UpdateSiteStageDocument = gql`
    mutation updateSiteStage($stageUpdate: SiteStageUpdate!) {
  updateSiteStage(updateData: $stageUpdate) {
    _id
  }
}
    `;
export type UpdateSiteStageMutationFn = Apollo.MutationFunction<UpdateSiteStageMutation, UpdateSiteStageMutationVariables>;

/**
 * __useUpdateSiteStageMutation__
 *
 * To run a mutation, you first call `useUpdateSiteStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteStageMutation, { data, loading, error }] = useUpdateSiteStageMutation({
 *   variables: {
 *      stageUpdate: // value for 'stageUpdate'
 *   },
 * });
 */
export function useUpdateSiteStageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteStageMutation, UpdateSiteStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteStageMutation, UpdateSiteStageMutationVariables>(UpdateSiteStageDocument, options);
      }
export type UpdateSiteStageMutationHookResult = ReturnType<typeof useUpdateSiteStageMutation>;
export type UpdateSiteStageMutationResult = Apollo.MutationResult<UpdateSiteStageMutation>;
export type UpdateSiteStageMutationOptions = Apollo.BaseMutationOptions<UpdateSiteStageMutation, UpdateSiteStageMutationVariables>;
export const UpdateAllSitesInStageDocument = gql`
    mutation updateAllSitesInStage($stageId: String!, $updateData: SiteUpdate!, $includeHidden: Boolean) {
  updateAllSitesInStage(
    stageId: $stageId
    updateData: $updateData
    includeHidden: $includeHidden
  ) {
    site {
      _id
      title
      notes
      site_labels {
        _id
        name
      }
      hidden
      position_in_stage
      created
      priority
      assignees
      _stage {
        _id
      }
    }
  }
}
    `;
export type UpdateAllSitesInStageMutationFn = Apollo.MutationFunction<UpdateAllSitesInStageMutation, UpdateAllSitesInStageMutationVariables>;

/**
 * __useUpdateAllSitesInStageMutation__
 *
 * To run a mutation, you first call `useUpdateAllSitesInStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllSitesInStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllSitesInStageMutation, { data, loading, error }] = useUpdateAllSitesInStageMutation({
 *   variables: {
 *      stageId: // value for 'stageId'
 *      updateData: // value for 'updateData'
 *      includeHidden: // value for 'includeHidden'
 *   },
 * });
 */
export function useUpdateAllSitesInStageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAllSitesInStageMutation, UpdateAllSitesInStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAllSitesInStageMutation, UpdateAllSitesInStageMutationVariables>(UpdateAllSitesInStageDocument, options);
      }
export type UpdateAllSitesInStageMutationHookResult = ReturnType<typeof useUpdateAllSitesInStageMutation>;
export type UpdateAllSitesInStageMutationResult = Apollo.MutationResult<UpdateAllSitesInStageMutation>;
export type UpdateAllSitesInStageMutationOptions = Apollo.BaseMutationOptions<UpdateAllSitesInStageMutation, UpdateAllSitesInStageMutationVariables>;
export const UpdateSelectedSitesDocument = gql`
    mutation updateSelectedSites($search: SiteSearchInput, $selection: SelectionInput, $siteUpdate: SiteUpdate!, $includeHidden: Boolean, $siteSort: SiteSorting, $limit: Int) {
  updateSelectedSites(
    search: $search
    selection: $selection
    updateData: $siteUpdate
    includeHidden: $includeHidden
    siteSort: $siteSort
    limit: $limit
  ) {
    site {
      _id
      title
      notes
      site_labels {
        _id
        name
      }
      hidden
      position_in_stage
      created
      priority
      assignees
      _stage {
        _id
      }
    }
  }
}
    `;
export type UpdateSelectedSitesMutationFn = Apollo.MutationFunction<UpdateSelectedSitesMutation, UpdateSelectedSitesMutationVariables>;

/**
 * __useUpdateSelectedSitesMutation__
 *
 * To run a mutation, you first call `useUpdateSelectedSitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSelectedSitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSelectedSitesMutation, { data, loading, error }] = useUpdateSelectedSitesMutation({
 *   variables: {
 *      search: // value for 'search'
 *      selection: // value for 'selection'
 *      siteUpdate: // value for 'siteUpdate'
 *      includeHidden: // value for 'includeHidden'
 *      siteSort: // value for 'siteSort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUpdateSelectedSitesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSelectedSitesMutation, UpdateSelectedSitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSelectedSitesMutation, UpdateSelectedSitesMutationVariables>(UpdateSelectedSitesDocument, options);
      }
export type UpdateSelectedSitesMutationHookResult = ReturnType<typeof useUpdateSelectedSitesMutation>;
export type UpdateSelectedSitesMutationResult = Apollo.MutationResult<UpdateSelectedSitesMutation>;
export type UpdateSelectedSitesMutationOptions = Apollo.BaseMutationOptions<UpdateSelectedSitesMutation, UpdateSelectedSitesMutationVariables>;
export const UpdateSiteStagesDocument = gql`
    mutation updateSiteStages($stageUpdates: [SiteStageUpdate!]!) {
  updateSiteStages(updateData: $stageUpdates) {
    _id
    position_in_pipeline
  }
}
    `;
export type UpdateSiteStagesMutationFn = Apollo.MutationFunction<UpdateSiteStagesMutation, UpdateSiteStagesMutationVariables>;

/**
 * __useUpdateSiteStagesMutation__
 *
 * To run a mutation, you first call `useUpdateSiteStagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteStagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteStagesMutation, { data, loading, error }] = useUpdateSiteStagesMutation({
 *   variables: {
 *      stageUpdates: // value for 'stageUpdates'
 *   },
 * });
 */
export function useUpdateSiteStagesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteStagesMutation, UpdateSiteStagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteStagesMutation, UpdateSiteStagesMutationVariables>(UpdateSiteStagesDocument, options);
      }
export type UpdateSiteStagesMutationHookResult = ReturnType<typeof useUpdateSiteStagesMutation>;
export type UpdateSiteStagesMutationResult = Apollo.MutationResult<UpdateSiteStagesMutation>;
export type UpdateSiteStagesMutationOptions = Apollo.BaseMutationOptions<UpdateSiteStagesMutation, UpdateSiteStagesMutationVariables>;
export const UpdateSitesDocument = gql`
    mutation updateSites($siteUpdates: [SiteUpdate!]!) {
  updateSites(updateData: $siteUpdates) {
    site {
      _id
      title
      notes
      site_labels {
        _id
        name
      }
      hidden
      geometry {
        type
        coordinates
      }
      position_in_stage
      local_authority
      created
      priority
      local_authority
      assignees
      _stage {
        _id
      }
      assignees
    }
  }
}
    `;
export type UpdateSitesMutationFn = Apollo.MutationFunction<UpdateSitesMutation, UpdateSitesMutationVariables>;

/**
 * __useUpdateSitesMutation__
 *
 * To run a mutation, you first call `useUpdateSitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSitesMutation, { data, loading, error }] = useUpdateSitesMutation({
 *   variables: {
 *      siteUpdates: // value for 'siteUpdates'
 *   },
 * });
 */
export function useUpdateSitesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSitesMutation, UpdateSitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSitesMutation, UpdateSitesMutationVariables>(UpdateSitesDocument, options);
      }
export type UpdateSitesMutationHookResult = ReturnType<typeof useUpdateSitesMutation>;
export type UpdateSitesMutationResult = Apollo.MutationResult<UpdateSitesMutation>;
export type UpdateSitesMutationOptions = Apollo.BaseMutationOptions<UpdateSitesMutation, UpdateSitesMutationVariables>;
export const SiteStagesVueDocument = gql`
    query siteStagesVue($isStagesView: Boolean!, $stageId: String, $stageIds: [String], $projectId: String, $siteLabels: [ID], $includeHidden: Boolean, $siteLimit: Int, $stageLimit: Int, $siteCursor: String, $stageCursor: String, $assignees: [ID], $siteName: String, $filters: Filters) {
  siteStages: siteStagesPaginated(
    _id: $stageId
    stageIds: $stageIds
    projectId: $projectId
    includeHidden: $includeHidden
    cursor: $stageCursor
    limit: $stageLimit
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
      startCursor
    }
    nodes {
      _id
      name
      color
      position_in_pipeline
      hidden
      ref
      _sites(
        limit: $siteLimit
        cursor: $siteCursor
        siteLabels: $siteLabels
        includeHidden: $includeHidden
        assignees: $assignees
        siteName: $siteName
        filters: $filters
      ) @include(if: $isStagesView) {
        totalCount
        nodes {
          _id
          title
          notes
          source {
            _id
          }
          site_labels {
            _id
            name
          }
          hidden
          position_in_stage
          local_authority
          created
          priority
          _stage {
            _id
          }
          assignees
        }
        pageInfo {
          hasNextPage
          endCursor
          startCursor
        }
      }
    }
  }
}
    `;

/**
 * __useSiteStagesVueQuery__
 *
 * To run a query within a React component, call `useSiteStagesVueQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteStagesVueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteStagesVueQuery({
 *   variables: {
 *      isStagesView: // value for 'isStagesView'
 *      stageId: // value for 'stageId'
 *      stageIds: // value for 'stageIds'
 *      projectId: // value for 'projectId'
 *      siteLabels: // value for 'siteLabels'
 *      includeHidden: // value for 'includeHidden'
 *      siteLimit: // value for 'siteLimit'
 *      stageLimit: // value for 'stageLimit'
 *      siteCursor: // value for 'siteCursor'
 *      stageCursor: // value for 'stageCursor'
 *      assignees: // value for 'assignees'
 *      siteName: // value for 'siteName'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSiteStagesVueQuery(baseOptions: Apollo.QueryHookOptions<SiteStagesVueQuery, SiteStagesVueQueryVariables> & ({ variables: SiteStagesVueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteStagesVueQuery, SiteStagesVueQueryVariables>(SiteStagesVueDocument, options);
      }
export function useSiteStagesVueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteStagesVueQuery, SiteStagesVueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteStagesVueQuery, SiteStagesVueQueryVariables>(SiteStagesVueDocument, options);
        }
export function useSiteStagesVueSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SiteStagesVueQuery, SiteStagesVueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiteStagesVueQuery, SiteStagesVueQueryVariables>(SiteStagesVueDocument, options);
        }
export type SiteStagesVueQueryHookResult = ReturnType<typeof useSiteStagesVueQuery>;
export type SiteStagesVueLazyQueryHookResult = ReturnType<typeof useSiteStagesVueLazyQuery>;
export type SiteStagesVueSuspenseQueryHookResult = ReturnType<typeof useSiteStagesVueSuspenseQuery>;
export type SiteStagesVueQueryResult = Apollo.QueryResult<SiteStagesVueQuery, SiteStagesVueQueryVariables>;
export const SitesDocument = gql`
    query sites($search: SiteSearchInput, $limit: Int, $cursor: String, $siteSort: SiteSorting, $includeHidden: Boolean) {
  sites: siteSearch(
    search: $search
    limit: $limit
    cursor: $cursor
    siteSort: $siteSort
    includeHidden: $includeHidden
  ) {
    totalCount
    nodes {
      _id
      title
      notes
      site_labels {
        _id
        name
      }
      hidden
      position_in_stage
      created
      priority
      _stage {
        _id
      }
      assignees
      local_authority
    }
    pageInfo {
      hasNextPage
      endCursor
      startCursor
    }
  }
}
    `;

/**
 * __useSitesQuery__
 *
 * To run a query within a React component, call `useSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      siteSort: // value for 'siteSort'
 *      includeHidden: // value for 'includeHidden'
 *   },
 * });
 */
export function useSitesQuery(baseOptions?: Apollo.QueryHookOptions<SitesQuery, SitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitesQuery, SitesQueryVariables>(SitesDocument, options);
      }
export function useSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitesQuery, SitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitesQuery, SitesQueryVariables>(SitesDocument, options);
        }
export function useSitesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SitesQuery, SitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SitesQuery, SitesQueryVariables>(SitesDocument, options);
        }
export type SitesQueryHookResult = ReturnType<typeof useSitesQuery>;
export type SitesLazyQueryHookResult = ReturnType<typeof useSitesLazyQuery>;
export type SitesSuspenseQueryHookResult = ReturnType<typeof useSitesSuspenseQuery>;
export type SitesQueryResult = Apollo.QueryResult<SitesQuery, SitesQueryVariables>;
export const TeamMembersDocument = gql`
    query teamMembers {
  getTeamMembers {
    _id
    firstname
    surname
  }
}
    `;

/**
 * __useTeamMembersQuery__
 *
 * To run a query within a React component, call `useTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeamMembersQuery(baseOptions?: Apollo.QueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamMembersQuery, TeamMembersQueryVariables>(TeamMembersDocument, options);
      }
export function useTeamMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamMembersQuery, TeamMembersQueryVariables>(TeamMembersDocument, options);
        }
export function useTeamMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeamMembersQuery, TeamMembersQueryVariables>(TeamMembersDocument, options);
        }
export type TeamMembersQueryHookResult = ReturnType<typeof useTeamMembersQuery>;
export type TeamMembersLazyQueryHookResult = ReturnType<typeof useTeamMembersLazyQuery>;
export type TeamMembersSuspenseQueryHookResult = ReturnType<typeof useTeamMembersSuspenseQuery>;
export type TeamMembersQueryResult = Apollo.QueryResult<TeamMembersQuery, TeamMembersQueryVariables>;
export const TotalSiteCountVueDocument = gql`
    query totalSiteCountVue {
  totalSiteCount
}
    `;

/**
 * __useTotalSiteCountVueQuery__
 *
 * To run a query within a React component, call `useTotalSiteCountVueQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalSiteCountVueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalSiteCountVueQuery({
 *   variables: {
 *   },
 * });
 */
export function useTotalSiteCountVueQuery(baseOptions?: Apollo.QueryHookOptions<TotalSiteCountVueQuery, TotalSiteCountVueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TotalSiteCountVueQuery, TotalSiteCountVueQueryVariables>(TotalSiteCountVueDocument, options);
      }
export function useTotalSiteCountVueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TotalSiteCountVueQuery, TotalSiteCountVueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TotalSiteCountVueQuery, TotalSiteCountVueQueryVariables>(TotalSiteCountVueDocument, options);
        }
export function useTotalSiteCountVueSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TotalSiteCountVueQuery, TotalSiteCountVueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TotalSiteCountVueQuery, TotalSiteCountVueQueryVariables>(TotalSiteCountVueDocument, options);
        }
export type TotalSiteCountVueQueryHookResult = ReturnType<typeof useTotalSiteCountVueQuery>;
export type TotalSiteCountVueLazyQueryHookResult = ReturnType<typeof useTotalSiteCountVueLazyQuery>;
export type TotalSiteCountVueSuspenseQueryHookResult = ReturnType<typeof useTotalSiteCountVueSuspenseQuery>;
export type TotalSiteCountVueQueryResult = Apollo.QueryResult<TotalSiteCountVueQuery, TotalSiteCountVueQueryVariables>;
export const TotalStageCountDocument = gql`
    query totalStageCount {
  totalStageCount
}
    `;

/**
 * __useTotalStageCountQuery__
 *
 * To run a query within a React component, call `useTotalStageCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalStageCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalStageCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useTotalStageCountQuery(baseOptions?: Apollo.QueryHookOptions<TotalStageCountQuery, TotalStageCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TotalStageCountQuery, TotalStageCountQueryVariables>(TotalStageCountDocument, options);
      }
export function useTotalStageCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TotalStageCountQuery, TotalStageCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TotalStageCountQuery, TotalStageCountQueryVariables>(TotalStageCountDocument, options);
        }
export function useTotalStageCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TotalStageCountQuery, TotalStageCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TotalStageCountQuery, TotalStageCountQueryVariables>(TotalStageCountDocument, options);
        }
export type TotalStageCountQueryHookResult = ReturnType<typeof useTotalStageCountQuery>;
export type TotalStageCountLazyQueryHookResult = ReturnType<typeof useTotalStageCountLazyQuery>;
export type TotalStageCountSuspenseQueryHookResult = ReturnType<typeof useTotalStageCountSuspenseQuery>;
export type TotalStageCountQueryResult = Apollo.QueryResult<TotalStageCountQuery, TotalStageCountQueryVariables>;
export const GetSiteAttachmentSignedUploadUrlDocument = gql`
    query getSiteAttachmentSignedUploadUrl($site_id: String!, $file_name: String!, $mime_type: String!) {
  siteAttachmentSignedUploadUrl(
    site_id: $site_id
    file_name: $file_name
    mime_type: $mime_type
  ) {
    url
  }
}
    `;

/**
 * __useGetSiteAttachmentSignedUploadUrlQuery__
 *
 * To run a query within a React component, call `useGetSiteAttachmentSignedUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteAttachmentSignedUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteAttachmentSignedUploadUrlQuery({
 *   variables: {
 *      site_id: // value for 'site_id'
 *      file_name: // value for 'file_name'
 *      mime_type: // value for 'mime_type'
 *   },
 * });
 */
export function useGetSiteAttachmentSignedUploadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetSiteAttachmentSignedUploadUrlQuery, GetSiteAttachmentSignedUploadUrlQueryVariables> & ({ variables: GetSiteAttachmentSignedUploadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteAttachmentSignedUploadUrlQuery, GetSiteAttachmentSignedUploadUrlQueryVariables>(GetSiteAttachmentSignedUploadUrlDocument, options);
      }
export function useGetSiteAttachmentSignedUploadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteAttachmentSignedUploadUrlQuery, GetSiteAttachmentSignedUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteAttachmentSignedUploadUrlQuery, GetSiteAttachmentSignedUploadUrlQueryVariables>(GetSiteAttachmentSignedUploadUrlDocument, options);
        }
export function useGetSiteAttachmentSignedUploadUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSiteAttachmentSignedUploadUrlQuery, GetSiteAttachmentSignedUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSiteAttachmentSignedUploadUrlQuery, GetSiteAttachmentSignedUploadUrlQueryVariables>(GetSiteAttachmentSignedUploadUrlDocument, options);
        }
export type GetSiteAttachmentSignedUploadUrlQueryHookResult = ReturnType<typeof useGetSiteAttachmentSignedUploadUrlQuery>;
export type GetSiteAttachmentSignedUploadUrlLazyQueryHookResult = ReturnType<typeof useGetSiteAttachmentSignedUploadUrlLazyQuery>;
export type GetSiteAttachmentSignedUploadUrlSuspenseQueryHookResult = ReturnType<typeof useGetSiteAttachmentSignedUploadUrlSuspenseQuery>;
export type GetSiteAttachmentSignedUploadUrlQueryResult = Apollo.QueryResult<GetSiteAttachmentSignedUploadUrlQuery, GetSiteAttachmentSignedUploadUrlQueryVariables>;
export const AddSiteCommentDocument = gql`
    mutation addSiteComment($site: ID!, $comment_body: String!) {
  addSiteComment(site: $site, comment_body: $comment_body) {
    new_activity {
      ...SiteActivityFragment
    }
  }
}
    ${SiteActivityFragmentFragmentDoc}`;
export type AddSiteCommentMutationFn = Apollo.MutationFunction<AddSiteCommentMutation, AddSiteCommentMutationVariables>;

/**
 * __useAddSiteCommentMutation__
 *
 * To run a mutation, you first call `useAddSiteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSiteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSiteCommentMutation, { data, loading, error }] = useAddSiteCommentMutation({
 *   variables: {
 *      site: // value for 'site'
 *      comment_body: // value for 'comment_body'
 *   },
 * });
 */
export function useAddSiteCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddSiteCommentMutation, AddSiteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSiteCommentMutation, AddSiteCommentMutationVariables>(AddSiteCommentDocument, options);
      }
export type AddSiteCommentMutationHookResult = ReturnType<typeof useAddSiteCommentMutation>;
export type AddSiteCommentMutationResult = Apollo.MutationResult<AddSiteCommentMutation>;
export type AddSiteCommentMutationOptions = Apollo.BaseMutationOptions<AddSiteCommentMutation, AddSiteCommentMutationVariables>;
export const DeleteSiteAttachmentDocument = gql`
    mutation deleteSiteAttachment($tidbit_id: String!) {
  deleteSiteAttachment(tidbit_id: $tidbit_id) {
    archived_items {
      _id
    }
    new_activity {
      ...SiteActivityFragment
    }
  }
}
    ${SiteActivityFragmentFragmentDoc}`;
export type DeleteSiteAttachmentMutationFn = Apollo.MutationFunction<DeleteSiteAttachmentMutation, DeleteSiteAttachmentMutationVariables>;

/**
 * __useDeleteSiteAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteSiteAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSiteAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSiteAttachmentMutation, { data, loading, error }] = useDeleteSiteAttachmentMutation({
 *   variables: {
 *      tidbit_id: // value for 'tidbit_id'
 *   },
 * });
 */
export function useDeleteSiteAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSiteAttachmentMutation, DeleteSiteAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSiteAttachmentMutation, DeleteSiteAttachmentMutationVariables>(DeleteSiteAttachmentDocument, options);
      }
export type DeleteSiteAttachmentMutationHookResult = ReturnType<typeof useDeleteSiteAttachmentMutation>;
export type DeleteSiteAttachmentMutationResult = Apollo.MutationResult<DeleteSiteAttachmentMutation>;
export type DeleteSiteAttachmentMutationOptions = Apollo.BaseMutationOptions<DeleteSiteAttachmentMutation, DeleteSiteAttachmentMutationVariables>;
export const DeleteSiteTidbitDocument = gql`
    mutation deleteSiteTidbit($_id: String!) {
  deleteSiteTidbit(_id: $_id) {
    archived_items {
      _id
      archived
    }
    new_activity {
      ...SiteActivityFragment
    }
  }
}
    ${SiteActivityFragmentFragmentDoc}`;
export type DeleteSiteTidbitMutationFn = Apollo.MutationFunction<DeleteSiteTidbitMutation, DeleteSiteTidbitMutationVariables>;

/**
 * __useDeleteSiteTidbitMutation__
 *
 * To run a mutation, you first call `useDeleteSiteTidbitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSiteTidbitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSiteTidbitMutation, { data, loading, error }] = useDeleteSiteTidbitMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDeleteSiteTidbitMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSiteTidbitMutation, DeleteSiteTidbitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSiteTidbitMutation, DeleteSiteTidbitMutationVariables>(DeleteSiteTidbitDocument, options);
      }
export type DeleteSiteTidbitMutationHookResult = ReturnType<typeof useDeleteSiteTidbitMutation>;
export type DeleteSiteTidbitMutationResult = Apollo.MutationResult<DeleteSiteTidbitMutation>;
export type DeleteSiteTidbitMutationOptions = Apollo.BaseMutationOptions<DeleteSiteTidbitMutation, DeleteSiteTidbitMutationVariables>;
export const UpdateSiteDescriptionDocument = gql`
    mutation updateSiteDescription($updateData: SiteUpdate!) {
  updateSiteDescription: updateSites(updateData: [$updateData]) {
    site {
      _id
      notes
    }
  }
}
    `;
export type UpdateSiteDescriptionMutationFn = Apollo.MutationFunction<UpdateSiteDescriptionMutation, UpdateSiteDescriptionMutationVariables>;

/**
 * __useUpdateSiteDescriptionMutation__
 *
 * To run a mutation, you first call `useUpdateSiteDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteDescriptionMutation, { data, loading, error }] = useUpdateSiteDescriptionMutation({
 *   variables: {
 *      updateData: // value for 'updateData'
 *   },
 * });
 */
export function useUpdateSiteDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteDescriptionMutation, UpdateSiteDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteDescriptionMutation, UpdateSiteDescriptionMutationVariables>(UpdateSiteDescriptionDocument, options);
      }
export type UpdateSiteDescriptionMutationHookResult = ReturnType<typeof useUpdateSiteDescriptionMutation>;
export type UpdateSiteDescriptionMutationResult = Apollo.MutationResult<UpdateSiteDescriptionMutation>;
export type UpdateSiteDescriptionMutationOptions = Apollo.BaseMutationOptions<UpdateSiteDescriptionMutation, UpdateSiteDescriptionMutationVariables>;
export const UpdateSiteCommentDocument = gql`
    mutation updateSiteComment($updateData: SiteTidbitCommentUpdate!) {
  updateSiteTidbitComment(updateData: $updateData) {
    tidbit {
      _id
      ... on SiteTidbitComment {
        comment_body
        modified
      }
    }
  }
}
    `;
export type UpdateSiteCommentMutationFn = Apollo.MutationFunction<UpdateSiteCommentMutation, UpdateSiteCommentMutationVariables>;

/**
 * __useUpdateSiteCommentMutation__
 *
 * To run a mutation, you first call `useUpdateSiteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteCommentMutation, { data, loading, error }] = useUpdateSiteCommentMutation({
 *   variables: {
 *      updateData: // value for 'updateData'
 *   },
 * });
 */
export function useUpdateSiteCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteCommentMutation, UpdateSiteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteCommentMutation, UpdateSiteCommentMutationVariables>(UpdateSiteCommentDocument, options);
      }
export type UpdateSiteCommentMutationHookResult = ReturnType<typeof useUpdateSiteCommentMutation>;
export type UpdateSiteCommentMutationResult = Apollo.MutationResult<UpdateSiteCommentMutation>;
export type UpdateSiteCommentMutationOptions = Apollo.BaseMutationOptions<UpdateSiteCommentMutation, UpdateSiteCommentMutationVariables>;
export const UpdateSiteTidbitDocument = gql`
    mutation updateSiteTidbit($updateData: SiteTidbitUpdate!) {
  updateSiteTidbit(updateData: $updateData) {
    tidbit {
      ...TidbitUpdateFragment
    }
    new_activity {
      ...SiteActivityFragment
    }
  }
}
    ${TidbitUpdateFragmentFragmentDoc}
${SiteActivityFragmentFragmentDoc}`;
export type UpdateSiteTidbitMutationFn = Apollo.MutationFunction<UpdateSiteTidbitMutation, UpdateSiteTidbitMutationVariables>;

/**
 * __useUpdateSiteTidbitMutation__
 *
 * To run a mutation, you first call `useUpdateSiteTidbitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteTidbitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteTidbitMutation, { data, loading, error }] = useUpdateSiteTidbitMutation({
 *   variables: {
 *      updateData: // value for 'updateData'
 *   },
 * });
 */
export function useUpdateSiteTidbitMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteTidbitMutation, UpdateSiteTidbitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteTidbitMutation, UpdateSiteTidbitMutationVariables>(UpdateSiteTidbitDocument, options);
      }
export type UpdateSiteTidbitMutationHookResult = ReturnType<typeof useUpdateSiteTidbitMutation>;
export type UpdateSiteTidbitMutationResult = Apollo.MutationResult<UpdateSiteTidbitMutation>;
export type UpdateSiteTidbitMutationOptions = Apollo.BaseMutationOptions<UpdateSiteTidbitMutation, UpdateSiteTidbitMutationVariables>;
export const UpsertTidbitDocument = gql`
    mutation upsertTidbit($site_id: String!, $file_name: String!) {
  registerSiteAttachmentUpload(site_id: $site_id, file_name: $file_name) {
    tidbit {
      ...CoreTidbitFragment
      ...AttachmentTidbitDocFragment
    }
    new_activity {
      ...SiteActivityFragment
    }
  }
}
    ${CoreTidbitFragmentFragmentDoc}
${AttachmentTidbitDocFragmentFragmentDoc}
${SiteActivityFragmentFragmentDoc}`;
export type UpsertTidbitMutationFn = Apollo.MutationFunction<UpsertTidbitMutation, UpsertTidbitMutationVariables>;

/**
 * __useUpsertTidbitMutation__
 *
 * To run a mutation, you first call `useUpsertTidbitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTidbitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTidbitMutation, { data, loading, error }] = useUpsertTidbitMutation({
 *   variables: {
 *      site_id: // value for 'site_id'
 *      file_name: // value for 'file_name'
 *   },
 * });
 */
export function useUpsertTidbitMutation(baseOptions?: Apollo.MutationHookOptions<UpsertTidbitMutation, UpsertTidbitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertTidbitMutation, UpsertTidbitMutationVariables>(UpsertTidbitDocument, options);
      }
export type UpsertTidbitMutationHookResult = ReturnType<typeof useUpsertTidbitMutation>;
export type UpsertTidbitMutationResult = Apollo.MutationResult<UpsertTidbitMutation>;
export type UpsertTidbitMutationOptions = Apollo.BaseMutationOptions<UpsertTidbitMutation, UpsertTidbitMutationVariables>;
export const SitesIntersectingDocument = gql`
    query SitesIntersecting($geometry: GeoJSONGeometryInput, $includeHidden: Boolean, $limit: Int) {
  sites(geometry: $geometry, includeHidden: $includeHidden, limit: $limit) {
    edges {
      node {
        _id
        title
        geometry {
          type
          coordinates
        }
        hidden
        sharedByUser {
          _id
        }
        _stage {
          _id
          color
          _workspace {
            id
            title
            developmentType
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSitesIntersectingQuery__
 *
 * To run a query within a React component, call `useSitesIntersectingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesIntersectingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesIntersectingQuery({
 *   variables: {
 *      geometry: // value for 'geometry'
 *      includeHidden: // value for 'includeHidden'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSitesIntersectingQuery(baseOptions?: Apollo.QueryHookOptions<SitesIntersectingQuery, SitesIntersectingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitesIntersectingQuery, SitesIntersectingQueryVariables>(SitesIntersectingDocument, options);
      }
export function useSitesIntersectingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitesIntersectingQuery, SitesIntersectingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitesIntersectingQuery, SitesIntersectingQueryVariables>(SitesIntersectingDocument, options);
        }
export function useSitesIntersectingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SitesIntersectingQuery, SitesIntersectingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SitesIntersectingQuery, SitesIntersectingQueryVariables>(SitesIntersectingDocument, options);
        }
export type SitesIntersectingQueryHookResult = ReturnType<typeof useSitesIntersectingQuery>;
export type SitesIntersectingLazyQueryHookResult = ReturnType<typeof useSitesIntersectingLazyQuery>;
export type SitesIntersectingSuspenseQueryHookResult = ReturnType<typeof useSitesIntersectingSuspenseQuery>;
export type SitesIntersectingQueryResult = Apollo.QueryResult<SitesIntersectingQuery, SitesIntersectingQueryVariables>;
export const AllSiteLabelsDocument = gql`
    query allSiteLabels {
  siteLabels {
    _id
    name
  }
}
    `;

/**
 * __useAllSiteLabelsQuery__
 *
 * To run a query within a React component, call `useAllSiteLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSiteLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSiteLabelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllSiteLabelsQuery(baseOptions?: Apollo.QueryHookOptions<AllSiteLabelsQuery, AllSiteLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSiteLabelsQuery, AllSiteLabelsQueryVariables>(AllSiteLabelsDocument, options);
      }
export function useAllSiteLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSiteLabelsQuery, AllSiteLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSiteLabelsQuery, AllSiteLabelsQueryVariables>(AllSiteLabelsDocument, options);
        }
export function useAllSiteLabelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllSiteLabelsQuery, AllSiteLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllSiteLabelsQuery, AllSiteLabelsQueryVariables>(AllSiteLabelsDocument, options);
        }
export type AllSiteLabelsQueryHookResult = ReturnType<typeof useAllSiteLabelsQuery>;
export type AllSiteLabelsLazyQueryHookResult = ReturnType<typeof useAllSiteLabelsLazyQuery>;
export type AllSiteLabelsSuspenseQueryHookResult = ReturnType<typeof useAllSiteLabelsSuspenseQuery>;
export type AllSiteLabelsQueryResult = Apollo.QueryResult<AllSiteLabelsQuery, AllSiteLabelsQueryVariables>;
export const GetAllAttachmentsDocument = gql`
    query GetAllAttachments($siteId: String!) {
  siteFileAttachments(site_id: $siteId) {
    __typename
    ...AttachmentTidbitDocFragment
  }
}
    ${AttachmentTidbitDocFragmentFragmentDoc}`;

/**
 * __useGetAllAttachmentsQuery__
 *
 * To run a query within a React component, call `useGetAllAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAttachmentsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetAllAttachmentsQuery(baseOptions: Apollo.QueryHookOptions<GetAllAttachmentsQuery, GetAllAttachmentsQueryVariables> & ({ variables: GetAllAttachmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAttachmentsQuery, GetAllAttachmentsQueryVariables>(GetAllAttachmentsDocument, options);
      }
export function useGetAllAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAttachmentsQuery, GetAllAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAttachmentsQuery, GetAllAttachmentsQueryVariables>(GetAllAttachmentsDocument, options);
        }
export function useGetAllAttachmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllAttachmentsQuery, GetAllAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllAttachmentsQuery, GetAllAttachmentsQueryVariables>(GetAllAttachmentsDocument, options);
        }
export type GetAllAttachmentsQueryHookResult = ReturnType<typeof useGetAllAttachmentsQuery>;
export type GetAllAttachmentsLazyQueryHookResult = ReturnType<typeof useGetAllAttachmentsLazyQuery>;
export type GetAllAttachmentsSuspenseQueryHookResult = ReturnType<typeof useGetAllAttachmentsSuspenseQuery>;
export type GetAllAttachmentsQueryResult = Apollo.QueryResult<GetAllAttachmentsQuery, GetAllAttachmentsQueryVariables>;
export const GetPinnedItemsDocument = gql`
    query getPinnedItems($siteId: String!) {
  siteTidbits(site_id: $siteId, is_pinned: true) {
    is_pinned
    __typename
    ... on SiteTidbitAttachment {
      _id
      __typename
      is_pinned
      can_delete
      created
      file_name
      title
      extension
      attachment {
        _id
        signed_url {
          url
        }
        thumb_url {
          url
          has_thumbnail
        }
      }
      user {
        _id
        firstname
        surname
      }
    }
    ... on SiteTidbitComment {
      _id
      is_pinned
      is_hidden
      can_delete
      created
      modified
      comment_body
      archived
      parent {
        __typename
        ... on SiteTidbitAttachment {
          file_name
        }
      }
      user {
        _id
        firstname
        surname
      }
      site {
        _id
        title
      }
    }
  }
}
    `;

/**
 * __useGetPinnedItemsQuery__
 *
 * To run a query within a React component, call `useGetPinnedItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPinnedItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPinnedItemsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetPinnedItemsQuery(baseOptions: Apollo.QueryHookOptions<GetPinnedItemsQuery, GetPinnedItemsQueryVariables> & ({ variables: GetPinnedItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPinnedItemsQuery, GetPinnedItemsQueryVariables>(GetPinnedItemsDocument, options);
      }
export function useGetPinnedItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPinnedItemsQuery, GetPinnedItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPinnedItemsQuery, GetPinnedItemsQueryVariables>(GetPinnedItemsDocument, options);
        }
export function useGetPinnedItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPinnedItemsQuery, GetPinnedItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPinnedItemsQuery, GetPinnedItemsQueryVariables>(GetPinnedItemsDocument, options);
        }
export type GetPinnedItemsQueryHookResult = ReturnType<typeof useGetPinnedItemsQuery>;
export type GetPinnedItemsLazyQueryHookResult = ReturnType<typeof useGetPinnedItemsLazyQuery>;
export type GetPinnedItemsSuspenseQueryHookResult = ReturnType<typeof useGetPinnedItemsSuspenseQuery>;
export type GetPinnedItemsQueryResult = Apollo.QueryResult<GetPinnedItemsQuery, GetPinnedItemsQueryVariables>;
export const GetPurchasedDocumentsDocument = gql`
    query getPurchasedDocuments($siteId: String!) {
  site(_id: $siteId) {
    title_document_purchases {
      ...PurchaseFragment
    }
    os_map_prints {
      ...OSMapPrintPurchasedFragment
    }
  }
}
    ${PurchaseFragmentFragmentDoc}
${OsMapPrintPurchasedFragmentFragmentDoc}`;

/**
 * __useGetPurchasedDocumentsQuery__
 *
 * To run a query within a React component, call `useGetPurchasedDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchasedDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchasedDocumentsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetPurchasedDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetPurchasedDocumentsQuery, GetPurchasedDocumentsQueryVariables> & ({ variables: GetPurchasedDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchasedDocumentsQuery, GetPurchasedDocumentsQueryVariables>(GetPurchasedDocumentsDocument, options);
      }
export function useGetPurchasedDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchasedDocumentsQuery, GetPurchasedDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchasedDocumentsQuery, GetPurchasedDocumentsQueryVariables>(GetPurchasedDocumentsDocument, options);
        }
export function useGetPurchasedDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPurchasedDocumentsQuery, GetPurchasedDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPurchasedDocumentsQuery, GetPurchasedDocumentsQueryVariables>(GetPurchasedDocumentsDocument, options);
        }
export type GetPurchasedDocumentsQueryHookResult = ReturnType<typeof useGetPurchasedDocumentsQuery>;
export type GetPurchasedDocumentsLazyQueryHookResult = ReturnType<typeof useGetPurchasedDocumentsLazyQuery>;
export type GetPurchasedDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetPurchasedDocumentsSuspenseQuery>;
export type GetPurchasedDocumentsQueryResult = Apollo.QueryResult<GetPurchasedDocumentsQuery, GetPurchasedDocumentsQueryVariables>;
export const GetSignedAttachmentUrlDocument = gql`
    query getSignedAttachmentUrl($attachment_id: String!, $link_duration_minutes: Int, $is_thumbnail: Boolean) {
  attachmentDownloadUrl(
    uploaded_file_id: $attachment_id
    link_duration: $link_duration_minutes
    thumb: $is_thumbnail
  ) {
    url
    expires_at
    has_thumbnail
  }
}
    `;

/**
 * __useGetSignedAttachmentUrlQuery__
 *
 * To run a query within a React component, call `useGetSignedAttachmentUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignedAttachmentUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignedAttachmentUrlQuery({
 *   variables: {
 *      attachment_id: // value for 'attachment_id'
 *      link_duration_minutes: // value for 'link_duration_minutes'
 *      is_thumbnail: // value for 'is_thumbnail'
 *   },
 * });
 */
export function useGetSignedAttachmentUrlQuery(baseOptions: Apollo.QueryHookOptions<GetSignedAttachmentUrlQuery, GetSignedAttachmentUrlQueryVariables> & ({ variables: GetSignedAttachmentUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignedAttachmentUrlQuery, GetSignedAttachmentUrlQueryVariables>(GetSignedAttachmentUrlDocument, options);
      }
export function useGetSignedAttachmentUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignedAttachmentUrlQuery, GetSignedAttachmentUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignedAttachmentUrlQuery, GetSignedAttachmentUrlQueryVariables>(GetSignedAttachmentUrlDocument, options);
        }
export function useGetSignedAttachmentUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSignedAttachmentUrlQuery, GetSignedAttachmentUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSignedAttachmentUrlQuery, GetSignedAttachmentUrlQueryVariables>(GetSignedAttachmentUrlDocument, options);
        }
export type GetSignedAttachmentUrlQueryHookResult = ReturnType<typeof useGetSignedAttachmentUrlQuery>;
export type GetSignedAttachmentUrlLazyQueryHookResult = ReturnType<typeof useGetSignedAttachmentUrlLazyQuery>;
export type GetSignedAttachmentUrlSuspenseQueryHookResult = ReturnType<typeof useGetSignedAttachmentUrlSuspenseQuery>;
export type GetSignedAttachmentUrlQueryResult = Apollo.QueryResult<GetSignedAttachmentUrlQuery, GetSignedAttachmentUrlQueryVariables>;
export const GetSiteAttachmentsDocument = gql`
    query GetSiteAttachments($siteId: String!) {
  siteTidbits(site_id: $siteId) {
    __typename
    ...AttachmentTidbitDocFragment
  }
}
    ${AttachmentTidbitDocFragmentFragmentDoc}`;

/**
 * __useGetSiteAttachmentsQuery__
 *
 * To run a query within a React component, call `useGetSiteAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteAttachmentsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetSiteAttachmentsQuery(baseOptions: Apollo.QueryHookOptions<GetSiteAttachmentsQuery, GetSiteAttachmentsQueryVariables> & ({ variables: GetSiteAttachmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteAttachmentsQuery, GetSiteAttachmentsQueryVariables>(GetSiteAttachmentsDocument, options);
      }
export function useGetSiteAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteAttachmentsQuery, GetSiteAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteAttachmentsQuery, GetSiteAttachmentsQueryVariables>(GetSiteAttachmentsDocument, options);
        }
export function useGetSiteAttachmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSiteAttachmentsQuery, GetSiteAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSiteAttachmentsQuery, GetSiteAttachmentsQueryVariables>(GetSiteAttachmentsDocument, options);
        }
export type GetSiteAttachmentsQueryHookResult = ReturnType<typeof useGetSiteAttachmentsQuery>;
export type GetSiteAttachmentsLazyQueryHookResult = ReturnType<typeof useGetSiteAttachmentsLazyQuery>;
export type GetSiteAttachmentsSuspenseQueryHookResult = ReturnType<typeof useGetSiteAttachmentsSuspenseQuery>;
export type GetSiteAttachmentsQueryResult = Apollo.QueryResult<GetSiteAttachmentsQuery, GetSiteAttachmentsQueryVariables>;
export const GetTeamMembersDocument = gql`
    query getTeamMembers {
  getTeamMembers {
    _id
    firstname
    surname
  }
}
    `;

/**
 * __useGetTeamMembersQuery__
 *
 * To run a query within a React component, call `useGetTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTeamMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetTeamMembersQuery, GetTeamMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamMembersQuery, GetTeamMembersQueryVariables>(GetTeamMembersDocument, options);
      }
export function useGetTeamMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamMembersQuery, GetTeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamMembersQuery, GetTeamMembersQueryVariables>(GetTeamMembersDocument, options);
        }
export function useGetTeamMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTeamMembersQuery, GetTeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamMembersQuery, GetTeamMembersQueryVariables>(GetTeamMembersDocument, options);
        }
export type GetTeamMembersQueryHookResult = ReturnType<typeof useGetTeamMembersQuery>;
export type GetTeamMembersLazyQueryHookResult = ReturnType<typeof useGetTeamMembersLazyQuery>;
export type GetTeamMembersSuspenseQueryHookResult = ReturnType<typeof useGetTeamMembersSuspenseQuery>;
export type GetTeamMembersQueryResult = Apollo.QueryResult<GetTeamMembersQuery, GetTeamMembersQueryVariables>;
export const OwnershipSummaryDocument = gql`
    query ownershipSummary($_id: String!) {
  ownershipSummary: site(_id: $_id) {
    _id
    geometry {
      type
      coordinates
    }
    totalNumberOfTitlesSummary
    location {
      type
      coordinates
    }
  }
}
    `;

/**
 * __useOwnershipSummaryQuery__
 *
 * To run a query within a React component, call `useOwnershipSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOwnershipSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOwnershipSummaryQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useOwnershipSummaryQuery(baseOptions: Apollo.QueryHookOptions<OwnershipSummaryQuery, OwnershipSummaryQueryVariables> & ({ variables: OwnershipSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OwnershipSummaryQuery, OwnershipSummaryQueryVariables>(OwnershipSummaryDocument, options);
      }
export function useOwnershipSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OwnershipSummaryQuery, OwnershipSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OwnershipSummaryQuery, OwnershipSummaryQueryVariables>(OwnershipSummaryDocument, options);
        }
export function useOwnershipSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OwnershipSummaryQuery, OwnershipSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OwnershipSummaryQuery, OwnershipSummaryQueryVariables>(OwnershipSummaryDocument, options);
        }
export type OwnershipSummaryQueryHookResult = ReturnType<typeof useOwnershipSummaryQuery>;
export type OwnershipSummaryLazyQueryHookResult = ReturnType<typeof useOwnershipSummaryLazyQuery>;
export type OwnershipSummarySuspenseQueryHookResult = ReturnType<typeof useOwnershipSummarySuspenseQuery>;
export type OwnershipSummaryQueryResult = Apollo.QueryResult<OwnershipSummaryQuery, OwnershipSummaryQueryVariables>;
export const SiteActivityDocument = gql`
    query siteActivity($_id: String!, $cursor: String, $limit: Int!, $exclude_verbs: [String]) {
  siteActivity(
    site_id: $_id
    cursor: $cursor
    limit: $limit
    exclude_verbs: $exclude_verbs
  ) {
    totalCount
    nodes {
      ...SiteActivityFragment
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${SiteActivityFragmentFragmentDoc}`;

/**
 * __useSiteActivityQuery__
 *
 * To run a query within a React component, call `useSiteActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteActivityQuery({
 *   variables: {
 *      _id: // value for '_id'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      exclude_verbs: // value for 'exclude_verbs'
 *   },
 * });
 */
export function useSiteActivityQuery(baseOptions: Apollo.QueryHookOptions<SiteActivityQuery, SiteActivityQueryVariables> & ({ variables: SiteActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteActivityQuery, SiteActivityQueryVariables>(SiteActivityDocument, options);
      }
export function useSiteActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteActivityQuery, SiteActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteActivityQuery, SiteActivityQueryVariables>(SiteActivityDocument, options);
        }
export function useSiteActivitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SiteActivityQuery, SiteActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiteActivityQuery, SiteActivityQueryVariables>(SiteActivityDocument, options);
        }
export type SiteActivityQueryHookResult = ReturnType<typeof useSiteActivityQuery>;
export type SiteActivityLazyQueryHookResult = ReturnType<typeof useSiteActivityLazyQuery>;
export type SiteActivitySuspenseQueryHookResult = ReturnType<typeof useSiteActivitySuspenseQuery>;
export type SiteActivityQueryResult = Apollo.QueryResult<SiteActivityQuery, SiteActivityQueryVariables>;
export const SiteAttachmentAntivirusScanStatusDocument = gql`
    query siteAttachmentAntivirusScanStatus($site_id: String!, $file_name: String!) {
  siteAttachmentAntivirusScanStatus(site_id: $site_id, file_name: $file_name) {
    antivirusScanStatus
  }
}
    `;

/**
 * __useSiteAttachmentAntivirusScanStatusQuery__
 *
 * To run a query within a React component, call `useSiteAttachmentAntivirusScanStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteAttachmentAntivirusScanStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteAttachmentAntivirusScanStatusQuery({
 *   variables: {
 *      site_id: // value for 'site_id'
 *      file_name: // value for 'file_name'
 *   },
 * });
 */
export function useSiteAttachmentAntivirusScanStatusQuery(baseOptions: Apollo.QueryHookOptions<SiteAttachmentAntivirusScanStatusQuery, SiteAttachmentAntivirusScanStatusQueryVariables> & ({ variables: SiteAttachmentAntivirusScanStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteAttachmentAntivirusScanStatusQuery, SiteAttachmentAntivirusScanStatusQueryVariables>(SiteAttachmentAntivirusScanStatusDocument, options);
      }
export function useSiteAttachmentAntivirusScanStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteAttachmentAntivirusScanStatusQuery, SiteAttachmentAntivirusScanStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteAttachmentAntivirusScanStatusQuery, SiteAttachmentAntivirusScanStatusQueryVariables>(SiteAttachmentAntivirusScanStatusDocument, options);
        }
export function useSiteAttachmentAntivirusScanStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SiteAttachmentAntivirusScanStatusQuery, SiteAttachmentAntivirusScanStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiteAttachmentAntivirusScanStatusQuery, SiteAttachmentAntivirusScanStatusQueryVariables>(SiteAttachmentAntivirusScanStatusDocument, options);
        }
export type SiteAttachmentAntivirusScanStatusQueryHookResult = ReturnType<typeof useSiteAttachmentAntivirusScanStatusQuery>;
export type SiteAttachmentAntivirusScanStatusLazyQueryHookResult = ReturnType<typeof useSiteAttachmentAntivirusScanStatusLazyQuery>;
export type SiteAttachmentAntivirusScanStatusSuspenseQueryHookResult = ReturnType<typeof useSiteAttachmentAntivirusScanStatusSuspenseQuery>;
export type SiteAttachmentAntivirusScanStatusQueryResult = Apollo.QueryResult<SiteAttachmentAntivirusScanStatusQuery, SiteAttachmentAntivirusScanStatusQueryVariables>;
export const SiteBoundaryImageBulkDocument = gql`
    query siteBoundaryImageBulk($siteIds: [ID], $stageIds: [ID], $limit: Int!) {
  siteBoundaryImageBulk: sites(
    siteIds: $siteIds
    stageIds: $stageIds
    limit: $limit
  ) {
    edges {
      node {
        _id
        boundary_image {
          id
          uri
        }
      }
    }
  }
}
    `;

/**
 * __useSiteBoundaryImageBulkQuery__
 *
 * To run a query within a React component, call `useSiteBoundaryImageBulkQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteBoundaryImageBulkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteBoundaryImageBulkQuery({
 *   variables: {
 *      siteIds: // value for 'siteIds'
 *      stageIds: // value for 'stageIds'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSiteBoundaryImageBulkQuery(baseOptions: Apollo.QueryHookOptions<SiteBoundaryImageBulkQuery, SiteBoundaryImageBulkQueryVariables> & ({ variables: SiteBoundaryImageBulkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteBoundaryImageBulkQuery, SiteBoundaryImageBulkQueryVariables>(SiteBoundaryImageBulkDocument, options);
      }
export function useSiteBoundaryImageBulkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteBoundaryImageBulkQuery, SiteBoundaryImageBulkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteBoundaryImageBulkQuery, SiteBoundaryImageBulkQueryVariables>(SiteBoundaryImageBulkDocument, options);
        }
export function useSiteBoundaryImageBulkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SiteBoundaryImageBulkQuery, SiteBoundaryImageBulkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiteBoundaryImageBulkQuery, SiteBoundaryImageBulkQueryVariables>(SiteBoundaryImageBulkDocument, options);
        }
export type SiteBoundaryImageBulkQueryHookResult = ReturnType<typeof useSiteBoundaryImageBulkQuery>;
export type SiteBoundaryImageBulkLazyQueryHookResult = ReturnType<typeof useSiteBoundaryImageBulkLazyQuery>;
export type SiteBoundaryImageBulkSuspenseQueryHookResult = ReturnType<typeof useSiteBoundaryImageBulkSuspenseQuery>;
export type SiteBoundaryImageBulkQueryResult = Apollo.QueryResult<SiteBoundaryImageBulkQuery, SiteBoundaryImageBulkQueryVariables>;
export const SiteGeometryDocument = gql`
    query siteGeometry($_id: String!) {
  siteGeometry: site(_id: $_id) {
    geometry {
      type
      coordinates
    }
  }
}
    `;

/**
 * __useSiteGeometryQuery__
 *
 * To run a query within a React component, call `useSiteGeometryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteGeometryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteGeometryQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useSiteGeometryQuery(baseOptions: Apollo.QueryHookOptions<SiteGeometryQuery, SiteGeometryQueryVariables> & ({ variables: SiteGeometryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteGeometryQuery, SiteGeometryQueryVariables>(SiteGeometryDocument, options);
      }
export function useSiteGeometryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteGeometryQuery, SiteGeometryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteGeometryQuery, SiteGeometryQueryVariables>(SiteGeometryDocument, options);
        }
export function useSiteGeometrySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SiteGeometryQuery, SiteGeometryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiteGeometryQuery, SiteGeometryQueryVariables>(SiteGeometryDocument, options);
        }
export type SiteGeometryQueryHookResult = ReturnType<typeof useSiteGeometryQuery>;
export type SiteGeometryLazyQueryHookResult = ReturnType<typeof useSiteGeometryLazyQuery>;
export type SiteGeometrySuspenseQueryHookResult = ReturnType<typeof useSiteGeometrySuspenseQuery>;
export type SiteGeometryQueryResult = Apollo.QueryResult<SiteGeometryQuery, SiteGeometryQueryVariables>;
export const SiteImageDocument = gql`
    query siteImage($siteId: String!, $mapZoom: Int!) {
  siteImage: site(_id: $siteId) {
    _id
    boundary_image(mapZoom: $mapZoom) {
      id
      uri
    }
  }
}
    `;

/**
 * __useSiteImageQuery__
 *
 * To run a query within a React component, call `useSiteImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteImageQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      mapZoom: // value for 'mapZoom'
 *   },
 * });
 */
export function useSiteImageQuery(baseOptions: Apollo.QueryHookOptions<SiteImageQuery, SiteImageQueryVariables> & ({ variables: SiteImageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteImageQuery, SiteImageQueryVariables>(SiteImageDocument, options);
      }
export function useSiteImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteImageQuery, SiteImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteImageQuery, SiteImageQueryVariables>(SiteImageDocument, options);
        }
export function useSiteImageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SiteImageQuery, SiteImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiteImageQuery, SiteImageQueryVariables>(SiteImageDocument, options);
        }
export type SiteImageQueryHookResult = ReturnType<typeof useSiteImageQuery>;
export type SiteImageLazyQueryHookResult = ReturnType<typeof useSiteImageLazyQuery>;
export type SiteImageSuspenseQueryHookResult = ReturnType<typeof useSiteImageSuspenseQuery>;
export type SiteImageQueryResult = Apollo.QueryResult<SiteImageQuery, SiteImageQueryVariables>;
export const SiteLabelOptionsDocument = gql`
    query siteLabelOptions {
  siteLabelOptions: siteLabels {
    _id
    name
  }
}
    `;

/**
 * __useSiteLabelOptionsQuery__
 *
 * To run a query within a React component, call `useSiteLabelOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteLabelOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteLabelOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSiteLabelOptionsQuery(baseOptions?: Apollo.QueryHookOptions<SiteLabelOptionsQuery, SiteLabelOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteLabelOptionsQuery, SiteLabelOptionsQueryVariables>(SiteLabelOptionsDocument, options);
      }
export function useSiteLabelOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteLabelOptionsQuery, SiteLabelOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteLabelOptionsQuery, SiteLabelOptionsQueryVariables>(SiteLabelOptionsDocument, options);
        }
export function useSiteLabelOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SiteLabelOptionsQuery, SiteLabelOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiteLabelOptionsQuery, SiteLabelOptionsQueryVariables>(SiteLabelOptionsDocument, options);
        }
export type SiteLabelOptionsQueryHookResult = ReturnType<typeof useSiteLabelOptionsQuery>;
export type SiteLabelOptionsLazyQueryHookResult = ReturnType<typeof useSiteLabelOptionsLazyQuery>;
export type SiteLabelOptionsSuspenseQueryHookResult = ReturnType<typeof useSiteLabelOptionsSuspenseQuery>;
export type SiteLabelOptionsQueryResult = Apollo.QueryResult<SiteLabelOptionsQuery, SiteLabelOptionsQueryVariables>;
export const SiteLocalAuthorityOptionsDocument = gql`
    query siteLocalAuthorityOptions {
  siteLocalAuthorityOptions: authorities {
    name
  }
}
    `;

/**
 * __useSiteLocalAuthorityOptionsQuery__
 *
 * To run a query within a React component, call `useSiteLocalAuthorityOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteLocalAuthorityOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteLocalAuthorityOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSiteLocalAuthorityOptionsQuery(baseOptions?: Apollo.QueryHookOptions<SiteLocalAuthorityOptionsQuery, SiteLocalAuthorityOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteLocalAuthorityOptionsQuery, SiteLocalAuthorityOptionsQueryVariables>(SiteLocalAuthorityOptionsDocument, options);
      }
export function useSiteLocalAuthorityOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteLocalAuthorityOptionsQuery, SiteLocalAuthorityOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteLocalAuthorityOptionsQuery, SiteLocalAuthorityOptionsQueryVariables>(SiteLocalAuthorityOptionsDocument, options);
        }
export function useSiteLocalAuthorityOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SiteLocalAuthorityOptionsQuery, SiteLocalAuthorityOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiteLocalAuthorityOptionsQuery, SiteLocalAuthorityOptionsQueryVariables>(SiteLocalAuthorityOptionsDocument, options);
        }
export type SiteLocalAuthorityOptionsQueryHookResult = ReturnType<typeof useSiteLocalAuthorityOptionsQuery>;
export type SiteLocalAuthorityOptionsLazyQueryHookResult = ReturnType<typeof useSiteLocalAuthorityOptionsLazyQuery>;
export type SiteLocalAuthorityOptionsSuspenseQueryHookResult = ReturnType<typeof useSiteLocalAuthorityOptionsSuspenseQuery>;
export type SiteLocalAuthorityOptionsQueryResult = Apollo.QueryResult<SiteLocalAuthorityOptionsQuery, SiteLocalAuthorityOptionsQueryVariables>;
export const SiteMapDocument = gql`
    query siteMap($_id: String!) {
  siteMap: site(_id: $_id) {
    _id
    title
    notes
    geometry {
      type
      coordinates
    }
    location {
      type
      coordinates
    }
    _stage {
      _id
      color
    }
  }
}
    `;

/**
 * __useSiteMapQuery__
 *
 * To run a query within a React component, call `useSiteMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteMapQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useSiteMapQuery(baseOptions: Apollo.QueryHookOptions<SiteMapQuery, SiteMapQueryVariables> & ({ variables: SiteMapQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteMapQuery, SiteMapQueryVariables>(SiteMapDocument, options);
      }
export function useSiteMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteMapQuery, SiteMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteMapQuery, SiteMapQueryVariables>(SiteMapDocument, options);
        }
export function useSiteMapSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SiteMapQuery, SiteMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiteMapQuery, SiteMapQueryVariables>(SiteMapDocument, options);
        }
export type SiteMapQueryHookResult = ReturnType<typeof useSiteMapQuery>;
export type SiteMapLazyQueryHookResult = ReturnType<typeof useSiteMapLazyQuery>;
export type SiteMapSuspenseQueryHookResult = ReturnType<typeof useSiteMapSuspenseQuery>;
export type SiteMapQueryResult = Apollo.QueryResult<SiteMapQuery, SiteMapQueryVariables>;
export const SiteOverviewDocument = gql`
    query siteOverview($_id: String!, $isShared: Boolean = false, $includeSiteSummary: Boolean = false) {
  siteOverview: site(_id: $_id) {
    _id
    title
    notes
    assignees
    ptal_rating @include(if: $includeSiteSummary)
    local_authority @include(if: $includeSiteSummary)
    use_classes_sep_2020 @include(if: $includeSiteSummary)
    use_classes @include(if: $includeSiteSummary)
    average_building_height @include(if: $includeSiteSummary) {
      rel_h_to_roof
      rel_h_max
    }
    geometry {
      type
      coordinates
    }
    location {
      type
      coordinates
    }
    _stage @skip(if: $isShared) {
      color
      _id
      name
    }
    sharedByUser {
      _id
      firstname
      surname
      date
    }
    assignedUsers @include(if: $isShared) {
      _id
      firstname
      surname
    }
    site_labels {
      _id
      name
    }
    source {
      _id
    }
    collaborators @skip(if: $isShared) {
      _id
      email
      firstname
      surname
    }
  }
}
    `;

/**
 * __useSiteOverviewQuery__
 *
 * To run a query within a React component, call `useSiteOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteOverviewQuery({
 *   variables: {
 *      _id: // value for '_id'
 *      isShared: // value for 'isShared'
 *      includeSiteSummary: // value for 'includeSiteSummary'
 *   },
 * });
 */
export function useSiteOverviewQuery(baseOptions: Apollo.QueryHookOptions<SiteOverviewQuery, SiteOverviewQueryVariables> & ({ variables: SiteOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteOverviewQuery, SiteOverviewQueryVariables>(SiteOverviewDocument, options);
      }
export function useSiteOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteOverviewQuery, SiteOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteOverviewQuery, SiteOverviewQueryVariables>(SiteOverviewDocument, options);
        }
export function useSiteOverviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SiteOverviewQuery, SiteOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiteOverviewQuery, SiteOverviewQueryVariables>(SiteOverviewDocument, options);
        }
export type SiteOverviewQueryHookResult = ReturnType<typeof useSiteOverviewQuery>;
export type SiteOverviewLazyQueryHookResult = ReturnType<typeof useSiteOverviewLazyQuery>;
export type SiteOverviewSuspenseQueryHookResult = ReturnType<typeof useSiteOverviewSuspenseQuery>;
export type SiteOverviewQueryResult = Apollo.QueryResult<SiteOverviewQuery, SiteOverviewQueryVariables>;
export const SiteOverviewUsDocument = gql`
    query siteOverviewUS($_id: String!) {
  siteOverview: site(_id: $_id) {
    _id
    title
    notes
    ptal_rating
    local_authority
    use_classes_sep_2020
    use_classes
    average_building_height {
      rel_h_to_roof
      rel_h_max
    }
    geometry {
      type
      coordinates
    }
    location {
      type
      coordinates
    }
    _stage {
      _id
      color
    }
  }
}
    `;

/**
 * __useSiteOverviewUsQuery__
 *
 * To run a query within a React component, call `useSiteOverviewUsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteOverviewUsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteOverviewUsQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useSiteOverviewUsQuery(baseOptions: Apollo.QueryHookOptions<SiteOverviewUsQuery, SiteOverviewUsQueryVariables> & ({ variables: SiteOverviewUsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteOverviewUsQuery, SiteOverviewUsQueryVariables>(SiteOverviewUsDocument, options);
      }
export function useSiteOverviewUsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteOverviewUsQuery, SiteOverviewUsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteOverviewUsQuery, SiteOverviewUsQueryVariables>(SiteOverviewUsDocument, options);
        }
export function useSiteOverviewUsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SiteOverviewUsQuery, SiteOverviewUsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiteOverviewUsQuery, SiteOverviewUsQueryVariables>(SiteOverviewUsDocument, options);
        }
export type SiteOverviewUsQueryHookResult = ReturnType<typeof useSiteOverviewUsQuery>;
export type SiteOverviewUsLazyQueryHookResult = ReturnType<typeof useSiteOverviewUsLazyQuery>;
export type SiteOverviewUsSuspenseQueryHookResult = ReturnType<typeof useSiteOverviewUsSuspenseQuery>;
export type SiteOverviewUsQueryResult = Apollo.QueryResult<SiteOverviewUsQuery, SiteOverviewUsQueryVariables>;
export const SiteStagesListDocument = gql`
    query siteStagesList($projectId: String) {
  siteStagesPaginated(projectId: $projectId) {
    nodes {
      _id
      name
      color
      hidden
      ref
    }
  }
}
    `;

/**
 * __useSiteStagesListQuery__
 *
 * To run a query within a React component, call `useSiteStagesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteStagesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteStagesListQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSiteStagesListQuery(baseOptions?: Apollo.QueryHookOptions<SiteStagesListQuery, SiteStagesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteStagesListQuery, SiteStagesListQueryVariables>(SiteStagesListDocument, options);
      }
export function useSiteStagesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteStagesListQuery, SiteStagesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteStagesListQuery, SiteStagesListQueryVariables>(SiteStagesListDocument, options);
        }
export function useSiteStagesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SiteStagesListQuery, SiteStagesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiteStagesListQuery, SiteStagesListQueryVariables>(SiteStagesListDocument, options);
        }
export type SiteStagesListQueryHookResult = ReturnType<typeof useSiteStagesListQuery>;
export type SiteStagesListLazyQueryHookResult = ReturnType<typeof useSiteStagesListLazyQuery>;
export type SiteStagesListSuspenseQueryHookResult = ReturnType<typeof useSiteStagesListSuspenseQuery>;
export type SiteStagesListQueryResult = Apollo.QueryResult<SiteStagesListQuery, SiteStagesListQueryVariables>;
export const SitesSharedWithUserDocument = gql`
    query sitesSharedWithUser {
  sitesSharedWithUser {
    _id
    title
    geometry {
      type
      coordinates
    }
    location {
      type
      coordinates
    }
    sharedByUser {
      _id
      firstname
      surname
      date
    }
  }
}
    `;

/**
 * __useSitesSharedWithUserQuery__
 *
 * To run a query within a React component, call `useSitesSharedWithUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesSharedWithUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesSharedWithUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useSitesSharedWithUserQuery(baseOptions?: Apollo.QueryHookOptions<SitesSharedWithUserQuery, SitesSharedWithUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitesSharedWithUserQuery, SitesSharedWithUserQueryVariables>(SitesSharedWithUserDocument, options);
      }
export function useSitesSharedWithUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitesSharedWithUserQuery, SitesSharedWithUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitesSharedWithUserQuery, SitesSharedWithUserQueryVariables>(SitesSharedWithUserDocument, options);
        }
export function useSitesSharedWithUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SitesSharedWithUserQuery, SitesSharedWithUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SitesSharedWithUserQuery, SitesSharedWithUserQueryVariables>(SitesSharedWithUserDocument, options);
        }
export type SitesSharedWithUserQueryHookResult = ReturnType<typeof useSitesSharedWithUserQuery>;
export type SitesSharedWithUserLazyQueryHookResult = ReturnType<typeof useSitesSharedWithUserLazyQuery>;
export type SitesSharedWithUserSuspenseQueryHookResult = ReturnType<typeof useSitesSharedWithUserSuspenseQuery>;
export type SitesSharedWithUserQueryResult = Apollo.QueryResult<SitesSharedWithUserQuery, SitesSharedWithUserQueryVariables>;
export const LetterCreditsDocument = gql`
    query LetterCredits {
  accountWithViews: account {
    included_letter_send {
      cap
      used
    }
  }
}
    `;

/**
 * __useLetterCreditsQuery__
 *
 * To run a query within a React component, call `useLetterCreditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLetterCreditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLetterCreditsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLetterCreditsQuery(baseOptions?: Apollo.QueryHookOptions<LetterCreditsQuery, LetterCreditsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LetterCreditsQuery, LetterCreditsQueryVariables>(LetterCreditsDocument, options);
      }
export function useLetterCreditsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LetterCreditsQuery, LetterCreditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LetterCreditsQuery, LetterCreditsQueryVariables>(LetterCreditsDocument, options);
        }
export function useLetterCreditsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LetterCreditsQuery, LetterCreditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LetterCreditsQuery, LetterCreditsQueryVariables>(LetterCreditsDocument, options);
        }
export type LetterCreditsQueryHookResult = ReturnType<typeof useLetterCreditsQuery>;
export type LetterCreditsLazyQueryHookResult = ReturnType<typeof useLetterCreditsLazyQuery>;
export type LetterCreditsSuspenseQueryHookResult = ReturnType<typeof useLetterCreditsSuspenseQuery>;
export type LetterCreditsQueryResult = Apollo.QueryResult<LetterCreditsQuery, LetterCreditsQueryVariables>;
export const SitesUploaderCreateSitesDocument = gql`
    mutation SitesUploaderCreateSites($sites: [CreateSiteInput!], $stageId: ID) {
  createSites(sites: $sites, stageId: $stageId) {
    id
    saved_site {
      _id
    }
    status
  }
}
    `;
export type SitesUploaderCreateSitesMutationFn = Apollo.MutationFunction<SitesUploaderCreateSitesMutation, SitesUploaderCreateSitesMutationVariables>;

/**
 * __useSitesUploaderCreateSitesMutation__
 *
 * To run a mutation, you first call `useSitesUploaderCreateSitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSitesUploaderCreateSitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sitesUploaderCreateSitesMutation, { data, loading, error }] = useSitesUploaderCreateSitesMutation({
 *   variables: {
 *      sites: // value for 'sites'
 *      stageId: // value for 'stageId'
 *   },
 * });
 */
export function useSitesUploaderCreateSitesMutation(baseOptions?: Apollo.MutationHookOptions<SitesUploaderCreateSitesMutation, SitesUploaderCreateSitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SitesUploaderCreateSitesMutation, SitesUploaderCreateSitesMutationVariables>(SitesUploaderCreateSitesDocument, options);
      }
export type SitesUploaderCreateSitesMutationHookResult = ReturnType<typeof useSitesUploaderCreateSitesMutation>;
export type SitesUploaderCreateSitesMutationResult = Apollo.MutationResult<SitesUploaderCreateSitesMutation>;
export type SitesUploaderCreateSitesMutationOptions = Apollo.BaseMutationOptions<SitesUploaderCreateSitesMutation, SitesUploaderCreateSitesMutationVariables>;
export const SitesListArchiveSitesDocument = gql`
    mutation SitesListArchiveSites($search: SiteSearchInput, $selection: SelectionInput, $includeHidden: Boolean, $siteSort: SiteSorting, $limit: Int) {
  archiveSites(
    search: $search
    selection: $selection
    includeHidden: $includeHidden
    siteSort: $siteSort
    limit: $limit
  ) {
    archived_items {
      _id
    }
  }
}
    `;
export type SitesListArchiveSitesMutationFn = Apollo.MutationFunction<SitesListArchiveSitesMutation, SitesListArchiveSitesMutationVariables>;

/**
 * __useSitesListArchiveSitesMutation__
 *
 * To run a mutation, you first call `useSitesListArchiveSitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSitesListArchiveSitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sitesListArchiveSitesMutation, { data, loading, error }] = useSitesListArchiveSitesMutation({
 *   variables: {
 *      search: // value for 'search'
 *      selection: // value for 'selection'
 *      includeHidden: // value for 'includeHidden'
 *      siteSort: // value for 'siteSort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSitesListArchiveSitesMutation(baseOptions?: Apollo.MutationHookOptions<SitesListArchiveSitesMutation, SitesListArchiveSitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SitesListArchiveSitesMutation, SitesListArchiveSitesMutationVariables>(SitesListArchiveSitesDocument, options);
      }
export type SitesListArchiveSitesMutationHookResult = ReturnType<typeof useSitesListArchiveSitesMutation>;
export type SitesListArchiveSitesMutationResult = Apollo.MutationResult<SitesListArchiveSitesMutation>;
export type SitesListArchiveSitesMutationOptions = Apollo.BaseMutationOptions<SitesListArchiveSitesMutation, SitesListArchiveSitesMutationVariables>;
export const SitesListSitesDocument = gql`
    query SitesListSites($assignees: [ID], $includeHidden: Boolean, $first: Int, $after: String, $localAuthorities: [String], $searchString: String, $siteIds: [ID], $siteLabels: [ID], $siteSort: SiteSorting, $stageIds: [ID], $projectId: String) {
  sites(
    after: $after
    assignees: $assignees
    first: $first
    includeHidden: $includeHidden
    localAuthorities: $localAuthorities
    searchString: $searchString
    siteIds: $siteIds
    siteLabels: $siteLabels
    siteSort: $siteSort
    stageIds: $stageIds
    projectId: $projectId
  ) {
    totalCount
    edges {
      _id
      node {
        _id
        title
        notes
        site_labels {
          _id
          name
        }
        hidden
        created
        priority
        _stage {
          _id
          color
          name
          _workspace {
            id
            title
            developmentType
          }
        }
      }
      cursor
      nextCursor
      previousCursor
    }
    pageInfo {
      endCursor
      startCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useSitesListSitesQuery__
 *
 * To run a query within a React component, call `useSitesListSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesListSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesListSitesQuery({
 *   variables: {
 *      assignees: // value for 'assignees'
 *      includeHidden: // value for 'includeHidden'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      localAuthorities: // value for 'localAuthorities'
 *      searchString: // value for 'searchString'
 *      siteIds: // value for 'siteIds'
 *      siteLabels: // value for 'siteLabels'
 *      siteSort: // value for 'siteSort'
 *      stageIds: // value for 'stageIds'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSitesListSitesQuery(baseOptions?: Apollo.QueryHookOptions<SitesListSitesQuery, SitesListSitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitesListSitesQuery, SitesListSitesQueryVariables>(SitesListSitesDocument, options);
      }
export function useSitesListSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitesListSitesQuery, SitesListSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitesListSitesQuery, SitesListSitesQueryVariables>(SitesListSitesDocument, options);
        }
export function useSitesListSitesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SitesListSitesQuery, SitesListSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SitesListSitesQuery, SitesListSitesQueryVariables>(SitesListSitesDocument, options);
        }
export type SitesListSitesQueryHookResult = ReturnType<typeof useSitesListSitesQuery>;
export type SitesListSitesLazyQueryHookResult = ReturnType<typeof useSitesListSitesLazyQuery>;
export type SitesListSitesSuspenseQueryHookResult = ReturnType<typeof useSitesListSitesSuspenseQuery>;
export type SitesListSitesQueryResult = Apollo.QueryResult<SitesListSitesQuery, SitesListSitesQueryVariables>;
export const SitesListStagesDocument = gql`
    query SitesListStages($includeHidden: Boolean, $projectId: String) {
  siteStagesPaginated(includeHidden: $includeHidden, projectId: $projectId) {
    totalCount
    edges {
      node {
        _id
        name
        color
        position_in_pipeline
      }
    }
    pageInfo {
      hasNextPage
      endCursor
      startCursor
    }
  }
}
    `;

/**
 * __useSitesListStagesQuery__
 *
 * To run a query within a React component, call `useSitesListStagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesListStagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesListStagesQuery({
 *   variables: {
 *      includeHidden: // value for 'includeHidden'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSitesListStagesQuery(baseOptions?: Apollo.QueryHookOptions<SitesListStagesQuery, SitesListStagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitesListStagesQuery, SitesListStagesQueryVariables>(SitesListStagesDocument, options);
      }
export function useSitesListStagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitesListStagesQuery, SitesListStagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitesListStagesQuery, SitesListStagesQueryVariables>(SitesListStagesDocument, options);
        }
export function useSitesListStagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SitesListStagesQuery, SitesListStagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SitesListStagesQuery, SitesListStagesQueryVariables>(SitesListStagesDocument, options);
        }
export type SitesListStagesQueryHookResult = ReturnType<typeof useSitesListStagesQuery>;
export type SitesListStagesLazyQueryHookResult = ReturnType<typeof useSitesListStagesLazyQuery>;
export type SitesListStagesSuspenseQueryHookResult = ReturnType<typeof useSitesListStagesSuspenseQuery>;
export type SitesListStagesQueryResult = Apollo.QueryResult<SitesListStagesQuery, SitesListStagesQueryVariables>;
export const SitesListTotalSiteCountDocument = gql`
    query SitesListTotalSiteCount($projectId: String) {
  totalSiteCount(projectId: $projectId)
}
    `;

/**
 * __useSitesListTotalSiteCountQuery__
 *
 * To run a query within a React component, call `useSitesListTotalSiteCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesListTotalSiteCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesListTotalSiteCountQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSitesListTotalSiteCountQuery(baseOptions?: Apollo.QueryHookOptions<SitesListTotalSiteCountQuery, SitesListTotalSiteCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitesListTotalSiteCountQuery, SitesListTotalSiteCountQueryVariables>(SitesListTotalSiteCountDocument, options);
      }
export function useSitesListTotalSiteCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitesListTotalSiteCountQuery, SitesListTotalSiteCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitesListTotalSiteCountQuery, SitesListTotalSiteCountQueryVariables>(SitesListTotalSiteCountDocument, options);
        }
export function useSitesListTotalSiteCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SitesListTotalSiteCountQuery, SitesListTotalSiteCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SitesListTotalSiteCountQuery, SitesListTotalSiteCountQueryVariables>(SitesListTotalSiteCountDocument, options);
        }
export type SitesListTotalSiteCountQueryHookResult = ReturnType<typeof useSitesListTotalSiteCountQuery>;
export type SitesListTotalSiteCountLazyQueryHookResult = ReturnType<typeof useSitesListTotalSiteCountLazyQuery>;
export type SitesListTotalSiteCountSuspenseQueryHookResult = ReturnType<typeof useSitesListTotalSiteCountSuspenseQuery>;
export type SitesListTotalSiteCountQueryResult = Apollo.QueryResult<SitesListTotalSiteCountQuery, SitesListTotalSiteCountQueryVariables>;
export const SitesListUpdateSitesDocument = gql`
    mutation SitesListUpdateSites($search: SiteSearchInput, $selection: SelectionInput, $siteUpdate: SiteUpdate!, $includeHidden: Boolean, $siteSort: SiteSorting, $limit: Int) {
  updateSelectedSites(
    search: $search
    selection: $selection
    updateData: $siteUpdate
    includeHidden: $includeHidden
    siteSort: $siteSort
    limit: $limit
  ) {
    site {
      _id
      title
      notes
      site_labels {
        _id
        name
      }
      hidden
      position_in_stage
      created
      priority
      assignees
      _stage {
        _id
      }
    }
  }
}
    `;
export type SitesListUpdateSitesMutationFn = Apollo.MutationFunction<SitesListUpdateSitesMutation, SitesListUpdateSitesMutationVariables>;

/**
 * __useSitesListUpdateSitesMutation__
 *
 * To run a mutation, you first call `useSitesListUpdateSitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSitesListUpdateSitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sitesListUpdateSitesMutation, { data, loading, error }] = useSitesListUpdateSitesMutation({
 *   variables: {
 *      search: // value for 'search'
 *      selection: // value for 'selection'
 *      siteUpdate: // value for 'siteUpdate'
 *      includeHidden: // value for 'includeHidden'
 *      siteSort: // value for 'siteSort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSitesListUpdateSitesMutation(baseOptions?: Apollo.MutationHookOptions<SitesListUpdateSitesMutation, SitesListUpdateSitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SitesListUpdateSitesMutation, SitesListUpdateSitesMutationVariables>(SitesListUpdateSitesDocument, options);
      }
export type SitesListUpdateSitesMutationHookResult = ReturnType<typeof useSitesListUpdateSitesMutation>;
export type SitesListUpdateSitesMutationResult = Apollo.MutationResult<SitesListUpdateSitesMutation>;
export type SitesListUpdateSitesMutationOptions = Apollo.BaseMutationOptions<SitesListUpdateSitesMutation, SitesListUpdateSitesMutationVariables>;
export const SkipTracingCreditsDocument = gql`
    query SkipTracingCredits {
  accountWithViews: account {
    skip_traces {
      cap
      used
    }
  }
}
    `;

/**
 * __useSkipTracingCreditsQuery__
 *
 * To run a query within a React component, call `useSkipTracingCreditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkipTracingCreditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkipTracingCreditsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSkipTracingCreditsQuery(baseOptions?: Apollo.QueryHookOptions<SkipTracingCreditsQuery, SkipTracingCreditsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkipTracingCreditsQuery, SkipTracingCreditsQueryVariables>(SkipTracingCreditsDocument, options);
      }
export function useSkipTracingCreditsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkipTracingCreditsQuery, SkipTracingCreditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkipTracingCreditsQuery, SkipTracingCreditsQueryVariables>(SkipTracingCreditsDocument, options);
        }
export function useSkipTracingCreditsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SkipTracingCreditsQuery, SkipTracingCreditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SkipTracingCreditsQuery, SkipTracingCreditsQueryVariables>(SkipTracingCreditsDocument, options);
        }
export type SkipTracingCreditsQueryHookResult = ReturnType<typeof useSkipTracingCreditsQuery>;
export type SkipTracingCreditsLazyQueryHookResult = ReturnType<typeof useSkipTracingCreditsLazyQuery>;
export type SkipTracingCreditsSuspenseQueryHookResult = ReturnType<typeof useSkipTracingCreditsSuspenseQuery>;
export type SkipTracingCreditsQueryResult = Apollo.QueryResult<SkipTracingCreditsQuery, SkipTracingCreditsQueryVariables>;
export const SkipTracingSitesDocument = gql`
    query SkipTracingSites($first: Int, $after: String, $stageIds: [ID]) {
  sites(first: $first, after: $after, stageIds: $stageIds) {
    totalCount
    edges {
      _id
      node {
        _id
        title
        address
        geometry {
          type
          coordinates
        }
        titles {
          id
          title_no
          parcel_identifier
          polygons {
            geometry {
              type
              coordinates
            }
          }
          owners {
            company {
              name
            }
            person {
              name
            }
          }
        }
      }
      cursor
      nextCursor
      previousCursor
    }
    pageInfo {
      endCursor
      startCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useSkipTracingSitesQuery__
 *
 * To run a query within a React component, call `useSkipTracingSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkipTracingSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkipTracingSitesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      stageIds: // value for 'stageIds'
 *   },
 * });
 */
export function useSkipTracingSitesQuery(baseOptions?: Apollo.QueryHookOptions<SkipTracingSitesQuery, SkipTracingSitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkipTracingSitesQuery, SkipTracingSitesQueryVariables>(SkipTracingSitesDocument, options);
      }
export function useSkipTracingSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkipTracingSitesQuery, SkipTracingSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkipTracingSitesQuery, SkipTracingSitesQueryVariables>(SkipTracingSitesDocument, options);
        }
export function useSkipTracingSitesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SkipTracingSitesQuery, SkipTracingSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SkipTracingSitesQuery, SkipTracingSitesQueryVariables>(SkipTracingSitesDocument, options);
        }
export type SkipTracingSitesQueryHookResult = ReturnType<typeof useSkipTracingSitesQuery>;
export type SkipTracingSitesLazyQueryHookResult = ReturnType<typeof useSkipTracingSitesLazyQuery>;
export type SkipTracingSitesSuspenseQueryHookResult = ReturnType<typeof useSkipTracingSitesSuspenseQuery>;
export type SkipTracingSitesQueryResult = Apollo.QueryResult<SkipTracingSitesQuery, SkipTracingSitesQueryVariables>;